import React from "react";
import ReactDOM from 'react-dom';
import http from '../modules/api';

import SelectBoxV2 from '../modules/common/SelectBoxV2';
import SaveDialogV2 from '../modules/dialogs/SaveDialogV2';
import BasicDialogV2 from "../modules/dialogs/BasicDialogV2";
import WarningDialog from "../modules/dialogs/WarningDialog";
import ConfirmDialogV2 from '../modules/dialogs/ConfirmDialogV2';
import TitleContentDialogV2 from '../modules/dialogs/TitleContentDialogV2';
import RoboImgSettingPopup from '../autoEvent/component/RoboImgSettingPopup';
import RoboImageStudioTabs from "../autoEvent/component/RoboImageStudioTabs";
import AiImageStudioWorkflowClass from "../modules/common/AiImageStudioWorkflowClass";
import AiVideoStudioWorkflowClass from "../modules/common/AiVideoStudioWorkflowClass";
import SearchProductPopup from '../modules/popup/SearchProductPopup';
import PopupFrameV2 from '../modules/popup/PopupFrameV2';
import CheckBox from "../modules/common/CheckBox";
import InstagramTemplateEditor from "./InstagramTemplateEditor";
import ModalSizeSelect from "./component/ModalSizeSelect"; 
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'

import RoboMDAICopywriterModal from './component/RoboMDAICopywriterModal';
import InstagramHashtagEditor from './component/InstagramHashtagEditor';
import InstagramAudioSelectModal, { normalizeInstagramAudioAsset } from './component/InstagramAudioSelectModal';

import * as StringUtil from '../modules/utils/StringUtil';

import DatePicker from "react-datepicker";
import { ko } from "date-fns/locale";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

import { Copy } from "lucide-react";


const _ = require('lodash');

const FACEBOOK_APP_ID = '780456611206591';
const BASEDOMAIN = document.domain.indexOf("127.0.0.1") >= 0 ? 'https://127.0.0.1:8092' : window.location.origin;
// Instagram Login 신규 인증 엔드포인트. 로컬 React(3000)와 Spring Boot(8092)는 서로 다른 서버입니다.
// 기존 Facebook OAuth용 BASEDOMAIN 및 REDIRECT_URI는 변경하지 않습니다.
const INSTAGRAM_DIRECT_LOGIN_URL =
  (window.location.hostname === "127.0.0.1" || window.location.hostname === "localhost"
    ? `http://${window.location.hostname}:8092`
    : window.location.origin) + "/rest/shop/instagram/direct/login";
const REDIRECT_URI = BASEDOMAIN + '/rest/shop/instagram/callbackForRefleshParent';
const STARTER_APPLY_TEMPLATE_STORAGE_KEY = "instagram_ai_design_starter_apply_template";
const AI_STUDIO_APPLY_IMAGE_STORAGE_KEY = "instagram_ai_studio_apply_image";
const AI_VIDEO_STUDIO_APPLY_VIDEO_STORAGE_KEY = "instagram_ai_video_studio_apply_video";
const COPYWRITER_SELECTED_CONTENT_STORAGE_KEY = "instagram_copywriter_selected_content";
const COPYWRITER_SELECTED_CONTENT_APPLY_PARAM = "apply_copywriter_content";
const CONTENT_CREATE_TUTORIAL_EVENT = "instagram-tutorial:content-create-action";
const REELS_ITEM_INDEX = 100;
const SCOPES = [
  'pages_show_list',
  'business_management',
  'instagram_basic',
  'instagram_content_publish',
  'instagram_manage_insights',
  'instagram_manage_contents',
  'public_profile'
].join(',');
const FACEBOOK_OAUTH_CHANNEL_NAME = "robomd_instagram_facebook_oauth";
const FACEBOOK_OAUTH_STORAGE_KEY = "robomd_instagram_facebook_oauth_event";
const FACEBOOK_OAUTH_PENDING_KEY = "robomd_instagram_facebook_oauth_pending";
const FACEBOOK_OAUTH_OWNER_KEY = "robomd_instagram_facebook_oauth_owner";
const FACEBOOK_OAUTH_TAB_ID_KEY = "robomd_instagram_facebook_oauth_tab_id";

const createFacebookOAuthId = () => {
  try {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
  } catch (e) {
    // randomUUID를 사용할 수 없는 환경에서는 아래 fallback 사용
  }

  return `${Date.now()}_${Math.random().toString(36).slice(2)}`;
};

const getFacebookOAuthTabId = () => {
  try {
    let tabId = sessionStorage.getItem(FACEBOOK_OAUTH_TAB_ID_KEY);
    if (!tabId) {
      tabId = createFacebookOAuthId();
      sessionStorage.setItem(FACEBOOK_OAUTH_TAB_ID_KEY, tabId);
    }
    return tabId;
  } catch (e) {
    return "";
  }
};

const markFacebookOAuthPending = () => {
  try {
    const tabId = getFacebookOAuthTabId();
    sessionStorage.setItem(FACEBOOK_OAUTH_PENDING_KEY, "Y");
    if (tabId) {
      localStorage.setItem(FACEBOOK_OAUTH_OWNER_KEY, tabId);
    }
  } catch (e) {
    // 저장소 사용이 제한된 환경에서도 OAuth 자체는 계속 진행
  }
};

const consumeFacebookOAuthPending = () => {
  try {
    if (sessionStorage.getItem(FACEBOOK_OAUTH_PENDING_KEY) !== "Y") {
      return false;
    }

    const tabId = getFacebookOAuthTabId();
    const ownerTabId = localStorage.getItem(FACEBOOK_OAUTH_OWNER_KEY);

    // 여러 RoboMD 탭이 열려 있어도 실제 OAuth를 시작한 탭만 처리한다.
    if (ownerTabId && tabId && ownerTabId !== tabId) {
      return false;
    }

    sessionStorage.removeItem(FACEBOOK_OAUTH_PENDING_KEY);
    if (!ownerTabId || ownerTabId === tabId) {
      localStorage.removeItem(FACEBOOK_OAUTH_OWNER_KEY);
    }
    return true;
  } catch (e) {
    // 저장소 접근이 막힌 경우에는 현재 탭에서 한 번 처리하도록 허용
    return true;
  }
};

const publishFacebookOAuthBridgeMessage = (payload) => {
  const message = {
    ...payload,
    bridge_event_id: payload.bridge_event_id || createFacebookOAuthId(),
    bridge_sent_at: Date.now(),
  };

  if (typeof BroadcastChannel !== "undefined") {
    try {
      const channel = new BroadcastChannel(FACEBOOK_OAUTH_CHANNEL_NAME);
      channel.postMessage(message);
      setTimeout(() => channel.close(), 0);
    } catch (e) {
      console.warn("Facebook OAuth BroadcastChannel 전송 실패:", e);
    }
  }

  // BroadcastChannel 미지원/차단 환경을 위한 동일 origin 탭 간 fallback
  try {
    localStorage.setItem(FACEBOOK_OAUTH_STORAGE_KEY, JSON.stringify(message));
    localStorage.removeItem(FACEBOOK_OAUTH_STORAGE_KEY);
  } catch (e) {
    console.warn("Facebook OAuth storage 이벤트 전송 실패:", e);
  }

  return message;
};

const subscribeFacebookOAuthBridge = (handler) => {
  let channel = null;

  if (typeof BroadcastChannel !== "undefined") {
    try {
      channel = new BroadcastChannel(FACEBOOK_OAUTH_CHANNEL_NAME);
      channel.onmessage = (e) => handler(e.data);
    } catch (e) {
      console.warn("Facebook OAuth BroadcastChannel 연결 실패:", e);
    }
  }

  const onStorage = (e) => {
    if (e.key !== FACEBOOK_OAUTH_STORAGE_KEY || !e.newValue) return;

    try {
      handler(JSON.parse(e.newValue));
    } catch (error) {
      console.warn("Facebook OAuth storage 메시지 파싱 실패:", error);
    }
  };

  window.addEventListener("storage", onStorage);

  return () => {
    window.removeEventListener("storage", onStorage);
    if (channel) {
      channel.close();
    }
  };
};


const isMobileFacebookOAuth = () => {
  try {
    const userAgent = navigator.userAgent || "";
    const isMobileUserAgent = /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent);
    const isIPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    return isMobileUserAgent || isIPadOS;
  } catch (e) {
    return false;
  }
};

/**
 * 기존 새 탭 OAuth 흐름을 유지하면서 GET form submit으로 Facebook OAuth를 시작한다.
 * callbackForRefleshParent에서 기존 부모 창 갱신/팝업 처리 후 새 탭이 닫히는 흐름을 그대로 사용한다.
 */
// 사전 확인 결과가 없다면 기존 Facebook OAuth 코드를 동기적으로 실행한다.
// Facebook 로그인은 기존 폼 제출의 사용자 제스처와 팝업 동작을 그대로 유지한다.
let instagramDirectGateStatus = null;
http.get("/rest/shop/instagram/direct/status")
  .then(({data}) => {instagramDirectGateStatus = data || null;})
  .catch(() => {instagramDirectGateStatus = null;});

const submitFacebookOAuthForm = ({ redirectUri } = {}) => {
  // 테스트 사용자이며 기존 Facebook 연동이 없는 경우만 Instagram Login으로 이동.
  if (instagramDirectGateStatus?.instagram_login_allowed &&
      instagramDirectGateStatus?.instagram_login_configured &&
      !instagramDirectGateStatus?.has_facebook_connection) {
    // Direct Instagram 인증도 기존 Facebook OAuth처럼 새 탭에서 수행한다.
    // opener를 유지해야 callback에서 원래 Post/자동화 화면에 결과를 전달할 수 있다.
    return { provider: "INSTAGRAM", popup: window.open(INSTAGRAM_DIRECT_LOGIN_URL, "_blank") };
  }

  const form = document.createElement("form");
  form.method = "GET";
  form.action = "https://www.facebook.com/v24.0/dialog/oauth";
  form.target = "_blank";
  form.style.display = "none";

  const oauthParams = {
    client_id: FACEBOOK_APP_ID,
    redirect_uri: redirectUri,
    scope: SCOPES,
    response_type: "code",
  };

  // 모바일에서는 reauthenticate가 Facebook 앱 전환을 유발할 수 있어 제외한다.
  // PC에서는 기존 동작대로 재로그인을 유도한다.
  if (!isMobileFacebookOAuth()) {
    oauthParams.auth_type = "reauthenticate";
  }

  Object.entries(oauthParams).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  markFacebookOAuthPending();

  document.body.appendChild(form);
  form.submit();
  setTimeout(() => form.remove(), 0);
};


const THREADS_OAUTH_CHANNEL_NAME = "robomd_threads_oauth";
const THREADS_OAUTH_STORAGE_KEY = "robomd_threads_oauth_event";

const THREADS_OAUTH_MOBILE_PENDING_KEY = "robomd_threads_oauth_mobile_pending";
const THREADS_OAUTH_MOBILE_GUIDE_DELAY_MS = 7000;

const isMobileThreadsOAuth = () => {
  try {
    const userAgent = navigator.userAgent || "";
    const isMobileUserAgent = /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent);
    const isIPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    return isMobileUserAgent || isIPadOS;
  } catch (e) {
    return false;
  }
};

const getThreadsMobileOS = () => {
  try {
    const userAgent = navigator.userAgent || "";
    const isIPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    if (/Android/i.test(userAgent)) return "android";
    if (/iPhone|iPad|iPod/i.test(userAgent) || isIPadOS) return "ios";
  } catch (e) {
    // OS 판별 실패 시 공통 모바일 안내를 사용한다.
  }
  return "mobile";
};

const saveThreadsMobileOAuthPending = (startedAt = Date.now()) => {
  try {
    sessionStorage.setItem(
      THREADS_OAUTH_MOBILE_PENDING_KEY,
      JSON.stringify({ startedAt, path: window.location.pathname || "" })
    );
  } catch (e) {
    // 저장소 사용이 제한되어도 OAuth 자체는 계속 진행한다.
  }
};

const readThreadsMobileOAuthPending = () => {
  try {
    const raw = sessionStorage.getItem(THREADS_OAUTH_MOBILE_PENDING_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch (e) {
    return null;
  }
};

const clearThreadsMobileOAuthPending = () => {
  try {
    sessionStorage.removeItem(THREADS_OAUTH_MOBILE_PENDING_KEY);
  } catch (e) {
    // 저장소 정리 실패는 무시한다.
  }
};


const subscribeThreadsOAuthBridge = (handler) => {
  let channel = null;

  if (typeof BroadcastChannel !== "undefined") {
    try {
      channel = new BroadcastChannel(THREADS_OAUTH_CHANNEL_NAME);
      channel.onmessage = (e) => handler(e.data);
    } catch (e) {
      console.warn("Threads OAuth BroadcastChannel 연결 실패:", e);
    }
  }

  const onStorage = (e) => {
    if (e.key !== THREADS_OAUTH_STORAGE_KEY || !e.newValue) return;

    try {
      handler(JSON.parse(e.newValue));
    } catch (error) {
      console.warn("Threads OAuth storage 메시지 파싱 실패:", error);
    }
  };

  window.addEventListener("storage", onStorage);

  return () => {
    window.removeEventListener("storage", onStorage);
    if (channel) channel.close();
  };
};

const getTemplateUpperCodeCdByEventTypeCd = (eventTypeCd) => {
  if (String(eventTypeCd || "").startsWith("07")) return "07000";
  if (String(eventTypeCd || "").startsWith("03")) return "03000";
  return "";
};

const getTemplateRatioByEventTypeCd = (eventTypeCd) => {
  if (String(eventTypeCd || "").startsWith("07")) return "4/5";
  if (String(eventTypeCd || "").startsWith("03")) return "16/9";
  return "1/1";
};

const normalizeImageRatio = (ratio) => {
  const value = String(ratio || "").trim();

  if (!value || value === "미선택") {
    return "";
  }

  return value.replace(/\s*:\s*/g, "/").replace(/\s*\/\s*/g, "/");
};


const createDefaultReelsAudioState = () => ({
  mode: "NONE",
  audioId: "",
  audioType: "",
  title: "",
  artist: "",
  durationMs: null,
  previewUrl: "",
  platformPreviewUrl: "",
  audioVolume: 100,
  videoVolume: 100,
  audioName: "",
  meta: null,
  mediaAudioType: "",
});

const clampInstagramAudioVolume = (value, fallback = 100) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.max(0, Math.min(100, Math.round(n)));
};

const getInstagramPlatformPreviewUrl = (audioState) => {
  const audio = audioState || {};
  const meta = audio.meta && typeof audio.meta === "object" ? audio.meta : {};
  return String(
    audio.platformPreviewUrl
    || meta.on_platform_audio_preview_link
    || meta.onPlatformAudioPreviewLink
    || meta.platform_preview_url
    || meta.platformPreviewUrl
    || ""
  ).trim();
};

export default class InstagramCreatePost_v3 extends React.Component {
  constructor(props) {
    super(props);
    this.captionTextareaRef = React.createRef();
    this.fileInputRef = React.createRef();
    this.scrollAreaRef = React.createRef();
    this.pickerRef = React.createRef();
    this.triggerRef = React.createRef();
    this.reelsPreviewVideoRef = React.createRef();
    this.reelsPreviewAudioRef = React.createRef();
    // 릴스 음악/영상 음소거 해제 시 직전 볼륨으로 복원하기 위한 메모리
    this.reelsAudioVolumeBeforeMute = 100;
    this.reelsVideoVolumeBeforeMute = 100;
    this.isComposing = false;
    this.copywriterSelectionSaveTimer = null;
    this.instagramTutorialSnapshot = null;
    this.instagramTutorialOpenedAiStudio = false;
    this.instagramTutorialOpenedAiVideoStudio = false;

    this.threadsOAuthWindow = null;
    this.threadsOAuthPollTimer = null;
    this.threadsOAuthPending = false;
    this.threadsOAuthStartedAt = 0;
    this.threadsOAuthMobileWasHidden = false;
    this.threadsOAuthMobileGuideShown = false;
    this.threadsOAuthMobileGuideTimer = null;

    this.state = {
      // 스크롤 스파이 상태
      activeSection: 'sec-image',

      // [NEW] HTML 추가 요소 상태 관리
      quickPhrases: [
        // { title: '📩 문의안내', content: '\n📩 문의는 언제든 DM 주세요!' }
      ],
      fixedTags: [
        // {favorite_tag_seq: '-1',tag_name: '#로보MD'}, {favorite_tag_seq: '-2',tag_name: '#의료AI'}
      ],
      modals: {
        copywriterRun: false,
        captionSettings: false,
        hashtagSettings: false,
        phrase: false,
        addTag: false
      },
      phraseTitleInput: "",
      phraseContentInput: "",
      newFixedTagInput: "",

      // 기존 상태값들
      isSizeModalOpen: false,
      add_account_list: [],
      selected_account_list : [],
      currentStep: 1, 
      accountConnected: false,
      selectedAccount: {},

      // v4: 발행 플랫폼 / Threads 계정
      instagramPublishEnabled: true,
      threadsPublishEnabled: false,
      threadsAccountConnected: false,
      threads_account_list_v2: [],
      selected_threads_access_seq: "",
      selectedThreadsAccount: null,
      add_threads_account_list: [],
      selected_threads_account_list: [],
      show_threads_account_connect_popup: false,
      show_threads_mobile_oauth_guide: false,
      threads_mobile_oauth_os: "",
      threads_oauth_manual_url: "",
      threads_oauth_manual_url_loading: false,
      threads_oauth_manual_copy_message: "",

      selectedFeedType: "SINGLE",
      imageSlots: [{ type: null, data: null }],
      // 피드/릴스 탭 전환 시 서로의 작업 데이터를 잃지 않도록 탭별 미디어를 임시 보관한다.
      // 실제 저장/발행 payload는 기존처럼 현재 imageSlots만 사용한다.
      feedImageSlots: [{ type: null, data: null }],
      reelsVideoSlots: [{ type: null, data: null }],
      feedRatio: "1/1",
      reelsRatio: "9/16",
      reelsAudioModalOpen: false,
      reelsAudio: createDefaultReelsAudioState(),
      imageModalOpen: false,
      videoSourceModalOpen: false,
      show_ai_video_popup: false,
      ai_video_studio_initial_prompt: "",
      ai_video_studio_initial_image_url: "",
      ai_video_studio_initial_history_seq: "",
      ai_video_studio_initial_result_seq: "",
      ai_video_studio_initial_result_no: "",
      currentImageSlotIndex: 0,
      caption_history: [],
      caption_future: [],
      caption: "",
      topicInput: "",
      selectedAiRecommendationIndexes: [],
      selectedCopywriterPreset: null,
      copywriter_preset_seq: null,
      isCopywriterDefaultInitialized: false,
      isAiCaptionGenerating: false,
      aiSuggestionsVisible: false,
      copywriterHistorySeq: null,
      selectedCopywriterHistorySeq: null,
      copywriterHistoryItems: [],
      copywriterHistoryLoading: false,
      copywriterHistoryDetailLoading: false,
      inputHashtagValue: "",
      tags: [],
      previewSlideIndex: 0,
      publishOption: "NOW",
      scheduledDate: "",
      scheduledTime: "00:00",
      save_dialog_show_state: false,
      save_dialog_content: "로딩중 입니다.",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn:"N" }],
      confirm_dialog_show_state : false,
      confirm_dialog_content : "",
      confirm_dialog_button_list : [],
      basic_dialog_show_state: false,
      basic_dialog_content: "",
      basic_dialog_button_list: [{title:"확인", event_method:()=>{this.setState({basic_dialog_show_state:false})}}],
      warning_dialog_show_state: false,
      warning_dialog_content: "",
      warning_dialog_button_list: [{title:"확인", event_method:()=>{this.setState({warning_dialog_show_state:false})}}],
      emojiPickerVisible: false,
      selected_event_seq: "",

      hashtag_setting_count: 5,
      caption_setting_count: 3,
      is_auto_hashtag_on: false,

      hideAccountBanner: false,

      selectedStyleConfig: {},

      title_content_dialog_title: "",
      title_content_dialog_content: "",
      title_content_dialog_button_list: [{title:"확인", event_method:()=>{this.setState({title_content_dialog_show_state:false})}}],
      title_content_dialog_show_state: false,

      ai_studio_initial_prompt: "",
      ai_studio_initial_image_url: "",
      ai_studio_initial_history_seq: "",
      ai_studio_initial_history_step_seq: "",
      ai_studio_initial_result_seq: "",
      ai_studio_initial_result_no: "",
      ai_studio_initial_result_image_url: "",

      selected_template_event_type_cd: "",
      selected_template_upper_code_cd: "",

      // show_account_connect_popup: true,
    };
  }

  handleFacebookOAuthReturn = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const oauthStatus = searchParams.get("facebook_oauth_status");

    if (!oauthStatus) return false;

    const tokenId = searchParams.get("facebook_oauth_token_id") || "";

    try {
      const url = new URL(window.location.href);
      url.searchParams.delete("facebook_oauth_status");
      url.searchParams.delete("facebook_oauth_token_id");
      window.history.replaceState({}, "", `${url.pathname}${url.search}${url.hash}`);
    } catch (e) {
      // URL 정리 실패는 계정 연동 처리와 무관하므로 무시한다.
    }

    if (oauthStatus === "success" && tokenId) {
      this.setState(
        {
          token_id: tokenId,
          show_account_connect_popup: true,
        },
        () => this.loadInstagramAccountList(tokenId)
      );
    } else {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "페이스북 로그인 또는 권한 승인이 완료되지 않았습니다.",
      });
    }

    return true;
  };

  captureInstagramTutorialSnapshot = () => {
    if (this.instagramTutorialSnapshot) return;

    this.instagramTutorialSnapshot = {
      publishOption: this.state.publishOption,
      instagramPublishEnabled: this.state.instagramPublishEnabled,
      threadsPublishEnabled: this.state.threadsPublishEnabled,
      selected_threads_access_seq: this.state.selected_threads_access_seq,
      scheduledDate: this.state.scheduledDate,
      scheduledTime: this.state.scheduledTime,
      selectedFeedType: this.state.selectedFeedType,
      imageSlots: (this.state.imageSlots || []).map((slot) => ({ ...slot })),
      feedImageSlots: (this.state.feedImageSlots || []).map((slot) => ({ ...slot })),
      reelsVideoSlots: (this.state.reelsVideoSlots || []).map((slot) => ({ ...slot })),
      feedRatio: this.state.feedRatio,
      reelsRatio: this.state.reelsRatio,
      currentRatio: this.state.currentRatio,
      previewSlideIndex: this.state.previewSlideIndex,
      currentImageSlotIndex: this.state.currentImageSlotIndex,
      imageModalOpen: this.state.imageModalOpen,
      videoSourceModalOpen: this.state.videoSourceModalOpen,
      isSizeModalOpen: this.state.isSizeModalOpen,
      show_robo_img_popup: this.state.show_robo_img_popup,
      show_ai_video_popup: this.state.show_ai_video_popup,
      show_add_product_popup: this.state.show_add_product_popup,
      show_design_template_popup: this.state.show_design_template_popup,
      reelsAudioModalOpen: this.state.reelsAudioModalOpen,
      reelsAudio: { ...(this.state.reelsAudio || createDefaultReelsAudioState()) },
      modals: { ...(this.state.modals || {}) },
    };
  };

  closeInstagramTutorialPopups = () => ({
    imageModalOpen: false,
    videoSourceModalOpen: false,
    isSizeModalOpen: false,
    reelsAudioModalOpen: false,
    modals: { ...(this.state.modals || {}), copywriterRun: false },
  });

  handleInstagramTutorialAction = (event) => {
    const action = event && event.detail ? event.detail.action : "";
    if (!action) return;

    if (action === "RESTORE") {
      if (!this.instagramTutorialSnapshot) return;
      const snapshot = this.instagramTutorialSnapshot;
      this.instagramTutorialSnapshot = null;
      this.instagramTutorialOpenedAiStudio = false;
      this.instagramTutorialOpenedAiVideoStudio = false;
      this.setState(snapshot);
      return;
    }

    this.captureInstagramTutorialSnapshot();

    if (action === "SNAPSHOT") return;

    if (action === "SHOW_SCHEDULE") {
      this.setState({
        ...this.closeInstagramTutorialPopups(),
        publishOption: "SCHEDULED",
      });
      return;
    }

    if (action === "SHOW_REELS" || action === "SHOW_REELS_SOURCE") {
      const closeAiStudio = this.instagramTutorialOpenedAiStudio;
      const closeAiVideoStudio = this.instagramTutorialOpenedAiVideoStudio;
      this.instagramTutorialOpenedAiStudio = false;
      this.instagramTutorialOpenedAiVideoStudio = false;
      this.setState({
        ...this.closeInstagramTutorialPopups(),
        selectedFeedType: "REELS",
        imageSlots: [{ type: null, data: null }],
        currentRatio: "9/16",
        previewSlideIndex: 0,
        currentImageSlotIndex: 0,
        videoSourceModalOpen: action === "SHOW_REELS_SOURCE",
        ...(closeAiStudio ? { show_robo_img_popup: false } : {}),
        ...(closeAiVideoStudio ? { show_ai_video_popup: false } : {}),
      });
      return;
    }

    if (["SHOW_REELS_AUDIO", "SHOW_REELS_AUDIO_MODAL", "SHOW_REELS_AUDIO_SELECTED"].includes(action)) {
      const closeAiStudio = this.instagramTutorialOpenedAiStudio;
      const closeAiVideoStudio = this.instagramTutorialOpenedAiVideoStudio;
      this.instagramTutorialOpenedAiStudio = false;
      this.instagramTutorialOpenedAiVideoStudio = false;

      const tutorialAudio = action === "SHOW_REELS_AUDIO_SELECTED"
        ? {
            ...createDefaultReelsAudioState(),
            mode: "MUSIC",
            audioId: "__tutorial_audio__",
            audioType: "MUSIC",
            title: "선택한 음악 예시",
            artist: "Instagram 음악",
            durationMs: 30000,
            audioVolume: 70,
            videoVolume: 100,
          }
        : createDefaultReelsAudioState();

      this.setState({
        ...this.closeInstagramTutorialPopups(),
        selectedFeedType: "REELS",
        imageSlots: [{ type: null, data: null }],
        currentRatio: "9/16",
        previewSlideIndex: 0,
        currentImageSlotIndex: 0,
        reelsAudio: tutorialAudio,
        reelsAudioModalOpen: action === "SHOW_REELS_AUDIO_MODAL",
        ...(closeAiStudio ? { show_robo_img_popup: false } : {}),
        ...(closeAiVideoStudio ? { show_ai_video_popup: false } : {}),
      });
      return;
    }

    if (["SHOW_FEED", "SHOW_FEED_SIZE", "SHOW_FEED_SOURCE"].includes(action)) {
      const closeAiStudio = this.instagramTutorialOpenedAiStudio;
      const closeAiVideoStudio = this.instagramTutorialOpenedAiVideoStudio;
      this.instagramTutorialOpenedAiStudio = false;
      this.instagramTutorialOpenedAiVideoStudio = false;
      this.setState({
        ...this.closeInstagramTutorialPopups(),
        selectedFeedType: "SINGLE",
        imageSlots: [{ type: null, data: null }],
        currentRatio: "1/1",
        previewSlideIndex: 0,
        currentImageSlotIndex: 0,
        isSizeModalOpen: action === "SHOW_FEED_SIZE",
        imageModalOpen: action === "SHOW_FEED_SOURCE",
        ...(closeAiStudio ? { show_robo_img_popup: false } : {}),
        ...(closeAiVideoStudio ? { show_ai_video_popup: false } : {}),
      });
      return;
    }

    if (action === "SHOW_AI_STUDIO") {
      const closeAiVideoStudio = this.instagramTutorialOpenedAiVideoStudio;
      this.instagramTutorialOpenedAiStudio = true;
      this.instagramTutorialOpenedAiVideoStudio = false;
      this.setState({
        ...this.closeInstagramTutorialPopups(),
        selectedFeedType: "SINGLE",
        imageSlots: [{ type: null, data: null }],
        currentRatio: "1/1",
        previewSlideIndex: 0,
        currentImageSlotIndex: 0,
        show_robo_img_popup: true,
        ...(closeAiVideoStudio ? { show_ai_video_popup: false } : {}),
      });
      return;
    }

    if (action === "SHOW_AI_VIDEO_STUDIO") {
      const closeAiStudio = this.instagramTutorialOpenedAiStudio;
      this.instagramTutorialOpenedAiStudio = false;
      this.instagramTutorialOpenedAiVideoStudio = true;
      this.setState({
        ...this.closeInstagramTutorialPopups(),
        selectedFeedType: "REELS",
        imageSlots: [{ type: null, data: null }],
        currentRatio: "9/16",
        previewSlideIndex: 0,
        currentImageSlotIndex: 0,
        ...(closeAiStudio ? { show_robo_img_popup: false } : {}),
        show_ai_video_popup: true,
      });
      return;
    }

    if (action === "SHOW_COPYWRITER") {
      this.setState({
        ...this.closeInstagramTutorialPopups(),
        modals: { ...(this.state.modals || {}), copywriterRun: true },
      });
      return;
    }

    if (action === "CLOSE_POPUPS") {
      const closeAiStudio = this.instagramTutorialOpenedAiStudio;
      const closeAiVideoStudio = this.instagramTutorialOpenedAiVideoStudio;
      this.instagramTutorialOpenedAiStudio = false;
      this.instagramTutorialOpenedAiVideoStudio = false;
      this.setState({
        ...this.closeInstagramTutorialPopups(),
        ...(closeAiStudio ? { show_robo_img_popup: false } : {}),
        ...(closeAiVideoStudio ? { show_ai_video_popup: false } : {}),
      });
    }
  };

  componentDidMount() {
    window.addEventListener(CONTENT_CREATE_TUTORIAL_EVENT, this.handleInstagramTutorialAction);
    this.instagramFreePreriod();
    this.loadNewFixedTagList();
    this.loadQuickPhrases();
    const generationCountPromise = this.loadGenerationCount();
    const mediaId = StringUtil.getUrlParams('media_id');
    this.setState({ media_id: mediaId });

    generationCountPromise.then(() => {
      this.applyCopywriterContentFromSession(mediaId);
    });

    const handledFacebookOAuthReturn = this.handleFacebookOAuthReturn();
    if (!handledFacebookOAuthReturn) {
      this.loadInstagramAccountList();
    }
    this.loadThreadsAccountList();

    const { scheduledDate, scheduledTime } = this.state;
    if (scheduledDate && scheduledTime) {
      const init = new Date(`${scheduledDate}T${scheduledTime}:00`);
      this.setState({ scheduledAt: init });
    }

    if (mediaId) {
      this.loadInstagramMediaDetail(mediaId);
    }

    const publishOption = StringUtil.getUrlParams('publish_option');
    if (publishOption == "SCHEDULED") {
      this.setState({
        publishOption: "SCHEDULED"
      });
    }

    const tutorialPopup = StringUtil.getUrlParams('tutorial_popup');
    if (tutorialPopup === "POPUP_REELS_AUDIO") {
      this.setState({
        selectedFeedType: "REELS",
        imageSlots: [{ type: null, data: null }],
        currentRatio: "9/16",
        previewSlideIndex: 0,
        currentImageSlotIndex: 0,
        reelsAudioModalOpen: true,
      });
    }

    const openAiStudio = StringUtil.getUrlParams('open_ai_studio');

    if (openAiStudio == "Y") {
      const aiStudioInitialPrompt =
        sessionStorage.getItem("instagram_ai_studio_initial_prompt") || "";

      const aiStudioInitialImageUrl =
        sessionStorage.getItem("instagram_ai_studio_initial_image_url") || "";

      this.setState({
        show_robo_img_popup: true,
        ai_studio_initial_prompt: aiStudioInitialPrompt,
        ai_studio_initial_image_url: aiStudioInitialImageUrl,
        currentImageSlotIndex: 0,
        currentRatio: this.state.currentRatio || "1/1",
      }, () => {
        sessionStorage.removeItem("instagram_ai_studio_initial_prompt");
        sessionStorage.removeItem("instagram_ai_studio_initial_image_url");
      });
    }
    
    const openAiVideoStudio = StringUtil.getUrlParams('open_ai_video_studio');

    if (openAiVideoStudio === "Y") {
      const initialPrompt = sessionStorage.getItem("instagram_ai_video_studio_initial_prompt") || "";
      const initialImageUrl = sessionStorage.getItem("instagram_ai_video_studio_initial_image_url") || "";

      this.setState({
        show_ai_video_popup: true,
        ai_video_studio_initial_prompt: initialPrompt,
        ai_video_studio_initial_image_url: initialImageUrl,
        selectedFeedType: "REELS",
        currentRatio: "9/16",
        currentImageSlotIndex: 0,
      }, () => {
        sessionStorage.removeItem("instagram_ai_video_studio_initial_prompt");
        sessionStorage.removeItem("instagram_ai_video_studio_initial_image_url");
      });
    }

    const openDesignTemplate = StringUtil.getUrlParams('open_design_template');
    const templateEventTypeCd = StringUtil.getUrlParams('event_type_cd') || "";
    const templateRatioParam = StringUtil.getUrlParams('template_ratio') || "";
    const templateRatio =
        templateRatioParam
          ? decodeURIComponent(templateRatioParam)
          : getTemplateRatioByEventTypeCd(templateEventTypeCd);

    
    console.log("openDesignTemplate: ", openDesignTemplate, "templateEventTypeCd: ", templateEventTypeCd, "templateRatio: ", templateRatio);  

    if (openDesignTemplate == "Y" && templateEventTypeCd) {
      this.setState({
        show_design_template_popup: true,
        selected_event_seq: "",

        selected_template_event_type_cd: templateEventTypeCd,
        selected_template_upper_code_cd: getTemplateUpperCodeCdByEventTypeCd(templateEventTypeCd),

        currentRatio: templateRatio,
        currentImageSlotIndex: 0,
      });
    }

    this.applyAiDesignStarterTemplateFromSession(mediaId);
    this.applyAiStudioImageFromSession(mediaId);
    this.applyAiVideoStudioVideoFromSession(mediaId);

    const options = { root: this.scrollAreaRef.current, threshold: 0.3 };
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          this.setState({ activeSection: entry.target.id });
        }
      });
    }, options);

    document.addEventListener('mousedown', this.handleClickOutside);

    this.unsubscribeFacebookOAuthBridge = subscribeFacebookOAuthBridge(this.handleFacebookOAuthBridgeMessage);
    this.unsubscribeThreadsOAuthBridge = subscribeThreadsOAuthBridge(this.handleThreadsOAuthBridgeMessage);
    document.addEventListener("visibilitychange", this.handleThreadsMobileOAuthVisibilityChange);
    window.addEventListener("focus", this.handleThreadsMobileOAuthFocus);
    window.addEventListener("message", this.handleMessage);
    window.addEventListener("message", this.handleInstagramDirectOAuthMessage); 
  }


  applyCopywriterContentFromSession = async (mediaId) => {
    if (mediaId) {
      return;
    }

    const shouldApply = StringUtil.getUrlParams(
      COPYWRITER_SELECTED_CONTENT_APPLY_PARAM
    );

    if (shouldApply !== "Y") {
      return;
    }

    const savedContent =
      sessionStorage.getItem(COPYWRITER_SELECTED_CONTENT_STORAGE_KEY) || "";

    sessionStorage.removeItem(COPYWRITER_SELECTED_CONTENT_STORAGE_KEY);

    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete(COPYWRITER_SELECTED_CONTENT_APPLY_PARAM);
    window.history.replaceState({}, "", currentUrl);

    if (!savedContent.trim()) {
      return;
    }

    let selectedContent = savedContent;
    let copywriterContext = {};

    try {
      const parsedContent = JSON.parse(savedContent);

      if (typeof parsedContent === "string") {
        selectedContent = parsedContent;
      } else if (parsedContent && typeof parsedContent === "object") {
        selectedContent =
          parsedContent.caption ||
          parsedContent.content ||
          parsedContent.selectedText ||
          parsedContent.mergedCaption ||
          "";

        copywriterContext = {
          copywriter_preset_seq:
            parsedContent.copywriter_preset_seq || null,
          copywriter_preset_title:
            parsedContent.copywriter_preset_title || null,
          copywriter_history_seq:
            parsedContent.copywriter_history_seq || null,
        };
      }
    } catch (error) {
      // 이전 버전에서 문자열만 저장한 데이터도 그대로 지원합니다.
      selectedContent = savedContent;
    }

    selectedContent = String(selectedContent || "").trim();

    if (!selectedContent) {
      return;
    }

    await this.handleAiCopywriterResultApply(
      selectedContent,
      [],
      copywriterContext
    );
  };

  applyAiDesignStarterTemplateFromSession = (mediaId) => {
    if (mediaId) {
      return;
    }

    const applyAiDesignTemplate = StringUtil.getUrlParams('apply_ai_design_template');
    const savedPayload = sessionStorage.getItem(STARTER_APPLY_TEMPLATE_STORAGE_KEY);

    if (applyAiDesignTemplate !== "Y" || !savedPayload) {
      return;
    }

    let payload = {};

    try {
      payload = JSON.parse(savedPayload);
    } catch (e) {
      console.error("AI 디자인 적용 데이터 파싱 실패:", e);
      sessionStorage.removeItem(STARTER_APPLY_TEMPLATE_STORAGE_KEY);
      return;
    }

    sessionStorage.removeItem(STARTER_APPLY_TEMPLATE_STORAGE_KEY);

    const imgUrl = payload.img_url || payload.image_url || "";

    if (!imgUrl) {
      return;
    }

    const eventSeq = payload.event_seq || "";
    const mediaSourceId = payload.media_source_id || null;
    const imageRatio = payload.image_ratio || getTemplateRatioByEventTypeCd(payload.event_type_cd || "");

    this.setState({
      imageSlots: [
        {
          type: "template",
          data: imgUrl,
          event_seq: eventSeq,
          image_url: imgUrl,
          media_source_id: mediaSourceId,
        },
        { type: null, data: null },
      ],
      selectedFeedType: "SINGLE",
      currentImageSlotIndex: 0,
      currentRatio: imageRatio || "1/1",
      previewSlideIndex: 0,
      show_design_template_popup: false,
      selected_event_seq: "",
      selected_template_event_type_cd: "",
      selected_template_upper_code_cd: "",
    });
  }

  applyAiStudioImageFromSession = (mediaId) => {
    if (mediaId) {
      return;
    }

    const applyAiStudioImage = StringUtil.getUrlParams('apply_ai_studio_image');
    const savedPayload = sessionStorage.getItem(AI_STUDIO_APPLY_IMAGE_STORAGE_KEY);

    if (applyAiStudioImage !== "Y" || !savedPayload) {
      return;
    }

    let payload = {};

    try {
      payload = JSON.parse(savedPayload);
    } catch (e) {
      console.error("AI 스튜디오 이미지 적용 데이터 파싱 실패:", e);
      sessionStorage.removeItem(AI_STUDIO_APPLY_IMAGE_STORAGE_KEY);
      return;
    }

    sessionStorage.removeItem(AI_STUDIO_APPLY_IMAGE_STORAGE_KEY);

    const imgUrl = payload.img_url || payload.image_url || payload.source_url || "";

    if (!imgUrl) {
      return;
    }

    const imageRatio = normalizeImageRatio(payload.image_ratio || payload.ratio) || "1/1";

    this.setState({
      imageSlots: [
        {
          type: "ai",
          data: imgUrl,
          image_url: imgUrl,
          source_url: imgUrl,
          ai_studio_history_seq: payload.ai_studio_history_seq || "",
          selected_final_step_no: payload.selected_final_step_no || "",
          ai_studio_history_step_seq: payload.ai_studio_history_step_seq || "",
          ai_studio_history_step_result_seq: payload.ai_studio_history_step_result_seq || "",
          result_no: payload.result_no || "",
          stability_call_seq: payload.stability_call_seq || null,
        },
        { type: null, data: null },
      ],
      selectedFeedType: "SINGLE",
      currentImageSlotIndex: 0,
      currentRatio: imageRatio,
      previewSlideIndex: 0,
      show_robo_img_popup: false,
    });
  }

  applyAiVideoStudioVideoFromSession = (mediaId) => {
    if (mediaId) {
      return;
    }

    const shouldApply = StringUtil.getUrlParams('apply_ai_video_studio_video');
    const savedPayload = sessionStorage.getItem(AI_VIDEO_STUDIO_APPLY_VIDEO_STORAGE_KEY);

    if (shouldApply !== "Y" || !savedPayload) {
      return;
    }

    let payload = {};
    try {
      payload = JSON.parse(savedPayload);
    } catch (e) {
      console.error("AI 동영상 스튜디오 적용 데이터 파싱 실패:", e);
      sessionStorage.removeItem(AI_VIDEO_STUDIO_APPLY_VIDEO_STORAGE_KEY);
      return;
    }

    sessionStorage.removeItem(AI_VIDEO_STUDIO_APPLY_VIDEO_STORAGE_KEY);

    const videoUrl = payload.video_url || payload.appliedVideo || payload.source_url || "";
    if (!videoUrl) {
      return;
    }

    const ratio = String(payload.aspect_ratio || payload.ratio || "9:16").replace(":", "/");

    this.setState({
      imageSlots: [{
        type: "video",
        data: videoUrl,
        source_url: videoUrl,
        ai_video_studio_history_seq: payload.ai_video_studio_history_seq || "",
        ai_video_studio_result_seq: payload.ai_video_studio_result_seq || "",
        result_no: payload.result_no || "",
      }],
      selectedFeedType: "REELS",
      currentImageSlotIndex: 0,
      currentRatio: ratio || "9/16",
      previewSlideIndex: 0,
      show_ai_video_popup: false,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const prevCnt = (prevState.imageSlots || []).filter(s => this.isFilledSlot(s)).length;
    const currCnt = (this.state.imageSlots || []).filter(s => this.isFilledSlot(s)).length;
    if (prevCnt !== currCnt) {
      const total = currCnt || 1;
      const idx = this.state.previewSlideIndex || 0;
      const fixed = ((idx % total) + total) % total;
      if (fixed !== idx) {
        this.setState({ previewSlideIndex: fixed });
      }
    }

    // AI 카피라이터는 비모달 창처럼 사용하므로 배경 페이지 스크롤을 잠그지 않습니다.
    const shouldLockBody = !!this.state.show_add_product_popup;
    const isTutorialActive = !!document.querySelector('.instagram-tutorial-layer');

    document.body.style.overflow = shouldLockBody || isTutorialActive ? 'hidden' : 'auto';

    if (prevState.reelsAudio !== this.state.reelsAudio) {
      this.syncReelsPreviewVolumes();
    }
  }

  componentWillUnmount() {
    this.stopThreadsOAuthPolling(true);
    if (this.unsubscribeThreadsOAuthBridge) {
      this.unsubscribeThreadsOAuthBridge();
      this.unsubscribeThreadsOAuthBridge = null;
    }
    this.clearThreadsMobileOAuthGuideTimer();
    clearThreadsMobileOAuthPending();
    this.threadsOAuthPending = false;
    document.removeEventListener("visibilitychange", this.handleThreadsMobileOAuthVisibilityChange);
    window.removeEventListener("focus", this.handleThreadsMobileOAuthFocus);
    window.removeEventListener(CONTENT_CREATE_TUTORIAL_EVENT, this.handleInstagramTutorialAction);
    this.instagramTutorialSnapshot = null;
    this.instagramTutorialOpenedAiStudio = false;
    this.instagramTutorialOpenedAiVideoStudio = false;
    document.removeEventListener('mousedown', this.handleClickOutside);
    if (this.unsubscribeFacebookOAuthBridge) {
      this.unsubscribeFacebookOAuthBridge();
      this.unsubscribeFacebookOAuthBridge = null;
    }
    window.removeEventListener("message", this.handleMessage);
    window.removeEventListener("message", this.handleInstagramDirectOAuthMessage);
    document.body.style.overflow = 'auto';
    if (this.reelsPreviewAudioRef.current) {
      try { this.reelsPreviewAudioRef.current.pause(); } catch (e) {}
    }

    if (this.copywriterSelectionSaveTimer) {
      window.clearTimeout(this.copywriterSelectionSaveTimer);
      this.copywriterSelectionSaveTimer = null;
    }

    if (this.observer) {
        this.observer.disconnect();
    }
  }


  handleFacebookOAuthBridgeMessage = (data) => {
    if (!data || data.type !== "refreshInstagramAccount") return;
    if (!consumeFacebookOAuthPending()) return;

    const sendDone = () => {
      publishFacebookOAuthBridgeMessage({
        type: "refreshInstagramAccountDone",
        token_id: data.token_id || "",
        bridge_event_id: data.bridge_event_id || "",
      });
    };

    if (data.result === "success" && data.token_id) {
      this.setState(
        {
          token_id: data.token_id,
          show_account_connect_popup: true,
        },
        () => {
          Promise.resolve(this.loadInstagramAccountList(data.token_id))
            .finally(sendDone);
        }
      );
      return;
    }

    this.setState({
      warning_dialog_show_state: true,
      warning_dialog_content: "페이스북 로그인 또는 권한 승인이 완료되지 않았습니다.",
    });
    sendDone();
  };

  handleMessage = (event) => {
    if(event.data.type === "cnt_setting_saved"){
      this.loadGenerationCount();
    }
  }


  scrollToSec = (id) => {
    const target = document.getElementById(id);
    if(target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.setState({ activeSection: id });
  };

  // [NEW] 모달 토글 로직
  toggleModal = (modalName, isOpen) => {
    this.setState(prev => ({
        modals: { ...prev.modals, [modalName]: isOpen }
    }));
  }

  goToSettings = (modalName) => {
    // alert('AI 자동 환경설정 페이지로 이동합니다.');
    this.toggleModal(modalName, false);
    window.open('/shop/instagram/InstagramCreateCntSetting');
  }

  // [NEW] 고정 문구 로직
  appendPhraseText = (text) => {
      if (this.state.caption.length > 0) {
        this.setCaption(this.state.caption + "\n" + text);
      } else {
        this.setCaption(this.state.caption + text);
      }
  }

  addNewPhrase = () => {
      const { phraseTitleInput, phraseContentInput, quickPhrases } = this.state;
      if(!phraseTitleInput.trim() || !phraseContentInput.trim()) {
          alert('제목과 내용을 모두 입력해주세요.');
          return;
      }
      this.toggleModal('phrase', false);
      this.addNewPhraseByAPI();
  }

  removePhrase = async (index) => {
      // 지워질 객체를 미리 참조해 둠 (복구를 위해 전체 정보 보존)
      const phraseToDelete = this.state.quickPhrases[index];

      if (phraseToDelete.favorite_phrase_seq && String(phraseToDelete.favorite_phrase_seq).startsWith('temp_')) {
        return false;
      }

      const result = await this.openConfirmDialog({
        title: `<b>${phraseToDelete.title}</b> 고정문구를 삭제하시겠습니까?`,
      });

      if (!result) {
          return false;
      }
      
      // 1. 화면(UI)에서 먼저 삭제 (Optimistic Update)
      this.setState(prev => {
          const newPhrases = [...prev.quickPhrases];
          newPhrases.splice(index, 1);
          return { quickPhrases: newPhrases };
      });

      // 2. 서버에서 지우기 
      // 서버 통신 함수에 '삭제된 객체'와 '원래 위치(index)'를 함께 전달합니다.
      this.removePhraseByAPI(phraseToDelete, index);
  }

  // [삭제 API 및 복구 로직]
  removePhraseByAPI = async (deletedPhrase, originalIndex) => {
      http.delete(`/rest/shop/favorite-phrases/${deletedPhrase.favorite_phrase_seq}`)
      .then(res => {
          if (res.data.status === 'success') {
              // 성공 시 이미 화면(UI)에서 지워뒀으므로, 더 이상 setState로 지우지 않습니다. (UI 2중 삭제 방지)
              console.log("고정문구 삭제 완료");
          } else {
              // 논리적 실패(status가 success가 아님)일 경우 강제로 에러를 발생시켜 catch 블록으로 보냅니다.
              throw new Error(res.data.message || "삭제 처리 실패");
          }
      })
      .catch(err => {
          console.error("고정문구 삭제 중 오류 발생:", err);
          // alert("삭제에 실패했습니다. 원래 상태로 복구됩니다.");
          
          // [데이터 원복(Rollback) 로직]
          // 에러가 발생하면, 삭제했던 객체를 원래 위치(originalIndex)에 다시 끼워 넣습니다.
          this.setState(prev => {
              const restoredPhrases = [...prev.quickPhrases];
              restoredPhrases.splice(originalIndex, 0, deletedPhrase);
              return { quickPhrases: restoredPhrases };
          });
      });
  }
  
  removePhraseHashtag = async (index) => {
      // 지워질 객체를 미리 참조해 둠 (복구를 위해 전체 정보 보존)
      const tagToDelete = this.state.fixedTags[index];

      if (tagToDelete.favorite_tag_seq && String(tagToDelete.favorite_tag_seq).startsWith('temp_')) {
        return false;
      }
      
      const result = await this.openConfirmDialog({
        title: `<b>${tagToDelete.tag_name}</b> 태그를 삭제하시겠습니까?`,
      });

      if (!result) {
          return false;
      }
      
      // 1. 화면(UI)에서 먼저 지우기
      this.setState(prev => {
          const newTags = [...prev.fixedTags];
          newTags.splice(index, 1);
          return { fixedTags: newTags };
      });

      // 2. 서버에서 지우기
      // 복구를 위해 '삭제된 객체'와 '원래 위치(index)'를 함께 넘겨줍니다.
      this.deleteFavoriteHashtag(tagToDelete, index);
  }

  // [해시태그 삭제 API 및 복구 로직]
  deleteFavoriteHashtag = async (deletedTag, originalIndex) => {
      http.delete("/rest/shop/favorite-hashtags/" + deletedTag.favorite_tag_seq)
      .then(res => {
          // 삭제 성공 여부 확인
          if (res.data.status === 'success') {
              console.log("해시태그 삭제 완료");
          } else {
              // 논리적 실패 시 강제로 catch 블록으로 보냅니다.
              throw new Error(res.data.message || "삭제 처리 실패");
          }
      })
      .catch(error => {
          console.error("해시태그 삭제 중 오류 발생:", error);
          // alert("해시태그 삭제에 실패했습니다. 원래 상태로 복구됩니다.");
          
          // [데이터 원복(Rollback) 로직]
          this.setState(prev => {
              const restoredTags = [...prev.fixedTags];
              restoredTags.splice(originalIndex, 0, deletedTag);
              return { fixedTags: restoredTags };
          });
      });
  }
  
  // [NEW] 고정 해시태그 로직
  addNewFixedTag = () => {
      let val = this.state.newFixedTagInput.trim();
      if(!val) {
          alert('해시태그를 입력해주세요.');
          return;
      }
      if(!val.startsWith('#')) val = '#' + val;
      
      this.toggleModal('addTag', false);
      this.addFavoriteHashtag(val);
  }

  removeFixedTag = (index) => {
      this.setState(prev => {
          const newTags = [...prev.fixedTags];
          newTags.splice(index, 1);
          return { fixedTags: newTags };
      });
  }

  // --- 비즈니스 로직 ---
  loadInstagramAccountList = (token_id) => {
    const url = token_id
      ? `/rest/shop/instagram/profile/list?token_id=${token_id}`
      : "/rest/shop/instagram/profile/list";

    return http.get(url)
      .then((res) => {
        const list = Array.isArray(res?.data?.list) ? res.data.list : [];
        const account_list_v2 = this.buildIgAccountOptionsV2(list);
        const defaultSeq = this.buildIgDefaultAccount(list) || "";

        const currentSelected = this.state.selected_ig_access_seq || "";

        const nextSelected = currentSelected === "none"
          ? "none"
          : currentSelected && currentSelected !== "add"
            ? currentSelected
            : defaultSeq;

        const targetAcc =
          (account_list_v2 || []).find(
            (acc) => String(acc.value) === String(nextSelected)
          ) || null;

        this.setState({
          add_account_list: list,
          account_list_v2,
          default_ig_access_seq: defaultSeq,
          accountConnected: account_list_v2.length > 0,
          selected_ig_access_seq: nextSelected || "",
          selectedAccount: targetAcc,
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          add_account_list: [],
          account_list_v2: [],
          default_ig_access_seq: "",
          accountConnected: false,
          selected_ig_access_seq: "",
          selectedAccount: null,
        });
      });
  };

  loadThreadsAccountList = () => {
    return http.get("/rest/shop/threds/profile/list")
      .then((res) => {
        const list = Array.isArray(res?.data?.list) ? res.data.list : [];
        const activeList = list.filter((row) => row && String(row.use_yn || "").toUpperCase() === "Y");
        const options = activeList
          .map((threads) => {
            const value = String(threads?.threads_access_token_seq ?? "");
            if (!value) return null;
            const username = threads?.username || threads?.threads_user_id || "Threads 계정";
            return {
              value,
              title: username.startsWith("@") ? username : `@${username}`,
              profile_picture_url: threads?.profile_picture_url || null,
            };
          })
          .filter(Boolean);

        const currentSelected = String(this.state.selected_threads_access_seq || "");
        const nextSelected = currentSelected === "none"
          ? "none"
          : options.some((option) => String(option.value) === currentSelected)
            ? currentSelected
            : (options[0]?.value || "");
        const selectedThreadsAccount = options.find((option) => String(option.value) === String(nextSelected)) || null;

        this.setState({
          threads_account_list_v2: options,
          threadsAccountConnected: options.length > 0,
          selected_threads_access_seq: nextSelected,
          selectedThreadsAccount,
        });

        return options;
      })
      .catch((error) => {
        console.error("Threads 계정 목록 조회 실패:", error);
        this.setState({
          threads_account_list_v2: [],
          threadsAccountConnected: false,
              selected_threads_access_seq: "",
          selectedThreadsAccount: null,
        });

        return [];
      });
  };


  loadThreadsAccountForConnect = (threadsAccessTokenSeq) => {
    const targetSeq = String(threadsAccessTokenSeq || "");
    if (!targetSeq) return Promise.resolve(false);

    return http.get("/rest/shop/threds/profile/list")
      .then((res) => {
        const list = Array.isArray(res?.data?.list) ? res.data.list : [];
        const addThreadsAccountList = list.filter(
          (threads) => threads && String(threads.threads_access_token_seq || "") === targetSeq
        );

        if (addThreadsAccountList.length === 0) {
          this.setState({
            warning_dialog_show_state: true,
            warning_dialog_content: "연결할 Threads 계정 정보를 불러오지 못했습니다.",
          });
          return false;
        }

        this.setState({
          add_threads_account_list: addThreadsAccountList,
          selected_threads_account_list: [],
          show_threads_account_connect_popup: true,
        });
        return true;
      })
      .catch((error) => {
        console.error("Threads 연결 계정 조회 실패:", error);
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: "Threads 계정 정보를 불러오는 중 오류가 발생했습니다.",
        });
        return false;
      });
  };

  toggleThreadsConnectSelection = (threadsAccessTokenSeq) => {
    const value = String(threadsAccessTokenSeq || "");
    if (!value) return;

    this.setState((prev) => {
      const selected = (prev.selected_threads_account_list || []).map(String);
      const next = selected.includes(value)
        ? selected.filter((seq) => seq !== value)
        : [...selected, value];
      return { selected_threads_account_list: next };
    });
  };

  updateThreadsAccountsUseYn = (selectedAccountList, useYn = "Y") => {
    return http.post(
      "/rest/shop/threds/updateAccountsUseYn",
      { selected_account_list: selectedAccountList, use_yn: useYn },
      {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
  };

  updateSelectedThreadsAccountsUseYn = () => {
    const selected = (this.state.selected_threads_account_list || []).map(String);

    if (selected.length === 0) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "하나 이상의 계정을 선택 해 주세요.",
      });
      return;
    }

    this.updateThreadsAccountsUseYn(selected, "Y")
      .then((res) => {
        const data = res?.data || {};
        if (String(data.status || "").toLowerCase() === "success") {
          const nextSelectedSeq = selected[0] || "";
          this.setState(
            {
              show_threads_account_connect_popup: false,
              add_threads_account_list: [],
              selected_threads_account_list: [],
              selected_threads_access_seq: nextSelectedSeq,
            },
            () => this.loadThreadsAccountList()
          );
        } else {
          this.setState({
            warning_dialog_show_state: true,
            warning_dialog_content: data.message || "Threads 계정 업데이트에 실패했습니다.",
          });
        }
      })
      .catch((error) => {
        console.error("Threads 계정 업데이트 실패:", error);
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: "Threads 계정 업데이트 요청 중 오류가 발생했습니다.",
        });
      });
  };


  clearThreadsMobileOAuthGuideTimer = () => {
    if (this.threadsOAuthMobileGuideTimer) {
      window.clearTimeout(this.threadsOAuthMobileGuideTimer);
      this.threadsOAuthMobileGuideTimer = null;
    }
  };

  markThreadsOAuthStarted = () => {
    this.clearThreadsMobileOAuthGuideTimer();
    this.threadsOAuthPending = true;
    this.threadsOAuthStartedAt = Date.now();
    this.threadsOAuthMobileWasHidden = false;
    this.threadsOAuthMobileGuideShown = false;

    if (isMobileThreadsOAuth()) {
      saveThreadsMobileOAuthPending(this.threadsOAuthStartedAt);
      this.scheduleThreadsMobileOAuthGuide(false);
    } else {
      clearThreadsMobileOAuthPending();
    }
  };

  clearThreadsOAuthPendingState = (hideGuide = true) => {
    this.clearThreadsMobileOAuthGuideTimer();
    this.threadsOAuthPending = false;
    this.threadsOAuthStartedAt = 0;
    this.threadsOAuthMobileWasHidden = false;
    this.threadsOAuthMobileGuideShown = false;
    clearThreadsMobileOAuthPending();

    if (hideGuide) {
      this.setState({
        show_threads_mobile_oauth_guide: false,
        threads_oauth_manual_copy_message: "",
      });
    }
  };

  scheduleThreadsMobileOAuthGuide = (returnedToPage = false) => {
    if (!isMobileThreadsOAuth() || !this.threadsOAuthPending || this.threadsOAuthMobileGuideShown) return;

    this.clearThreadsMobileOAuthGuideTimer();

    const startedAt = this.threadsOAuthStartedAt || Date.now();
    const elapsed = Math.max(0, Date.now() - startedAt);
    const delay = returnedToPage
      ? 1000
      : Math.max(0, THREADS_OAUTH_MOBILE_GUIDE_DELAY_MS - elapsed);

    this.threadsOAuthMobileGuideTimer = window.setTimeout(() => {
      this.threadsOAuthMobileGuideTimer = null;
      if (!this.threadsOAuthPending || this.threadsOAuthMobileGuideShown) return;
      if (document.visibilityState === "hidden") return;

      this.threadsOAuthMobileGuideShown = true;
      this.setState(
        {
          show_threads_mobile_oauth_guide: true,
          threads_mobile_oauth_os: getThreadsMobileOS(),
          threads_oauth_manual_url: "",
          threads_oauth_manual_url_loading: true,
          threads_oauth_manual_copy_message: "",
        },
        this.loadThreadsOAuthManualUrl
      );
    }, delay);
  };

  handleThreadsMobileOAuthVisibilityChange = () => {
    if (!this.threadsOAuthPending || !isMobileThreadsOAuth()) return;

    if (document.visibilityState === "hidden") {
      this.threadsOAuthMobileWasHidden = true;
      return;
    }

    if (document.visibilityState === "visible") {
      this.scheduleThreadsMobileOAuthGuide(this.threadsOAuthMobileWasHidden);
    }
  };

  handleThreadsMobileOAuthFocus = () => {
    if (!this.threadsOAuthPending || !isMobileThreadsOAuth()) return;

    const elapsed = Date.now() - (this.threadsOAuthStartedAt || Date.now());
    const returnedToPage = this.threadsOAuthMobileWasHidden || elapsed >= 2500;
    this.scheduleThreadsMobileOAuthGuide(returnedToPage);
  };

  loadThreadsOAuthManualUrl = () => {
    return http.get("/rest/shop/threds/auth-url?return_to_parent=Y")
      .then((res) => {
        const authUrl = String(res?.data?.auth_url || "").trim();
        this.setState({
          threads_oauth_manual_url: authUrl,
          threads_oauth_manual_url_loading: false,
        });
        return authUrl;
      })
      .catch((error) => {
        console.error("Threads 수동 인증 주소 조회 실패:", error);
        this.setState({
          threads_oauth_manual_url: "",
          threads_oauth_manual_url_loading: false,
          threads_oauth_manual_copy_message: "인증 주소를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.",
        });
        return "";
      });
  };

  copyThreadsOAuthManualUrl = () => {
    const authUrl = String(this.state.threads_oauth_manual_url || "").trim();
    if (!authUrl) {
      this.setState({
        threads_oauth_manual_copy_message: this.state.threads_oauth_manual_url_loading
          ? "인증 주소를 준비 중입니다."
          : "인증 주소를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.",
      });
      return;
    }

    const onCopied = () => this.setState({ threads_oauth_manual_copy_message: "인증 주소를 복사했습니다." });
    const fallbackCopy = () => {
      try {
        const textarea = document.createElement("textarea");
        textarea.value = authUrl;
        textarea.setAttribute("readonly", "readonly");
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        const copied = document.execCommand("copy");
        textarea.remove();
        if (copied) onCopied();
        else throw new Error("copy failed");
      } catch (e) {
        this.setState({ threads_oauth_manual_copy_message: "인증 주소 복사에 실패했습니다." });
      }
    };

    if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
      navigator.clipboard.writeText(authUrl).then(onCopied).catch(fallbackCopy);
    } else {
      fallbackCopy();
    }
  };

  closeThreadsMobileOAuthGuide = () => {
    this.setState({
      show_threads_mobile_oauth_guide: false,
      threads_oauth_manual_copy_message: "",
    });
  };

  retryThreadsOAuthFromGuide = () => {
    this.closeThreadsMobileOAuthGuide();
    if (typeof this.stopThreadsOAuthPolling === "function") {
      this.stopThreadsOAuthPolling(true);
    }
    this.clearThreadsOAuthPendingState(false);
    this.handleThreadsConnect();
  };

  renderThreadsMobileOAuthGuide = () => {
    if (!this.state.show_threads_mobile_oauth_guide) return null;

    const os = this.state.threads_mobile_oauth_os || getThreadsMobileOS();
    const isAndroid = os === "android";
    const isIOS = os === "ios";
    const manualUrlReady = !!String(this.state.threads_oauth_manual_url || "").trim();

    return (
      <PopupFrameV2
        className={"threads-mobile-oauth-guide-popup"}
        maxWidth={"620px"}
        onClose={this.closeThreadsMobileOAuthGuide}
      >
        <div style={{ padding: "26px 28px 24px", color: "#0A1A2F", lineHeight: 1.65, wordBreak: "keep-all" }}>
          <h5 style={{ margin: "0 0 12px", fontSize: "20px" }}>Threads 연결이 잘 안 되나요?</h5>
          <div style={{ fontSize: "14px", color: "#4b5563" }}>
            모바일에서는 Threads 앱이 자동으로 열리면서 계정 연결이 중간에 멈출 수 있습니다.
            <br />아래 방법으로 다시 진행해 주세요.
          </div>

          {isAndroid && (
            <div style={{ marginTop: "18px" }}>
              <div style={{ fontWeight: 800, marginBottom: "8px" }}>방법 1. Threads 앱이 자동으로 열리지 않게 설정하기</div>
              <div style={{ fontSize: "14px", color: "#374151", lineHeight: 1.8 }}>
                1. 휴대폰 <b>설정 → 앱 → Threads → 기본으로 설정</b>으로 이동해 주세요.
                <br />2. <b>이 앱으로 열기</b>를 꺼 주세요. 기기에 따라 <b>지원되는 웹 주소</b>로 표시될 수 있습니다.
                <br />3. 아래 <b>다시 연결</b>을 눌러 주세요.
              </div>

              <div style={{ fontWeight: 800, margin: "18px 0 8px" }}>방법 2. 인증 주소를 브라우저에서 직접 열기</div>
              <div style={{ fontSize: "14px", color: "#374151", lineHeight: 1.8 }}>
                1. 아래 <b>인증 주소 복사</b>를 눌러 주세요.
                <br />2. 지금 RoboMD를 보고 있는 <b>같은 브라우저에서 새 탭</b>을 열어 주세요.
                <br />3. 새 탭의 주소창에 붙여넣고 Threads 인증을 진행해 주세요.
                <br />4. 인증 완료 안내가 나오면 그 탭을 닫고 원래 RoboMD 탭으로 돌아와 주세요.
              </div>
            </div>
          )}

          {isIOS && (
            <div style={{ marginTop: "18px" }}>
              <div style={{ fontWeight: 800, marginBottom: "8px" }}>인증 주소를 브라우저에서 직접 열어 주세요</div>
              <div style={{ fontSize: "14px", color: "#374151", lineHeight: 1.8 }}>
                1. 아래 <b>인증 주소 복사</b>를 눌러 주세요.
                <br />2. 지금 RoboMD를 보고 있는 <b>같은 브라우저에서 새 탭</b>을 열어 주세요.
                <br />3. 새 탭의 주소창에 붙여넣고 Threads 인증을 진행해 주세요.
                <br />4. 인증 완료 안내가 나오면 그 탭을 닫고 원래 RoboMD 탭으로 돌아와 주세요.
              </div>
            </div>
          )}

          {!isAndroid && !isIOS && (
            <div style={{ marginTop: "18px" }}>
              <div style={{ fontWeight: 800, marginBottom: "8px" }}>인증 주소를 브라우저에서 직접 열어 주세요</div>
              <div style={{ fontSize: "14px", color: "#374151", lineHeight: 1.8 }}>
                1. 아래 <b>인증 주소 복사</b>를 눌러 주세요.
                <br />2. 지금 RoboMD를 보고 있는 <b>같은 브라우저에서 새 탭</b>을 열어 주세요.
                <br />3. 새 탭의 주소창에 붙여넣고 Threads 인증을 진행해 주세요.
                <br />4. 인증 완료 안내가 나오면 그 탭을 닫고 원래 RoboMD 탭으로 돌아와 주세요.
              </div>
            </div>
          )}

          <div style={{ marginTop: "16px", padding: "12px 14px", background: "#f8fafc", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", color: "#4b5563" }}>
            <b>중요:</b> 지금 보고 있는 RoboMD 탭은 닫지 마세요. 인증이 끝나면 이 화면에서 연결할 Threads 계정을 선택할 수 있습니다.
          </div>

          {this.state.threads_oauth_manual_copy_message && (
            <div style={{ marginTop: "10px", fontSize: "13px", color: "#374151" }}>
              {this.state.threads_oauth_manual_copy_message}
            </div>
          )}

          <div style={{ display: "flex", justifyContent: "flex-end", flexWrap: "wrap", gap: "8px", marginTop: "22px" }}>
            <button type="button" className="btn" onClick={this.closeThreadsMobileOAuthGuide}>
              닫기
            </button>
            <button
              type="button"
              className="btn"
              disabled={this.state.threads_oauth_manual_url_loading || !manualUrlReady}
              onClick={this.copyThreadsOAuthManualUrl}
              style={{ opacity: this.state.threads_oauth_manual_url_loading || !manualUrlReady ? 0.55 : 1 }}
            >
              {this.state.threads_oauth_manual_url_loading ? "인증 주소 준비 중" : "인증 주소 복사"}
            </button>
            {isAndroid && (
              <button type="button" className="btn btn-primary" onClick={this.retryThreadsOAuthFromGuide}>
                다시 연결
              </button>
            )}
          </div>
        </div>
      </PopupFrameV2>
    );
  };

  handleThreadsOAuthResult = (result, threadsAccessTokenSeq) => {
    if (!this.threadsOAuthPending) return;

    this.stopThreadsOAuthPolling(true);
    this.clearThreadsOAuthPendingState(true);

    if (String(result || "").toLowerCase() === "success" && threadsAccessTokenSeq) {
      this.loadThreadsAccountForConnect(threadsAccessTokenSeq);
      return;
    }

    this.setState({
      warning_dialog_show_state: true,
      warning_dialog_content: "Threads 로그인 또는 권한 승인이 완료되지 않았습니다.",
    });
  };

  handleThreadsOAuthBridgeMessage = (data) => {
    if (!data || data.type !== "refreshThreadsAccount") return;
    if (!this.threadsOAuthPending) return;

    this.handleThreadsOAuthResult(
      data.result,
      data.threads_access_token_seq || ""
    );
  };


  stopThreadsOAuthPolling = (closeWindow = false) => {
    if (this.threadsOAuthPollTimer) {
      window.clearInterval(this.threadsOAuthPollTimer);
      this.threadsOAuthPollTimer = null;
    }

    if (closeWindow && this.threadsOAuthWindow && !this.threadsOAuthWindow.closed) {
      try {
        this.threadsOAuthWindow.close();
      } catch (e) {
        // OAuth 창 닫기 실패는 계정 연동 결과와 무관하므로 무시한다.
      }
    }

    if (!this.threadsOAuthWindow || this.threadsOAuthWindow.closed || closeWindow) {
      this.threadsOAuthWindow = null;
    }
  };

  startThreadsOAuthPolling = () => {
    this.stopThreadsOAuthPolling(false);

    let attempts = 0;
    let checking = false;

    const checkOAuthCallback = () => {
      if (checking) return;
      checking = true;

      try {
        const authWindow = this.threadsOAuthWindow;
        if (!authWindow) {
          this.stopThreadsOAuthPolling(false);
          return;
        }

        if (authWindow.closed) {
          // 창이 닫혀도 callback BroadcastChannel/localStorage 메시지는 받을 수 있으므로
          // pending 상태는 유지하고 polling만 종료한다.
          this.stopThreadsOAuthPolling(false);
          return;
        }

        try {
          // Threads OAuth 중에는 cross-origin이라 접근이 차단되고,
          // callback 후 RoboMD origin으로 돌아온 순간에만 아래 값 조회가 가능하다.
          const callbackUrl = new URL(authWindow.location.href);
          if (callbackUrl.origin === window.location.origin) {
            const status = callbackUrl.searchParams.get("threads_status");
            const accessTokenSeq = callbackUrl.searchParams.get("threads_access_token_seq") || "";

            if (status === "success" && accessTokenSeq) {
              this.handleThreadsOAuthResult("success", accessTokenSeq);
              return;
            }

            if (status === "fail") {
              this.handleThreadsOAuthResult("fail", "");
              return;
            }
          }
        } catch (e) {
          // OAuth 진행 중 cross-origin 접근 오류는 정상 흐름이므로 무시한다.
        }

        attempts += 1;
        if (attempts >= 180) {
          // 3분 이후에는 polling만 중단한다. callback bridge listener는 페이지가 살아있는 동안 유지된다.
          this.stopThreadsOAuthPolling(false);
        }
      } finally {
        checking = false;
      }
    };

    checkOAuthCallback();
    this.threadsOAuthPollTimer = window.setInterval(checkOAuthCallback, 1000);
  };

  handleThreadsConnect = () => {
    // 콘텐츠/자동화 설정의 입력값을 보존하기 위해 OAuth는 새 탭에서 진행한다.
    // callback 성공 시 현재 페이지에서 연결할 Threads 계정 선택 팝업을 띄운다.
    this.markThreadsOAuthStarted();
    const authWindow = window.open("/rest/shop/threds/auth-redirect?return_to_parent=Y", "_blank");

    if (!authWindow) {
      this.clearThreadsOAuthPendingState(false);
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "Threads 계정 연결 창을 열 수 없습니다. 팝업 차단 설정을 확인해주세요.",
      });
      return;
    }

    this.threadsOAuthWindow = authWindow;
    this.startThreadsOAuthPolling();
  };

  loadInstagramMediaDetail = async (mediaId, blocked_load_dialog = false) => {
    if (!mediaId) return;
    try {
      if (blocked_load_dialog !== true) {
        this.setState({ save_dialog_show_state: true, save_dialog_content: "콘텐츠 불러오는 중..." });
      }

      const { data: res } = await http.get(`/rest/shop/instagram/media/${mediaId}`);
      const r = res || {};

      if (r.status == "PUBLISHED") {
        alert("이미 발행된 콘텐츠은 수정할 수 없습니다.");
        window.location.href = '/shop/instagram/InstagramPostList';
      }

      const loadedMediaTypeCd = String(r.media_type_cd || "").toUpperCase();
      const items = Array.isArray(r.items) ? r.items : [];
      const hasReservedReelsItem = items.some((it) => Number(it && it.item_index) === REELS_ITEM_INDEX);

      const mappedSlots = items.map((it) => {
        const src = it.source || {};
        const sourceTypeCd = String(src.source_type_cd || it.source_type_cd || "").toUpperCase();
        const itemIndex = Number(it.item_index);
        const isReservedReelsItem = itemIndex === REELS_ITEM_INDEX;
        const isLegacyReelsItem = !hasReservedReelsItem && loadedMediaTypeCd === "R";

        // 조회 API가 it.source.source_url 형태로 줄 때와
        // it.source_url처럼 평평한 형태로 줄 때를 모두 대응한다.
        const sourceUrl =
          src.source_url ||
          it.source_url ||
          src.video_url ||
          it.video_url ||
          src.org_video_path ||
          it.org_video_path ||
          src.image_url ||
          it.image_url ||
          src.org_img_path ||
          it.org_img_path ||
          "";

        const videoUrl = this.looksLikeVideoUrl(sourceUrl)
          ? sourceUrl
          : (src.video_url || it.video_url || src.org_video_path || it.org_video_path || "");

        const posterUrl =
          src.preview_image_url ||
          it.preview_image_url ||
          src.thumbnail_url ||
          it.thumbnail_url ||
          src.poster_url ||
          it.poster_url ||
          (!this.looksLikeVideoUrl(sourceUrl) ? sourceUrl : "");

        const shouldTreatAsVideo =
          isReservedReelsItem ||
          isLegacyReelsItem ||
          sourceTypeCd === "V" ||
          this.looksLikeVideoUrl(videoUrl || sourceUrl);

        const type =
          shouldTreatAsVideo ? "video" :
          sourceTypeCd === "U" ? "upload" :
          sourceTypeCd === "P" ? "product" :
          sourceTypeCd === "A" ? "ai" :
          sourceTypeCd === "T" ? "template" :
          (src.product_no || it.product_no ? "product" : "upload");

        return {
          type,
          data: videoUrl || sourceUrl || posterUrl || null,
          source_url: sourceUrl || null,
          video_url: videoUrl || null,
          preview_image_url: posterUrl || null,
          poster_url: posterUrl || null,
          media_source_id: it.media_source_id || src.media_source_id || null,
          item_index: Number.isFinite(itemIndex) ? itemIndex : null,
          product_no: src.product_no || it.product_no || null,
          stability_call_seq: it.stability_call_seq || src.stability_call_seq || null,
          event_seq: src.event_seq || it.event_seq || null,
          product_name: src.product_name || it.product_name || null,

          ai_studio_history_seq: src.ai_studio_history_seq || it.ai_studio_history_seq || null,
          ai_studio_history_step_seq: src.ai_studio_history_step_seq || it.ai_studio_history_step_seq || null,
          ai_studio_history_step_result_seq: src.ai_studio_history_step_result_seq || it.ai_studio_history_step_result_seq || null,

          ai_video_studio_history_seq: src.ai_video_studio_history_seq || it.ai_video_studio_history_seq || null,
          ai_video_studio_result_seq: src.ai_video_studio_result_seq || it.ai_video_studio_result_seq || null,

          image_ratio: normalizeImageRatio(it.image_ratio || src.image_ratio || ""),
          video_ratio: normalizeImageRatio(it.video_ratio || src.video_ratio || it.aspect_ratio || src.aspect_ratio || ""),
        };
      });

      // 신규 구조: 100번은 릴스 전용, 그 외는 피드.
      // 기존 구조: 100번이 없고 media_type_cd=R이면 기존 item_index(보통 0)를 릴스로 호환한다.
      const feedSourceSlots = hasReservedReelsItem
        ? mappedSlots.filter((slot) => slot.item_index !== REELS_ITEM_INDEX)
        : (loadedMediaTypeCd === "R" ? [] : mappedSlots);
      const reelsSourceSlots = hasReservedReelsItem
        ? mappedSlots.filter((slot) => slot.item_index === REELS_ITEM_INDEX)
        : (loadedMediaTypeCd === "R" ? mappedSlots : []);

      const feedImageSlots = this.normalizeImageSlots(feedSourceSlots);
      const reelsVideoSlots = this.normalizeVideoSlots(reelsSourceSlots);
      const selectedFeedType = loadedMediaTypeCd === "R"
        ? "REELS"
        : this.getFeedTypeBySlots(feedImageSlots);
      const normalizedSlots = selectedFeedType === "REELS"
        ? reelsVideoSlots
        : feedImageSlots;
      const tags = Array.isArray(r.hashtags)
        ? r.hashtags
        : (typeof r.hashtags === "string" ? r.hashtags.split(/\s+/).filter(Boolean) : []);

      const scheduledRaw = r.scheduled_time || r.scheduled_at || "";
      let scheduledDate = "";
      let scheduledTime = "";
      if (scheduledRaw) {
        const iso = scheduledRaw.replace(" ", "T");
        const s = scheduledRaw.replace("T", " ");
        scheduledDate = s.slice(0, 10);
        scheduledTime = s.slice(11, 16);
      }

      let parsedSuggestions = [];
      try {
        parsedSuggestions = r.gpt_caption_suggestions
          ? JSON.parse(r.gpt_caption_suggestions)
          : [];
      } catch (e) {
        console.error("gpt_caption_suggestions JSON 파싱 실패:", e);
        parsedSuggestions = [];
      }

      let audioMeta = null;
      try {
        audioMeta = r.audio_meta_snapshot_json ? JSON.parse(r.audio_meta_snapshot_json) : null;
      } catch (e) {
        audioMeta = null;
      }

      const loadedAudioMode = ["MUSIC", "ORIGINAL_SOUND"].includes(String(r.audio_mode_cd || "").toUpperCase())
        ? String(r.audio_mode_cd).toUpperCase()
        : "NONE";

      const loadedReelsAudio = {
        ...createDefaultReelsAudioState(),
        mode: loadedAudioMode,
        audioId: r.instagram_audio_id ? String(r.instagram_audio_id) : "",
        audioType: String(r.instagram_audio_type || loadedAudioMode || "").toUpperCase(),
        title: r.instagram_audio_title || "",
        artist: r.instagram_audio_artist || "",
        durationMs: r.instagram_audio_duration_ms !== null && r.instagram_audio_duration_ms !== undefined
          ? Number(r.instagram_audio_duration_ms)
          : null,
        audioVolume: clampInstagramAudioVolume(r.audio_volume, 100),
        videoVolume: clampInstagramAudioVolume(r.video_volume, 100),
        audioName: r.audio_name || "",
        platformPreviewUrl: audioMeta
          ? normalizeInstagramAudioAsset(
              audioMeta,
              loadedAudioMode === "ORIGINAL_SOUND" ? "original_sound" : "music"
            ).platformPreviewUrl
          : "",
        meta: audioMeta,
        mediaAudioType: r.media_audio_type || "",
      };

      const loadedHeaderRatio = normalizeImageRatio(r.image_ratio || "");
      const loadedReelsSlotRatio = normalizeImageRatio(
        (reelsVideoSlots[0] && (reelsVideoSlots[0].video_ratio || reelsVideoSlots[0].aspect_ratio || reelsVideoSlots[0].image_ratio)) || ""
      );
      const nextFeedRatio = selectedFeedType === "REELS"
        ? (blocked_load_dialog === true ? (this.state.feedRatio || "1/1") : "1/1")
        : (loadedHeaderRatio || "1/1");
      const nextReelsRatio = selectedFeedType === "REELS"
        ? (loadedHeaderRatio || loadedReelsSlotRatio || "9/16")
        : (blocked_load_dialog === true ? (this.state.reelsRatio || loadedReelsSlotRatio || "9/16") : (loadedReelsSlotRatio || "9/16"));

      this.setState({
        media_id: r.instagram_media_seq || mediaId,
        // 계정 미선택 임시저장은 기본 계정으로 자동 대체하지 않는다.
        selected_ig_access_seq: r.instagram_access_token_seq
          ? String(r.instagram_access_token_seq)
          : (String(r.is_draft || "").toUpperCase() === "Y" ? "none" : this.state.selected_ig_access_seq),
        selected_threads_access_seq: r.threads_access_token_seq
          ? String(r.threads_access_token_seq)
          : (String(r.is_draft || "").toUpperCase() === "Y" ? "none" : this.state.selected_threads_access_seq),
        selectedAccount: r.instagram_access_token_seq
          ? ((this.state.account_list_v2 || []).find((acc) => String(acc.value) === String(r.instagram_access_token_seq)) || null)
          : (String(r.is_draft || "").toUpperCase() === "Y" ? null : this.state.selectedAccount),
        selectedThreadsAccount: r.threads_access_token_seq
          ? ((this.state.threads_account_list_v2 || []).find((acc) => String(acc.value) === String(r.threads_access_token_seq)) || null)
          : (String(r.is_draft || "").toUpperCase() === "Y" ? null : this.state.selectedThreadsAccount),
        instagramPublishEnabled: String(r.instagram_publish_yn || "Y").toUpperCase() !== "N",
        threadsPublishEnabled: String(r.threads_publish_yn || "N").toUpperCase() === "Y",
        imageSlots: normalizedSlots,
        feedImageSlots,
        reelsVideoSlots,
        feedRatio: nextFeedRatio,
        reelsRatio: nextReelsRatio,
        tags,
        publishOption : r.post_type,
        scheduledDate,
        scheduledTime,
        is_draft: r.is_draft,
        status: r.status,
        selectedFeedType,
        previewSlideIndex: 0,
        aiSuggestionsVisible: parsedSuggestions.length > 0,
        topicInput: r.caption_prompt || "",
        aiRecommendations: r.gpt_caption_suggestions ? JSON.parse(r.gpt_caption_suggestions) : [],
        selectedLabel: r.gpt_caption_selected_suggestions || "",
        currentRatio: selectedFeedType === "REELS" ? nextReelsRatio : nextFeedRatio,
        copywriter_preset_seq: r.copywriter_preset_seq || "",
        reelsAudio: loadedReelsAudio,
      }, () => {
        this.syncReelsPreviewVolumes();
        if (selectedFeedType === "REELS" && loadedReelsAudio.audioId) {
          this.refreshSelectedInstagramAudioMetadata(loadedReelsAudio.audioId, loadedReelsAudio.audioType);
        }
      });
      this.setCaption(r.caption || "");
      
    } catch (err) {
      console.error(err);
      this.setState({
        basic_dialog_show_state: true,
        basic_dialog_content: "콘텐츠 불러오기에 실패했습니다.",
      });
    } finally {
      this.setState({ save_dialog_show_state: false });
    }
  }

  buildIgAccountOptions(apiPayload) {
    const src = apiPayload && (apiPayload.list || apiPayload) || [];
    const opts = [];
    src.forEach(fb => {
      const fbName = fb.facebook_username || "(이름 없음)";
      const igList = fb.instagram_account_list || [];
      igList.forEach(ig => {
        const v = String(ig.instagram_access_token_seq ?? "");
        if (!v) return;
        const uname = ig.username ? `@${ig.username}` : "(계정명 없음)";
        opts.push({ value: v, title: `${fbName} / ${uname}` });
      });
    });
    return opts;
  }

  buildIgAccountOptionsV2(apiPayload) {
    const src = apiPayload && (apiPayload.list || apiPayload) || [];
    const opts = [];
    src.forEach(fb => {
      const igList = fb.instagram_account_list || [];
      igList.forEach(ig => {
        const v = String(ig.instagram_access_token_seq ?? "");
        if (!v) return;
        const uname = ig.username ? `${ig.username}` : "(계정명 없음)";
        opts.push({ value: v, title: `${uname}`, profile_picture_url: ig.profile_picture_url || null });
      });
    });
    return opts;
  }

  buildIgDefaultAccount(apiPayload) {
    const src = (apiPayload && (apiPayload.list || apiPayload)) || [];
    
    // 1. 모든 facebook 객체에서 instagram_account_list를 추출하여 하나의 배열로 만듭니다.
    const allIgAccounts = src.reduce((acc, fb) => {
        return acc.concat(fb.instagram_account_list || []);
    }, []);

    if (allIgAccounts.length === 0) return "";

    // 2. 전체 배열에서 default_yn === 'Y'인 것을 찾습니다.
    const defaultAcc = allIgAccounts.find(ig => ig.default_yn === 'Y');

    // 3. 찾았다면 그 시퀀스를 반환, 없다면 배열의 첫 번째 계정을 반환합니다.
    if (defaultAcc) {
        return String(defaultAcc.instagram_access_token_seq ?? "");
    } else {
        return String(allIgAccounts[0].instagram_access_token_seq ?? "");
    }
  }

  needConnectAccount() {
    this.setState({
        title_content_dialog_show_state: true,
        title_content_dialog_title: "<b>계정 연결 필요</b>",
        title_content_dialog_content: "계정 연결 후 이용하실 수 있습니다.<br/>지금 연결 하시겠습니까?",
        title_content_dialog_button_list: [
          {
            title: "네",
            event_method: () => {
              this.setState({ title_content_dialog_show_state: false });
              this.handleConnectAccount(); // 기존에 구현되어 있는 페이스북/인스타 연동 함수 실행
            }
          },
          {
            title: "아니요",
            event_method: () => {
              this.setState({ title_content_dialog_show_state: false });
            }
          }
        ]
    });
  }

  onChangeAccount = (text, value) => {
    const previousAccountSeq = String(this.state.selected_ig_access_seq || "");
    // 1. "연동하기" 버튼을 눌렀을 때
    if (value === 'add') {
      // alert('계정 관리/연동 페이지로 이동합니다.');
      this.needConnectAccount();
      // (SelectBox의 값은 변하지 않도록 여기서 중단)
      return;
    }

    // 2. "계정 미연동"을 선택했을 때
    if (value === 'none') {
      this.setState({ 
        selected_ig_access_seq: 'none', 
        selectedAccount: null,
        reelsAudio: createDefaultReelsAudioState(),
      });
      return;
    }

    // 3. 정상적으로 연결된 계정을 선택했을 때
    const targetAcc = (this.state.account_list_v2 || []).find(acc => acc.value == value);
    this.setState({ 
      selected_ig_access_seq: value,
      selectedAccount: targetAcc || null,
      ...(previousAccountSeq && previousAccountSeq !== String(value)
        ? { reelsAudio: createDefaultReelsAudioState() }
        : {}),
    });
  };

  isValidThreadsSeq = (value) => {
    if (value === null || value === undefined) return false;
    const v = String(value).trim();
    return !!v && v !== "none" && v !== "add";
  };

  getThreadsPublishAccountSeq = () => {
    return this.isValidThreadsSeq(this.state.selected_threads_access_seq)
      ? String(this.state.selected_threads_access_seq).trim()
      : "";
  };

  togglePublishPlatform = (platform) => {
    this.setState((prev) => {
      const isInstagram = platform === "instagram";
      const current = isInstagram ? prev.instagramPublishEnabled : prev.threadsPublishEnabled;
      const nextInstagram = isInstagram ? !current : prev.instagramPublishEnabled;
      const nextThreads = isInstagram ? prev.threadsPublishEnabled : !current;

      if (!nextInstagram && !nextThreads) {
        return null;
      }

      return isInstagram
        ? { instagramPublishEnabled: nextInstagram }
        : { threadsPublishEnabled: nextThreads };
    });
  };

  onChangeThreadsAccount = (text, value) => {
    if (value === "add") {
      this.handleThreadsConnect();
      return;
    }

    const targetAcc = (this.state.threads_account_list_v2 || [])
      .find((acc) => String(acc.value) === String(value));

    this.setState({
      selected_threads_access_seq: value,
      selectedThreadsAccount: targetAcc || null,
    });
  };

  publishThreadsFromCommonMedia = async (mediaId) => {
    if (!mediaId) {
      throw new Error("Threads 발행에 필요한 콘텐츠 ID가 없습니다.");
    }

    const { data } = await http.post(
      `/rest/shop/threds/media/source/${mediaId}/publish-now`,
      {}
    );

    const failed = !data
      || data.ok === false
      || String(data.status || "").toLowerCase() === "fail"
      || !!data.error_code;

    if (failed) {
      throw new Error(
        data?.message
        || data?.error
        || data?.error_message
        || "Threads 콘텐츠 공유에 실패했습니다."
      );
    }

    return data;
  };

  saveCommonMediaForThreadsOnlyNow = async (payload) => {
    const mediaId = this.state.media_id;
    const sourcePayload = {
      ...payload,
      instagram_access_token_seq: null,
      instagram_publish_yn: "N",
      threads_publish_yn: "Y",
      scheduled_at: null,
      post_type: "NOW",
    };

    const url = mediaId
      ? `/rest/shop/instagram/media/drafts/${mediaId}`
      : "/rest/shop/instagram/media/drafts";

    const { data } = mediaId
      ? await http.put(url, sourcePayload)
      : await http.post(url, sourcePayload);

    if (!data || data.ok !== true) {
      throw new Error(data?.error || "Threads 발행용 콘텐츠 저장에 실패했습니다.");
    }

    return data.media_id || mediaId;
  };

  selectFeedType = (type) => {
    if (type === "REELS") {
      // 피드/릴스 상단 탭과 동일한 보존 로직을 사용한다.
      this.selectPostContentType("REELS");
      return;
    }

    if (type === "SINGLE") {
      const firstFeedSlot = (this.state.imageSlots || []).find((slot) => this.isFilledSlot(slot) && !this.isVideoSlot(slot));
      this.setState({
        selectedFeedType: "SINGLE",
        imageSlots: this.normalizeImageSlots(firstFeedSlot ? [firstFeedSlot] : []),
        previewSlideIndex: 0,
      });
      return;
    }

    this.setState({
      selectedFeedType: "CAROUSEL",
      imageSlots: this.normalizeImageSlots(this.state.imageSlots || []),
      previewSlideIndex: 0,
    });
  };

  selectPostContentType = (type) => {
    if (type === "REELS") {
      if (this.state.selectedFeedType === "REELS") {
        return;
      }

      this.setState((prev) => {
        // 현재 피드 작업을 보관한 뒤 이전 릴스 작업을 복원한다.
        const feedImageSlots = this.normalizeImageSlots(prev.imageSlots || []);
        const reelsVideoSlots = this.normalizeVideoSlots(prev.reelsVideoSlots || []);

        return {
          selectedFeedType: "REELS",
          feedImageSlots,
          feedRatio: prev.currentRatio || "1/1",
          imageSlots: reelsVideoSlots,
          currentRatio: prev.reelsRatio || "9/16",
          previewSlideIndex: 0,
        };
      });
      return;
    }

    if (this.state.selectedFeedType !== "REELS") {
      return;
    }

    this.setState((prev) => {
      // 현재 릴스 작업을 보관한 뒤 이전 피드 작업을 복원한다.
      const reelsVideoSlots = this.normalizeVideoSlots(prev.imageSlots || []);
      const feedImageSlots = this.normalizeImageSlots(prev.feedImageSlots || []);

      return {
        selectedFeedType: this.getFeedTypeBySlots(feedImageSlots),
        reelsVideoSlots,
        reelsRatio: prev.currentRatio || "9/16",
        imageSlots: feedImageSlots,
        currentRatio: prev.feedRatio || "1/1",
        previewSlideIndex: 0,
        // reelsAudio는 탭 전환만으로 초기화하지 않는다.
      };
    });
  };

  addNewImageSlot = () => {
    this.setState((prev) => {
      if (prev.imageSlots.length >= 10) {
        alert("최대 10개까지만 추가할 수 있습니다.");
        return null;
      }
      return { imageSlots: [...prev.imageSlots, { type: null, data: null }] };
    });
  };

  isFilledSlot = (slot) => {
    return !!(
      slot &&
      slot.type &&
      (slot.data || slot.source_url || slot.video_url || slot.preview_image_url || slot.media_source_id)
    );
  };

  getFilledSlotCount = (imageSlots = []) => {
    return imageSlots.filter((slot) => this.isFilledSlot(slot)).length;
  };

  getFeedTypeBySlots = (imageSlots = []) => {
    const feedSlots = (imageSlots || []).filter((slot) => this.isFilledSlot(slot) && !this.isVideoSlot(slot));
    return feedSlots.length >= 2 ? "CAROUSEL" : "SINGLE";
  };

  looksLikeVideoUrl = (url) => {
    const value = String(url || "").split("?")[0].toLowerCase();
    return /\.(mp4|mov|m4v|webm|avi|mpeg|mpg)$/.test(value);
  };

  looksLikeImageUrl = (url) => {
    const value = String(url || "").split("?")[0].toLowerCase();
    return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/.test(value);
  };

  getSlotVideoUrl = (slot) => {
    if (!slot) return "";

    const candidates = [
      slot.video_url,
      slot.org_video_path,
      slot.source_url,
      slot.data,
    ];

    return candidates.find((url) => url && this.looksLikeVideoUrl(url)) || "";
  };

  getSlotPosterUrl = (slot) => {
    if (!slot) return "";

    const candidates = [
      slot.poster_url,
      slot.preview_image_url,
      slot.thumbnail_url,
      slot.image_url,
      slot.org_img_path,
      slot.data && !this.looksLikeVideoUrl(slot.data) ? slot.data : "",
    ];

    return candidates.find((url) => !!url) || "";
  };

  getSlotPreviewUrl = (slot) => {
    if (!slot) return "";
    return this.getSlotVideoUrl(slot) || this.getSlotPosterUrl(slot) || slot.data || slot.source_url || "";
  };

  isVideoSlot = (slot) => {
    return !!(
      slot &&
      (
        slot.type === "video" ||
        String(slot.source_type_cd || "").toUpperCase() === "V" ||
        this.looksLikeVideoUrl(slot.data || slot.source_url || slot.video_url || slot.org_video_path || slot.preview_image_url)
      )
    );
  };

  getReducedRatio = (width, height) => {
    const w = Number(width) || 0;
    const h = Number(height) || 0;

    if (w <= 0 || h <= 0) {
      return "";
    }

    const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));
    const divisor = gcd(w, h) || 1;

    return `${w / divisor}/${h / divisor}`;
  };

  getRatioNumber = (ratioStr) => {
    const normalizedRatio = normalizeImageRatio(ratioStr);

    if (!normalizedRatio) {
      return 1;
    }

    const [width, height] = normalizedRatio.split("/").map((value) => Number(value));

    if (!width || !height) {
      return 1;
    }

    return width / height;
  };

  getSlotDisplayRatio = (slot) => {
    if (this.isVideoSlot(slot)) {
      return normalizeImageRatio(
        slot?.video_ratio || slot?.aspect_ratio || slot?.image_ratio || this.state.currentRatio || "9/16"
      ) || "9/16";
    }

    return normalizeImageRatio(this.state.currentRatio || "1/1") || "1/1";
  };

  handleVideoLoadedMetadata = (slotIndex, e) => {
    const video = e && e.currentTarget;
    const width = video && video.videoWidth;
    const height = video && video.videoHeight;
    const videoRatio = this.getReducedRatio(width, height);

    if (!videoRatio || slotIndex < 0) {
      return;
    }

    this.setState((prev) => {
      const imageSlots = [...(prev.imageSlots || [])];
      const targetSlot = imageSlots[slotIndex];

      if (!targetSlot || !this.isVideoSlot(targetSlot)) {
        return null;
      }

      if (targetSlot.video_ratio === videoRatio && prev.currentRatio === videoRatio) {
        return null;
      }

      imageSlots[slotIndex] = {
        ...targetSlot,
        video_ratio: videoRatio,
        video_width: width,
        video_height: height,
      };

      return {
        imageSlots,
        currentRatio: prev.selectedFeedType === "REELS" ? videoRatio : prev.currentRatio,
      };
    });
  };

  getFilledSlots = () => {
    return (this.state.imageSlots || []).filter((s) => this.isFilledSlot(s));
  };

  normalizeVideoSlots = (imageSlots = []) => {
    const filledVideoSlots = (imageSlots || [])
      .filter((slot) => this.isFilledSlot(slot) && this.isVideoSlot(slot))
      .slice(0, 1);

    return filledVideoSlots.length > 0 ? filledVideoSlots : [{ type: null, data: null }];
  };

  normalizeImageSlots = (imageSlots = []) => {
    const filledSlots = (imageSlots || [])
      .filter((slot) => this.isFilledSlot(slot) && !this.isVideoSlot(slot))
      .slice(0, 10);

    if (filledSlots.length >= 10) {
      return filledSlots;
    }

    return [...filledSlots, { type: null, data: null }];
  };

  buildInstagramMediaItemPayload = (slot, itemIndex, isCoverYn = "N") => {
    const s = slot || {};
    const typeCd =
      ((s.type === "upload" || s.type === "video") && "U") ||
      (s.type === "product" && "P") ||
      (s.type === "ai" && "A") ||
      (s.type === "template" && "T") ||
      "U";

    return {
      item_index: itemIndex,
      is_cover_yn: isCoverYn,
      ...(s.media_source_id
        ? { media_source_id: s.media_source_id }
        : { source_type_cd: typeCd, source_url: s.data }),
      event_seq: s.event_seq || null,
      product_no: s.product_no || null,
      stability_call_seq: s.stability_call_seq || null,
      preview_image_url: s.preview_image_url || null,
      ai_studio_history_seq: s.ai_studio_history_seq || null,
      ai_studio_history_step_seq: s.ai_studio_history_step_seq || null,
      ai_studio_history_step_result_seq: s.ai_studio_history_step_result_seq || null,
      ai_video_studio_history_seq: s.ai_video_studio_history_seq || null,
      ai_video_studio_result_seq: s.ai_video_studio_result_seq || null,
    };
  };

  getDraftSlotGroups = () => {
    const isReelsActive = this.state.selectedFeedType === "REELS";
    const feedSourceSlots = isReelsActive ? this.state.feedImageSlots : this.state.imageSlots;
    const reelsSourceSlots = isReelsActive ? this.state.imageSlots : this.state.reelsVideoSlots;

    return {
      feedSlots: this.normalizeImageSlots(feedSourceSlots || []).filter((slot) => this.isFilledSlot(slot)),
      reelsSlots: this.normalizeVideoSlots(reelsSourceSlots || []).filter((slot) => this.isFilledSlot(slot)).slice(0, 1),
    };
  };

  buildDraftItemsPayload = () => {
    const { feedSlots, reelsSlots } = this.getDraftSlotGroups();
    const isReelsActive = this.state.selectedFeedType === "REELS";

    return [
      ...feedSlots.map((slot, idx) =>
        this.buildInstagramMediaItemPayload(slot, idx, !isReelsActive && idx === 0 ? "Y" : "N")
      ),
      ...reelsSlots.map((slot) =>
        this.buildInstagramMediaItemPayload(slot, REELS_ITEM_INDEX, isReelsActive ? "Y" : "N")
      ),
    ];
  };

  updateImageSlotsState = (updater, callback) => {
    this.setState((prev) => {
      const draftSlots =
        typeof updater === "function"
          ? updater([...(prev.imageSlots || [])], prev)
          : updater;

      if (prev.selectedFeedType === "REELS") {
        return {
          imageSlots: this.normalizeVideoSlots(draftSlots),
          selectedFeedType: "REELS",
          currentRatio: prev.currentRatio || "9/16",
          previewSlideIndex: 0,
        };
      }

      const normalizedSlots = this.normalizeImageSlots(draftSlots);
      const nextFeedType = this.getFeedTypeBySlots(normalizedSlots);

      return {
        imageSlots: normalizedSlots,
        selectedFeedType: nextFeedType,
      };
    }, callback);
  };

  isAllImageSlotsEmpty = () => {
    const { imageSlots } = this.state;
    return (imageSlots || []).every((slot) => !this.isFilledSlot(slot));
  };
  

  openImageModal = (index, slot_type) => {
    if (this.state.selectedFeedType === "REELS") {
      this.setState({
        videoSourceModalOpen: true,
        currentImageSlotIndex: index,
      });
      return;
    }

    // 기존 슬롯을 클릭해도 바로 해당 편집기로 들어가지 않고
    // 항상 제작방식 선택 팝업을 거친 뒤 같은 타입을 다시 선택했을 때만 기존 작업을 이어간다.
    if (this.isAllImageSlotsEmpty()) {
      this.setState({ isSizeModalOpen: true, currentImageSlotIndex: index });
    } else {
      this.setState({ imageModalOpen: true, currentImageSlotIndex: index });
    }
  };

  closeImageModal = () => {
    this.setState({ imageModalOpen: false });
  };

  openImageUpload = (idx) => {
    if (!this.fileInputRef.current) return;

    this.fileInputRef.current.accept = "image/*";
    this.fileInputRef.current.onchange = async (e) => {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      this.saveS3Image(idx, file);
    };
    this.fileInputRef.current.click();
  };

  openVideoUpload = (idx) => {
    this.setState({ currentImageSlotIndex: idx }, () => {
      const input = this.fileInputRef.current;
      if (!input) return;

      input.accept = "video/*";

      // 중요: 같은 파일을 다시 선택해도 onchange가 타도록 클릭 전에 초기화
      input.value = "";

      input.onchange = async (e) => {
        const file = e.target.files && e.target.files[0];

        if (!file) {
          e.target.value = "";
          return;
        }

        this.saveS3Video(idx, file);
      };

      input.click();
    });
  };

  closeVideoSourceModal = () => {
    this.setState({ videoSourceModalOpen: false });
  };

  handleVideoSource = (source) => {
    const idx = this.state.currentImageSlotIndex || 0;
    const currentSlot = (this.state.imageSlots || [])[idx] || {};
    const reopenLinkedAiVideo =
      source === "ai" &&
      currentSlot.type === "video" &&
      currentSlot.ai_video_studio_history_seq;

    if (source === "upload") {
      this.setState({
        videoSourceModalOpen: false,
        ai_video_studio_initial_history_seq: "",
        ai_video_studio_initial_result_seq: "",
        ai_video_studio_initial_result_no: "",
      }, () => {
        this.openVideoUpload(idx);
      });
      return;
    }

    if (source === "ai") {
      this.setState({
        videoSourceModalOpen: false,
        show_ai_video_popup: true,
        selectedFeedType: "REELS",
        currentRatio: this.getSlotDisplayRatio(currentSlot) || "9/16",
        currentImageSlotIndex: idx,
        ai_video_studio_initial_prompt: "",
        ai_video_studio_initial_image_url: "",
        ai_video_studio_initial_history_seq: reopenLinkedAiVideo
          ? currentSlot.ai_video_studio_history_seq
          : "",
        ai_video_studio_initial_result_seq: reopenLinkedAiVideo
          ? currentSlot.ai_video_studio_result_seq || ""
          : "",
        ai_video_studio_initial_result_no: reopenLinkedAiVideo
          ? currentSlot.result_no || ""
          : "",
      });
    }
  };

  handleImageSource = (source, event_seq) => {
    const idx = this.state.currentImageSlotIndex;
    const currentSlot = (this.state.imageSlots || [])[idx] || {};

    if (source === "upload") {
      this.setState({
        ai_studio_initial_history_seq: "",
        ai_studio_initial_history_step_seq: "",
        ai_studio_initial_result_seq: "",
        ai_studio_initial_result_no: "",
        ai_studio_initial_result_image_url: "",
      });
      this.openImageUpload(idx);
    } else if (source === "product") {
      this.setState({ show_add_product_popup: true }, () => {
        this.closeImageModal();
      });
    } else if (source === "ai") {
      const reopenLinkedAiStudio =
        currentSlot.type === "ai" &&
        currentSlot.ai_studio_history_seq;

      this.setState({
        show_robo_img_popup: true,
        ai_studio_initial_prompt: "",
        ai_studio_initial_image_url: "",
        ai_studio_initial_history_seq: reopenLinkedAiStudio
          ? currentSlot.ai_studio_history_seq
          : "",
        ai_studio_initial_history_step_seq: reopenLinkedAiStudio
          ? currentSlot.ai_studio_history_step_seq || ""
          : "",
        ai_studio_initial_result_seq: reopenLinkedAiStudio
          ? currentSlot.ai_studio_history_step_result_seq || ""
          : "",
        ai_studio_initial_result_no: reopenLinkedAiStudio
          ? currentSlot.result_no || ""
          : "",
        ai_studio_initial_result_image_url: reopenLinkedAiStudio
          ? currentSlot.data || currentSlot.source_url || ""
          : "",
      }, () => {
        this.closeImageModal();
      });
    } else if (source === "template") {
      const reopenLinkedTemplate = currentSlot.type === "template";
      this.setState({
        show_design_template_popup: true,
        selected_event_seq: reopenLinkedTemplate ? (currentSlot.event_seq || "") : "",
      }, () => {
        this.closeImageModal();
      });
    } else {
      this.updateImageSlotsState((imageSlots) => {
        imageSlots[idx] = { type: source, data: null };
        return imageSlots;
      });
    }
    this.closeImageModal();
  };

  deleteImageAt = (e, index) => {
    e.stopPropagation();

    this.updateImageSlotsState((imageSlots) => {
      imageSlots.splice(index, 1);
      return imageSlots;
    }, () => {
      if (this.fileInputRef?.current) this.fileInputRef.current.value = "";
    });
  };

  saveS3Image = (idx, file) => {
    this.setState({ save_dialog_show_state: true });
    const config = { headers: { 'Content-Type': 'multipart/form-data' } }
    const formData = new FormData();
    formData.append("files", file);
    formData.append("ratio", this.state.currentRatio ? this.state.currentRatio : "1/1");
        
    http.post("/rest/shop/instagram/resizeOrgImg", formData, config)
    .then(res => {
        const url = res.data.org_img_path;
        this.updateImageSlotsState((imageSlots) => {
          imageSlots[idx] = { type: "upload", data: url };
          return imageSlots;
        }, () => { 
          if (this.fileInputRef?.current) this.fileInputRef.current.value = "";
        });
        this.setState({ save_dialog_show_state: false });
      }).catch(error => {
        console.log (error);
        this.setState({ save_dialog_show_state: false });
      })
  }

  saveS3Video = (idx, file) => {
    this.setState({
      save_dialog_show_state: true,
      save_dialog_content: "동영상을 업로드 중입니다."
    });

    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    const formData = new FormData();
    formData.append("files", file);

    http.post("/rest/shop/instagram/uploadVideo", formData, config)
      .then(res => {
        const url = res.data.org_video_path || res.data.video_url || res.data.org_img_path;

        if (!url) {
          throw new Error("동영상 업로드 URL이 없습니다.");
        }

        this.setState({
          imageSlots: [{ type: "video", data: url }],
          selectedFeedType: "REELS",
          currentRatio: "9/16",
          previewSlideIndex: 0,
          save_dialog_show_state: false,
        });
      })
      .catch(error => {
        console.log(error);

        this.setState({
          save_dialog_show_state: false,
          warning_dialog_show_state: true,
          warning_dialog_content: "동영상 업로드에 실패했습니다."
        });
      })
      .finally(() => {
        // 중요: 성공/실패 상관없이 초기화
        if (this.fileInputRef?.current) {
          this.fileInputRef.current.value = "";
        }
      });
  };

  onChangeCaption = (e) => this.setCaption(e.target.value);

  showEmojiPicker = () => {
    this.setState((prev) => ({ emojiPickerVisible: !prev.emojiPickerVisible }));
  };

  handleEmojiSelect = (emoji) => {
    const textarea = this.captionTextareaRef.current;
    if (!textarea) return;
    const { selectionStart, selectionEnd } = textarea;
    const before = this.state.caption.slice(0, selectionStart);
    const after = this.state.caption.slice(selectionEnd);
    const newCaption = before + emoji.native + after;

    this.setCaption(newCaption, () => {
      const pos = selectionStart + emoji.native.length;
      textarea.selectionStart = textarea.selectionEnd = pos;
      textarea.focus();
    });
    this.setState({ emojiPickerVisible: false });
  };

  useSuggestion = (label) => {
    const { aiRecommendations = [] } = this.state;
    const found = aiRecommendations.find((r) => r.label === label);
    const text = found?.text?.trim?.() || "문구를 찾지 못했어요.";
    this.setCaption(text);
    this.setState({ selectedLabel: label, aiSuggestionsVisible: true });
  };

  generateAIHashtags = async () => {
    // fixedTags, manualTags 대신 실제 적용 중인 tags 배열을 가져옵니다.
    const { caption, tags } = this.state;
    
    if (!caption || !caption.trim()) {
      // alert("피드 문구를 입력해주세요.\n(문구를 기반으로 해시태그를 생성합니다.)");
      this.setState({ 
        warning_dialog_show_state: true,
        warning_dialog_content: "피드 문구를 작성해주세요.<br/>(문구를 기반으로 해시태그를 생성합니다.)"
      });
      return;
    }
    
    this.setState({ save_dialog_show_state: true, save_dialog_content: "인공지능이 해시태그를 생성중입니다..."  });

    try {
      const { data } = await http.post("/rest/shop/instagram/GptRecommamdHashtag",
        // 이미 본문에 추가된 태그들(tags)을 전달하여 중복 추천을 방지
        { create_cnt : this.state.hashtag_setting_count ? this.state.hashtag_setting_count: 5, user_prompt: caption, alreadyUsedHashtags: tags },
        { headers: { "Content-Type": "application/json" } }
      );
      
      const hashtags = Array.isArray(data?.hashtags) ? data.hashtags : [];
      
      // AI가 생성한 태그를 실제 화면에 렌더링되는 tags 배열에 직접 병합 (중복 방지 로직 포함)
      this.setState(prev => {
        const newTags = [...prev.tags];
        hashtags.forEach(tag => {
            if (!newTags.includes(tag)) {
                newTags.push(tag);
            }
        });
        return {
          tags: newTags,
          gpt_hashtag_seq : data?.gpt_call_seq || null,
        };
      });
      
    } catch (err) {
      console.error("AI 해시태그 생성 실패:", err);
      alert("추천 해시태그 생성에 실패했습니다. 잠시 후 다시 시도해주세요.");
    } finally {
      this.setState({ save_dialog_show_state: false });
      
      // 혹시 응답에 usage 값이 안 왔을 때를 대비해 한 번 더 동기화
      // this.loadGptUsage(); // 이제 문구 생성을 카피라이터 팝업 안에서 하기 때문에 실행하지 않음
    }
  };

  onChangeTopic = (e) => this.setState({ topicInput: e.target.value });

  addHashtagOnEnter = (e) => {
    if (e.key === "Enter") {
      if (this.isComposing) return;
      e.preventDefault();
      let valueRaw = e.target.value.trim();
      if (!valueRaw) return;
      valueRaw = this.sanitizeHashtag(valueRaw);
      const value = valueRaw.startsWith("#") ? valueRaw : `#${valueRaw}`;
      this.setState((prev) => {
        if (prev.tags.includes(value)) return null;
        return { tags: [...prev.tags, value], inputHashtagValue: "" };
      });
      e.target.value = "";
    }
  };

  // sanitizeHashtag = (raw) => {
  //   const value = raw.replace(/[^A-Za-z0-9ㄱ-ㅎㅏ-ㅣ가-힣_]/g, '');
  //   return raw.startsWith("#") ? `#${value}` : value;
  // };

  sanitizeHashtag = (raw) => {
    return raw
      .split(' ') // 1. 띄어쓰기 기준으로 각 태그를 나눔
      .map((tag) => {
        // 2. 빈 문자열(연속된 공백) 방지
        if (!tag) return ''; 

        const hasHash = tag.startsWith('#');
        
        // 3. '#'를 제외하고 허용된 문자만 남김
        // (정규식에서 '#'이 포함되지 않았으므로, 여기서 '#'이 같이 제거되지 않게 주의)
        const cleanContent = tag.replace(/[^A-Za-z0-9ㄱ-ㅎㅏ-ㅣ가-힣_]/g, '');
        
        // 4. 원래 '#'가 있었다면 다시 붙여줌
        return hasHash ? `#${cleanContent}` : cleanContent;
      })
      .filter((tag) => tag !== '') // 5. 중간에 발생한 빈 값 제거
      .join(' '); // 6. 다시 띄어쓰기로 합침
  };


  handlePasteHashtag = (e) => {
    e.preventDefault();
    const paste = (e.clipboardData || window.clipboardData).getData("text");
    const noSpace = paste.replace(/\s+/g, "");
    const target = e.target;
    let newValue = this.sanitizeHashtag(noSpace);
    target.value = newValue;
  };

  removeTagAt = (i) => {
    this.setState((prev) => {
      const tags = [...prev.tags];
      tags.splice(i, 1);
      return { tags };
    });
  };

  selectPublishOption = (type) => this.setState({ publishOption: type });
  onChangeDatePicker = (date) => this.setState({ scheduledDate: date ? format(date, "yyyy-MM-dd") : "" });
  onChangeTimePicker = (date) => this.setState({ scheduledTime: date ? format(date, "HH:mm") : "" });

  getDateObjForDate = () => {
    const { scheduledDate, scheduledTime } = this.state;
    if (!scheduledDate) return null;
    const time = scheduledTime || "00:00";
    return new Date(`${scheduledDate}T${time}:00`);
  };

  getDateObjForTime = () => {
    const { scheduledDate, scheduledTime } = this.state;
    const baseDate = scheduledDate ? scheduledDate : format(new Date(), "yyyy-MM-dd");
    const time = scheduledTime || "00:00";
    return new Date(`${baseDate}T${time}:00`);
  };

  // ==============================
  // 발행용 검증
  // - 즉시발행 / 예약발행 전용
  // ==============================
  validateForPublish = () => {
    const {
      publishOption,
      caption,
      tags,
      scheduledDate,
      scheduledTime,
      imageSlots,
      selectedFeedType,
    } = this.state;

    const { instagramPublishEnabled, threadsPublishEnabled } = this.state;
    if (!instagramPublishEnabled && !threadsPublishEnabled) {
      return "발행할 채널을 선택해주세요.";
    }

    if (instagramPublishEnabled) {
      const igAccessSeq = this.getPublishAccountSeq();
      if (!this.isValidIgSeq(igAccessSeq)) {
        return "발행할 Instagram 계정을 선택해주세요.";
      }
    }

    if (threadsPublishEnabled) {
      const threadsAccessSeq = this.getThreadsPublishAccountSeq();
      if (!this.isValidThreadsSeq(threadsAccessSeq)) {
        return "발행할 Threads 계정을 선택해주세요.";
      }
    }

    const filled = (imageSlots || []).filter((s) => s && (s.media_source_id || s.data));
    const threadsTextOnly = threadsPublishEnabled && !instagramPublishEnabled && filled.length === 0;
    if (filled.length === 0 && !threadsTextOnly) {
      return selectedFeedType === "REELS"
        ? "최소 한 개 이상의 동영상이 필요합니다."
        : "최소 한 개 이상의 이미지가 필요합니다.";
    }

    if (!threadsTextOnly && selectedFeedType === "REELS") {
      if (filled.length !== 1) {
        return "릴스는 동영상 1개만 등록할 수 있습니다.";
      }
      if (!this.isVideoSlot(filled[0])) {
        return "릴스는 동영상 파일만 등록할 수 있습니다.";
      }
    } else if (!threadsTextOnly) {
      if (filled.some((slot) => this.isVideoSlot(slot))) {
        return "피드는 이미지 파일만 등록할 수 있습니다.<br/>동영상은 릴스로 등록해주세요.";
      }
      if (selectedFeedType === "CAROUSEL" && filled.length < 2) {
        return "슬라이드 이미지인 경우 최소 2개의 이미지가 필요합니다.";
      }
    }

    const itemError = this.validateItems(filled, selectedFeedType);
    if (itemError) {
      return itemError;
    }

    const {
      normalizedCaption,
      normalizedTags,
      tagCount,
      totalLength,
    } = this.getCaptionAndTagLengthInfo(caption, tags);

    if (!normalizedCaption) {
      return "문구를 작성해주세요.";
    }

    if (tagCount > 30) {
      return `해시태그는 최대 30개까지만 등록할 수 있습니다.<br/>(현재 ${tagCount}개 작성)`;
    }

    if (totalLength > 2200) {
      return `본문과 해시태그를 합친 총 글자 수는<br/>2,200자를 초과할 수 없습니다.<br/>(현재 ${totalLength.toLocaleString()}자 작성)`;
    }

    if (publishOption === "SCHEDULED") {
      if (!scheduledDate || !scheduledTime) {
        return "날짜와 시간을 선택해주세요.";
      }

      const now = new Date();
      const scheduled = new Date(`${scheduledDate}T${scheduledTime}:00`);

      if (!(scheduled.getTime() > now.getTime())) {
        return "예약 시각은 현재보다 이후여야 합니다.";
      }

      // 최소 5분 이후만 허용하려면 사용
      // const minTime = new Date(Date.now() + 5 * 60 * 1000);
      // if (scheduled.getTime() <= minTime.getTime()) {
      //   return "예약 시각은 현재보다 최소 5분 이후여야 합니다.";
      // }
    }

    return "";
  };

  validateItems = (items, selectedFeedType = this.state.selectedFeedType) => {
    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (!item.media_source_id && !item.data) {
        return selectedFeedType === "REELS"
          ? `${i + 1}번 동영상이 비어있습니다.`
          : `${i + 1}번 이미지가 비어있습니다.`;
      }

      if (!item.type) {
        return selectedFeedType === "REELS"
          ? `${i + 1}번 동영상 타입이 없습니다.`
          : `${i + 1}번 이미지 타입이 없습니다.`;
      }

      if (selectedFeedType === "REELS" && !this.isVideoSlot(item)) {
        return `${i + 1}번은 동영상 파일이 아닙니다.`;
      }

      if (selectedFeedType !== "REELS" && this.isVideoSlot(item)) {
        return `${i + 1}번은 동영상입니다. 동영상은 릴스로 등록해주세요.`;
      }

      // if (item.type === "ai" && !item.stability_call_seq) {
      //   return `${i + 1}번 AI 이미지 정보가 없습니다.`;
      // }

      if (item.type === "product" && !item.product_no) {
        return `${i + 1}번 상품 정보가 없습니다.`;
      }

      if (item.type === "template" && !item.event_seq) {
        return `${i + 1}번 템플릿 정보가 없습니다.`;
      }
    }

    return null;
  };


  // ==============================
  // 드래프트용 검증
  // - 임시저장은 느슨하게
  // ==============================
  validateForDraft = () => {
    const { caption, tags, imageSlots, selectedFeedType } = this.state;

    const filled = (imageSlots || []).filter((s) => s && (s.media_source_id || s.data));

    const itemError = this.validateItems(filled, selectedFeedType);
    if (itemError) {
      return itemError;
    }

    const { tagCount, totalLength } = this.getCaptionAndTagLengthInfo(caption, tags);

    if (tagCount > 30) {
      return `해시태그는 최대 30개까지만 등록할 수 있습니다.<br/>(현재 ${tagCount}개 작성)`;
    }

    if (totalLength > 2200) {
      return `본문과 해시태그를 합친 총 글자 수는<br/>2,200자를 초과할 수 없습니다.<br/>(현재 ${totalLength.toLocaleString()}자 작성)`;
    }

    return "";
  };

  getCaptionAndTagLengthInfo = (caption, tags) => {
    // 1. caption 정리
    const normalizedCaption = (caption || "").trim();

    // 2. tags 정리 (빈값 제거 + trim)
    const normalizedTags = (tags || [])
      .map(tag => (tag || "").trim())
      .filter(tag => tag.length > 0);

    // 3. 해시태그 개수
    const tagCount = normalizedTags.length;

    // 4. 해시태그 문자열
    const hashtagText = normalizedTags.join(" ");

    // 5. 총 길이 계산
    // caption + (공백 1개 + hashtags)
    const totalLength =
      normalizedCaption.length +
      (hashtagText.length > 0 ? hashtagText.length + 1 : 0);

    return {
      normalizedCaption,
      normalizedTags,
      tagCount,
      totalLength,
    };
  };

  publishPost = async () => {
    try {
      const validateMessage = this.validateForPublish();
      if (validateMessage) {
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: validateMessage
        });
        return;
      }

      const {
        publishOption,
        caption,
        tags,
        scheduledDate,
        scheduledTime,
        imageSlots,
        gpt_caption_seq,
        gpt_hashtag_seq,
        aiRecommendations,
        selectedLabel,
        media_id,
        selectedFeedType
      } = this.state;

      const igAccessSeq = this.getPublishAccountSeq();
      const filled = (imageSlots || []).filter((s) => s && (s.media_source_id || s.data));
      const { normalizedCaption, normalizedTags } = this.getCaptionAndTagLengthInfo(caption, tags);

      const items = filled.map((s, idx) =>
        this.buildInstagramMediaItemPayload(
          s,
          selectedFeedType === "REELS" ? REELS_ITEM_INDEX : idx,
          idx === 0 ? "Y" : "N"
        )
      );

      const payload = {
        instagram_access_token_seq: this.state.instagramPublishEnabled ? igAccessSeq : null,
        threads_access_token_seq: this.state.threadsPublishEnabled ? this.getThreadsPublishAccountSeq() : null,
        instagram_publish_yn: this.state.instagramPublishEnabled ? "Y" : "N",
        threads_publish_yn: this.state.threadsPublishEnabled ? "Y" : "N",
        caption: normalizedCaption,
        hashtags: normalizedTags,
        media_type_cd:
          (!this.state.instagramPublishEnabled && this.state.threadsPublishEnabled && items.length === 0)
            ? "T"
            : selectedFeedType === "CAROUSEL"
            ? "C"
            : selectedFeedType === "REELS"
            ? "R"
            : "S",
        items,
        gpt_caption_seq: gpt_caption_seq || null,
        gpt_hashtag_seq: gpt_hashtag_seq || null,
        gpt_caption_suggestions: aiRecommendations ? JSON.stringify(aiRecommendations) : "[]",
        gpt_caption_selected_suggestions: selectedLabel || "",
        instagram_media_seq: media_id || null,
        image_ratio: this.state.currentRatio || "1/1",
        copywriter_preset_seq: this.state.copywriter_preset_seq || null,
        ...this.buildReelsAudioPayload(selectedFeedType, this.state.reelsAudio),
      };

      if (publishOption === "SCHEDULED") {
        this.setState({
          save_dialog_show_state: true,
          save_dialog_content: "콘텐츠 예약 중입니다."
        });

        payload.scheduled_at = `${scheduledDate}T${scheduledTime}`;

        const { data } = await http.post("/rest/shop/instagram/reservations", payload);

        this.setState({ save_dialog_show_state: false });

        if (!data || data.ok !== true) {
          alert(data && data.error ? data.error : "예약 생성 실패");
          return;
        }

        this.setState({
          basic_dialog_show_state: true,
          basic_dialog_content: "콘텐츠 예약이 완료되었습니다."
        });
        this.loadInstagramMediaDetail(data.reservation_id, true);

      } else if (publishOption === "NOW") {
        this.setState({
          save_dialog_show_state: true,
          save_dialog_content: "콘텐츠 공유 중입니다."
        });

        let commonMediaId = media_id || null;
        let instagramPublished = false;

        if (this.state.instagramPublishEnabled) {
          const { data } = await http.post("/rest/shop/instagram/media/publish-now", payload);

          if (!data || data.ok !== true) {
            this.setState({ save_dialog_show_state: false });
            alert(data && data.error ? data.error : "Instagram 콘텐츠 공유 실패");
            return;
          }

          commonMediaId = data.media_id || commonMediaId;
          instagramPublished = true;
        } else {
          commonMediaId = await this.saveCommonMediaForThreadsOnlyNow(payload);
        }

        if (this.state.threadsPublishEnabled) {
          try {
            await this.publishThreadsFromCommonMedia(commonMediaId);
          } catch (threadsError) {
            this.setState({ save_dialog_show_state: false });
            const prefix = instagramPublished
              ? "Instagram 발행은 완료되었지만 Threads 발행에 실패했습니다.<br/>"
              : "Threads 발행에 실패했습니다.<br/>";
            this.setState({
              warning_dialog_show_state: true,
              warning_dialog_content: `${prefix}${threadsError.message || ""}`
            });
            return;
          }
        }

        this.setState({ save_dialog_show_state: false });

        this.setState({
          basic_dialog_show_state: true,
          basic_dialog_content: "콘텐츠 공유가 완료되었습니다.",
          basic_dialog_button_list: [{
            title: "확인",
            event_method: () => {
              window.location.href = "/shop/instagram/InstagramPostList";
            }
          }]
        });
      }
    } catch (err) {
      this.setState({ save_dialog_show_state: false });
      console.error(err);
      alert(err.message || "발행 중 오류 발생");
    }
  };

  draftPost = async () => {
    try {
      const validateMessage = this.validateForDraft();
      if (validateMessage) {
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: validateMessage
        });
        return;
      }

      const { imageSlots, is_draft, ...rest } = this.state;
      const filled = (imageSlots || []).filter((s) => s && (s.media_source_id || s.data));
      const { feedSlots, reelsSlots } = this.getDraftSlotGroups();
      const hasAnyDraftMedia = feedSlots.length > 0 || reelsSlots.length > 0;

      if (!hasAnyDraftMedia) {
        this.setState({
          confirm_dialog_show_state: true,
          confirm_dialog_content: this.state.selectedFeedType === "REELS" ? "동영상 없이 임시 저장할까요?" : "이미지 없이 임시 저장할까요?",
          confirm_dialog_button_list: [
            {
              title: "네",
              type: "1",
              event_method: () => {
                this.setState({ confirm_dialog_show_state: false });
                this.handleConfirmDraftSave(rest, filled);
              }
            },
            {
              title: "아니요",
              type: "2",
              event_method: () => {
                this.setState({ confirm_dialog_show_state: false });
              }
            }
          ]
        });
        return;
      }

      if (this.state.is_draft === "N") {
        this.setState({
          confirm_dialog_show_state: true,
          confirm_dialog_content: "콘텐츠을 임시저장 상태로 되돌리시겠습니까?<br/>발행은 중단되고, 수정만 가능한 상태가 됩니다.",
          confirm_dialog_button_list: [
            {
              title: "네",
              type: "1",
              event_method: () => {
                this.setState({ confirm_dialog_show_state: false });
                this.handleConfirmDraftSave(rest, filled);
              }
            },
            {
              title: "아니요",
              type: "2",
              event_method: () => {
                this.setState({ confirm_dialog_show_state: false });
              }
            }
          ]
        });
        return;
      }

      this.handleConfirmDraftSave(rest, filled);
    } catch (err) {
      console.error(err);
      alert(err.message || "임시 저장 중 오류 발생");
    }
  };

  handleConfirmDraftSave = async (state, filled) => {
    try {
        this.setState({ save_dialog_show_state: true, save_dialog_content: "임시 저장 중입니다." });
        const { publishOption, selected_ig_access_seq, default_ig_access_seq, caption, tags, scheduledDate, scheduledTime, gpt_caption_seq, gpt_hashtag_seq, aiRecommendations, selectedLabel, selectedFeedType, media_id } = state;

        const items = this.buildDraftItemsPayload();

        const now = new Date();
        const defaultDate = now.toISOString().split("T")[0];
        const defaultTime = now.toTimeString().split(" ")[0].slice(0, 5);

        const payload = {
            instagram_access_token_seq: this.state.instagramPublishEnabled ? (this.getPublishAccountSeq() || null) : null,
            threads_access_token_seq: this.state.threadsPublishEnabled ? (this.getThreadsPublishAccountSeq() || null) : null,
            instagram_publish_yn: this.state.instagramPublishEnabled ? "Y" : "N",
            threads_publish_yn: this.state.threadsPublishEnabled ? "Y" : "N",
            caption: caption || null, hashtags: tags || [],
            scheduled_at: `${scheduledDate || defaultDate}T${scheduledTime || defaultTime}`,
            post_type: publishOption,
            media_type_cd: (!this.state.instagramPublishEnabled && this.state.threadsPublishEnabled && items.length === 0)
              ? "T" : selectedFeedType === "CAROUSEL" ? "C" : selectedFeedType === "REELS" ? "R" : "S",
            items, gpt_caption_seq: gpt_caption_seq || null, gpt_hashtag_seq: gpt_hashtag_seq || null,
            gpt_caption_suggestions: aiRecommendations ? JSON.stringify(aiRecommendations) : "[]",
            gpt_caption_selected_suggestions: selectedLabel || "",
            image_ratio: this.state.currentRatio || "1/1",
            copywriter_preset_seq: this.state.copywriter_preset_seq || null,
            // 임시저장은 현재 탭과 관계없이 릴스 음악 상태도 함께 보존한다.
            ...this.buildReelsAudioPayload("REELS", this.state.reelsAudio),
        };

        const url = media_id ? `/rest/shop/instagram/media/drafts/${media_id}` : `/rest/shop/instagram/media/drafts`;
        const { data } = media_id ? await http.put(url, payload) : await http.post(url, payload);

        this.setState({ save_dialog_show_state: false });
        if (!data || data.ok !== true) { alert("임시 저장에 실패하였습니다."); return; }

        this.setState({ basic_dialog_show_state: true, basic_dialog_content: "임시 저장이 완료되었습니다.", media_id: data.media_id, lastDraftId: data.media_id });
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set("media_id", data.media_id);
        window.history.replaceState({}, "", newUrl);
        this.loadInstagramMediaDetail(data.media_id, true);
    } catch (err) {
        console.error(err);
        this.setState({ save_dialog_show_state: false });
        alert("임시 저장 중 오류 발생");
    }
  };

  getFilledIndices = () => {
    return (this.state.imageSlots || [])
      .map((s, idx) => (this.isFilledSlot(s) ? idx : null))
      .filter((v) => v !== null);
  };

  moveImage = (i, direction) => {
    const filled = this.getFilledIndices();
    const pos = filled.indexOf(i);
    if (pos < 0) return;

    const targetPos = pos + direction;
    if (targetPos < 0 || targetPos >= filled.length) return;

    const j = filled[targetPos];

    this.updateImageSlotsState((imageSlots) => {
      const temp = imageSlots[i];
      imageSlots[i] = imageSlots[j];
      imageSlots[j] = temp;
      return imageSlots;
    });
  };

  renderImageSlots() {
    const { imageSlots } = this.state;
    const BASE_HEIGHT = 100;

    const firstVideoSlot = (imageSlots || []).find((slot) => this.isFilledSlot(slot) && this.isVideoSlot(slot));
    const gridRatio = this.state.selectedFeedType === "REELS" && firstVideoSlot
      ? this.getSlotDisplayRatio(firstVideoSlot)
      : this.state.currentRatio;
    const currentRatioValue = this.getRatioNumber(gridRatio);
    const minWidth = BASE_HEIGHT * currentRatioValue;
    const finalMinWidth = Math.max(minWidth, 100);

    return (
      <>
        <div
          className="slot-container"
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(auto-fill, minmax(${finalMinWidth}px, 1fr))`,
            gap: 12,
            maxWidth: "100%"
          }}
        >
          {imageSlots.map((slot, i) => {
            const filled = this.isFilledSlot(slot);
            const isVideo = this.isVideoSlot(slot);
            const isReelsSlot = this.state.selectedFeedType === "REELS";
            const slotAspectRatio = filled && isVideo
              ? this.getSlotDisplayRatio(slot)
              : (this.state.currentRatio ? this.state.currentRatio : "1 / 1");

            const bg = filled && !isVideo
              ? {
                  backgroundImage: `url(${slot.data})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center"
                }
              : { background: filled && isVideo ? "#111827" : "#f3f4f6" };

            return (
              <div
                key={i}
                data-instagram-tutorial={i === 0
                  ? (this.state.selectedFeedType === "REELS" ? "post-reels-slot" : "post-feed-slot")
                  : undefined}
                className={`
                  image-slot
                  ${i === 0 ? "primary" : ""}
                  ${filled ? "filled" : "slot-add has-tooltip"}
                `}
                onClick={() => this.openImageModal(i, slot.type)}
                style={{
                  aspectRatio: slotAspectRatio,
                  border: filled ? "2px solid #00e2e6" : "2px dashed #cbd5e1",
                  borderRadius: 12,
                  display: "flex",
                  alignItems: filled ? "flex-start" : "center",
                  justifyContent: filled ? "right" : "center",
                  position: "relative",
                  minWidth: 100,
                  padding: "5px 5px",
                  cursor: "pointer",
                  transition: "0.2s",
                  ...bg
                }}
              >
                {filled ? (
                  <>
                    {isVideo && (() => {
                      const videoUrl = this.getSlotVideoUrl(slot);
                      const posterUrl = this.getSlotPosterUrl(slot);

                      if (videoUrl) {
                        return (
                          <video
                            src={videoUrl}
                            poster={posterUrl || undefined}
                            controls={!isReelsSlot}
                            muted
                            playsInline
                            preload="metadata"
                            style={{
                              position: "absolute",
                              inset: 0,
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              borderRadius: 10,
                              background: "#111827",
                              pointerEvents: isReelsSlot ? "none" : "auto"
                            }}
                            onLoadedMetadata={(e) => this.handleVideoLoadedMetadata(i, e)}
                            onClick={(e) => {
                              if (!isReelsSlot) e.stopPropagation();
                            }}
                          />
                        );
                      }

                      if (posterUrl) {
                        return (
                          <img
                            src={posterUrl}
                            alt="동영상 썸네일"
                            style={{
                              position: "absolute",
                              inset: 0,
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              borderRadius: 10,
                              background: "#111827",
                              pointerEvents: isReelsSlot ? "none" : "auto"
                            }}
                            onClick={(e) => {
                              if (!isReelsSlot) e.stopPropagation();
                            }}
                          />
                        );
                      }

                      return null;
                    })()}
                    {isReelsSlot && isVideo ? (
                      <button
                        type="button"
                        className="reels-slot-click-overlay"
                        aria-label="동영상 변경"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.openImageModal(i, slot.type);
                        }}
                        style={{
                          position: "absolute",
                          inset: 0,
                          zIndex: 2,
                          padding: 0,
                          border: 0,
                          borderRadius: 10,
                          background: "transparent",
                          cursor: "pointer"
                        }}
                      />
                    ) : null}
                    {!isReelsSlot ? (
                    <span
                      className="slot-number"
                      style={{
                        position: "absolute",
                        top: 8,
                        left: 8,
                        background: "rgba(10,26,47,0.7)",
                        color: "#fff",
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 11
                      }}
                    >
                      {i + 1}
                    </span>
                    ) : null}

                    <div
                      className="order-controls"
                      onClick={(e) => e.stopPropagation()}
                      style={{ position: "relative", zIndex: 4 }}
                    >
                      {this.state.selectedFeedType !== "REELS" ? (() => {
                        const filledIdx = this.getFilledIndices();
                        const pos = filledIdx.indexOf(i);
                        const isFirst = pos === 0;
                        const isLast = pos === filledIdx.length - 1;

                        return (
                          <>
                            <button
                              className="order-btn up"
                              disabled={isFirst}
                              onClick={() => this.moveImage(i, -1)}
                              style={{
                                width: 24,
                                height: 24,
                                borderRadius: "50%",
                                background: "rgba(255,255,255,0.95)",
                                border: "1px solid #00e2e6",
                                color: "#00e2e6",
                                cursor: isFirst ? "not-allowed" : "pointer",
                                fontWeight: 700
                              }}
                            >
                              ▲
                            </button>
                            <button
                              className="order-btn down"
                              disabled={isLast}
                              onClick={() => this.moveImage(i, +1)}
                              style={{
                                width: 24,
                                height: 24,
                                borderRadius: "50%",
                                background: "rgba(255,255,255,0.95)",
                                border: "1px solid #00e2e6",
                                color: "#00e2e6",
                                cursor: isLast ? "not-allowed" : "pointer",
                                fontWeight: 700
                              }}
                            >
                              ▼
                            </button>
                          </>
                        );
                      })() : null}

                      <button
                        className="delete-btn"
                        onClick={(e) => this.deleteImageAt(e, i)}
                        style={{
                          width: 24,
                          height: 24,
                          borderRadius: "50%",
                          background: "rgba(255,255,255,0.9)",
                          border: "1px solid #dc2626",
                          color: "#dc2626",
                          cursor: "pointer",
                          fontSize: 18,
                          lineHeight: 1
                        }}
                      >
                        ×
                      </button>
                    </div>

                    <span
                      className="image-source-badge"
                      style={{
                        position: "absolute",
                        left: 8,
                        bottom: 8,
                        width: "fit-content",
                        color: "#fff",
                        fontWeight: 700,
                        textShadow: "0 1px 2px rgba(0,0,0,.35)",
                        fontSize: 12,
                        background: "rgba(10, 26, 47, 0.7)",
                        zIndex: 3,
                      }}
                    >
                      {slot.type === "video"
                        ? "동영상"
                        : slot.type === "upload"
                        ? "업로드"
                        : slot.type === "product"
                        ? "상품"
                        : slot.type === "ai"
                        ? "AI"
                        : slot.type === "template"
                        ? "템플릿"
                        : ""}
                    </span>
                  </>
                 ) : (
                  <>
                    <div style={{ textAlign: "center", width: "100%" }}>
                      <div style={{ 
                          // fontSize: "28px", 
                          color: "#9ca3af" 
                        }}>
                        {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M21 15V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V15ZM19.5 4.5V13.1906L16.8094 10.5C16.527 10.2217 16.1464 10.0658 15.75 10.0658C15.3536 10.0658 14.973 10.2217 14.6906 10.5L10.5 14.6906L8.55938 12.75C8.27698 12.4717 7.89645 12.3158 7.5 12.3158C7.10355 12.3158 6.72302 12.4717 6.44062 12.75L4.5 14.6906V4.5H19.5ZM19.5 19.5H4.5V16.8094L7.5 13.8094L9.44062 15.75C9.72302 16.0283 10.1036 16.1842 10.5 16.1842C10.8964 16.1842 11.277 16.0283 11.5594 15.75L15.75 11.5594L19.5 15.3094V19.5ZM8.57812 9.42188C8.47332 9.31744 8.39034 9.19321 8.33401 9.0564C8.27768 8.91959 8.24912 8.77295 8.25 8.625C8.25 8.32663 8.36853 8.04048 8.5795 7.8295C8.79048 7.61853 9.07663 7.5 9.375 7.5C9.67337 7.5 9.95952 7.61853 10.1705 7.8295C10.3815 8.04048 10.5 8.32663 10.5 8.625C10.5 8.92337 10.3815 9.20952 10.1705 9.4205C9.95952 9.63147 9.67337 9.75 9.375 9.75C9.07695 9.74772 8.79136 9.63013 8.57812 9.42188Z" fill="#333333"/>
                        </svg> */}
                        {
                          this.state.selectedFeedType === "REELS"
                          ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M15.6662 12.923L11.1662 9.92299C11.0533 9.84761 10.9219 9.80433 10.7863 9.79775C10.6506 9.79118 10.5157 9.82157 10.396 9.88567C10.2763 9.94977 10.1762 10.0452 10.1064 10.1617C10.0367 10.2783 9.99991 10.4115 10 10.5474V16.5474C9.99991 16.6832 10.0367 16.8165 10.1064 16.933C10.1762 17.0495 10.2763 17.145 10.396 17.2091C10.5157 17.2732 10.6506 17.3035 10.7863 17.297C10.9219 17.2904 11.0533 17.2471 11.1662 17.1717L15.6662 14.1717C15.7691 14.1033 15.8535 14.0105 15.9118 13.9015C15.9702 13.7926 16.0007 13.6709 16.0007 13.5474C16.0007 13.4238 15.9702 13.3021 15.9118 13.1932C15.8535 13.0843 15.7691 12.9915 15.6662 12.923ZM11.5 15.1458V11.9536L13.8981 13.5474L11.5 15.1458Z" fill="#333333"/>
                              <path d="M13.4 3H5.23677C4.64354 3 4.07461 3.23955 3.65514 3.66595C3.23566 4.09235 3 4.67067 3 5.27368V18.7263C3 19.3293 3.23566 19.9077 3.65514 20.3341C4.07461 20.7605 4.64354 21 5.23677 21H18.7632C19.3565 21 19.9254 20.7605 20.3449 20.3341C20.7643 19.9077 21 19.3293 21 18.7263V12.2" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M4.5 7.5H14.2" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                              <path d="M7 4L9 7.4641" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                              <path d="M11 4L13 7.4641" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                              <path d="M19 3V9" stroke="#333333" stroke-width="2" stroke-linecap="round"/>
                              <path d="M16 6H22" stroke="#333333" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                          : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.19739 20.9343L15.256 12.4086L19.5188 16.6714M6.19739 20.9343H16.8545C18.6203 20.9343 20.0517 19.5029 20.0517 17.7371V12.4086M6.19739 20.9343C4.43165 20.9343 3.00024 19.5029 3.00024 17.7371V7.08001C3.00024 5.31427 4.43165 3.88287 6.19739 3.88287H13.1245M18.986 9.02859L18.986 6.01429M18.986 6.01429L18.986 3M18.986 6.01429L15.9717 6.01429M18.986 6.01429L22.0002 6.01429M9.39453 8.67858C9.39453 9.56144 8.67882 10.2771 7.79596 10.2771C6.91309 10.2771 6.19739 9.56144 6.19739 8.67858C6.19739 7.79571 6.91309 7.08001 7.79596 7.08001C8.67882 7.08001 9.39453 7.79571 9.39453 8.67858Z" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        }
                        <div style={{ fontSize: 12, marginTop: 4, color: "rgb(136 140 145)" }} dangerouslySetInnerHTML={{ __html: this.state.selectedFeedType === "REELS" ? "동영상 추가<br/>(최대 300MB)" : "이미지 추가" }}></div>
                      </div>
                    </div>
                    <div className="tooltip-down">{this.state.selectedFeedType === "REELS" ? "동영상을 바로 업로드" : "사진 또는 AI디자인도구 등으로 제작"}</div>
                  </>
                )}
              </div>
            );
          })}
        </div>
        {/* <div style={{ marginTop: 12, fontSize: 12, color: "#6b7280" }}>
          이미지를 추가하면 다음 칸이 생성되며, 최대 10개까지 등록 가능합니다.
        </div> */}
      </>
    );
  }

  getFilledImages = () => {
    return this.getFilledSlots().map((s) => s.data);
  };

  setSlide = (idx) => {
    const imgs = this.getFilledImages();
    if (!imgs.length) return;
    const next = ((idx % imgs.length) + imgs.length) % imgs.length;
    this.setState({ previewSlideIndex: next });
  };
  nextSlide = () => { const { previewSlideIndex = 0 } = this.state; this.setSlide(previewSlideIndex + 1); };
  previousSlide = () => { const { previewSlideIndex = 0 } = this.state; this.setSlide(previewSlideIndex - 1); };

  applyAIImg(img, sourceInfo){
    const info = sourceInfo && typeof sourceInfo === "object"
      ? sourceInfo
      : { stability_call_seq: sourceInfo };

    this.updateImageSlotsState((imageSlots) => {
      imageSlots[this.state.currentImageSlotIndex] = {
        type: "ai",
        data: img,
        source_url: img,
        stability_call_seq: info.stability_call_seq || null,

        ai_studio_history_seq: info.ai_studio_history_seq || null,
        ai_studio_history_step_seq: info.ai_studio_history_step_seq || null,
        ai_studio_history_step_result_seq: info.ai_studio_history_step_result_seq || null,
        result_no: info.result_no || null,
      };
      return imageSlots;
    });
  }

  onClickAddProductbtn(selected_product_list){
     this.setState({ show_add_product_popup:false, save_dialog_show_state: true });
     this.setState({
      save_dialog_show_state: true,
      save_dialog_content: "이미지를 적용 중입니다."
    });
     const config = { headers: { 'Content-Type': 'application/json' } }
     const body = { image_url: selected_product_list[0].image_url, ratio: this.state.currentRatio ? this.state.currentRatio : "1/1" }
     http.post("/rest/shop/instagram/resizeUrlImg", body, config)
     .then(res => {
        const url = res.data.org_img_path;
        this.setSelectedProduct(selected_product_list, url);
        this.setState({ save_dialog_show_state: false, save_dialog_show_state: false });
      }).catch(error => { console.log (error); this.setState({ save_dialog_show_state: false }); })
  }

  setSelectedProduct(selected_product_list, img_url) {
    this.updateImageSlotsState((imageSlots) => {
      imageSlots[this.state.currentImageSlotIndex] = {
        type: "product",
        data: img_url,
        product_no: selected_product_list[0].product_no,
        product_name: selected_product_list[0].product_name,
        product_price: selected_product_list[0].product_price,
        image_url: selected_product_list[0].image_url
      };
      return imageSlots;
    });

    this.setState({
      selected_rp_product_list: selected_product_list
    });
  }
  applydDesign(event_seq, img_url, media_source_id) {
    this.updateImageSlotsState((imageSlots) => {
      imageSlots[this.state.currentImageSlotIndex] = {
        type: "template",
        data: img_url,
        event_seq: event_seq,
        image_url: img_url,
        media_source_id: media_source_id,
      };
      return imageSlots;
    });

    this.setState({
      show_design_template_popup: false,
      selected_template_event_type_cd: "",
      selected_template_upper_code_cd: "",
    });
  }

  setCaption = (nextCaption, callback) => {
    this.setState(prev => ({ caption_history: [...prev.caption_history, prev.caption], caption: nextCaption, caption_future: [] }), () => { if (callback) callback(); });
  };

  undoCaption = () => {
    this.setState(prev => {
      if (prev.caption_history.length === 0) return null;
      const prevCaption = prev.caption_history[prev.caption_history.length - 1];
      const caption_history = prev.caption_history.slice(0, -1);
      return { caption: prevCaption, caption_history, caption_future: [prev.caption, ...prev.caption_future] };
    });
  };
  
  redoCaption = () => {
    this.setState(prev => {
      if (prev.caption_future.length === 0) return null;
      const nextCaption = prev.caption_future[0];
      const caption_future = prev.caption_future.slice(1);
      return { caption: nextCaption, caption_history: [...prev.caption_history, prev.caption], caption_future };
    });
  };

  instagramFreePreriod() {
    http.get("/rest/shop/instagram/FreePreriod").then(res => {
        if (res.data.is_finish != null) {
            this.setState({ instagram_is_finish: res.data.is_finish });
            if (res.data.is_finish == 1) {
              alert("이용 기간이 종료되었습니다.");
              window.location.href = "/shop/instagram/InstagramPostList";
            }
        }
    }).catch(error => { console.error(error); })
  }

  updateSelectedAccountsUseYn = () => {
    const { token_id, selected_account_list } = this.state;

    if (!token_id) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "토큰 정보가 없습니다. 다시 연동해주세요."
      });
      return;
    }

    if (!selected_account_list || selected_account_list.length === 0) {
      this.setState({ warning_dialog_show_state: true, warning_dialog_content: "하나 이상의 계정을 선택 해 주세요." });
      return;
    }
    http.post("/rest/shop/instagram/updateAccountsUseYn", { token_id, selected_account_list, use_yn: "Y" }, { headers: { "Content-Type": "application/json" } })
      .then((res) => {
        const data = res && res.data ? res.data : {};
        if (String(data.code) === "200") {
          this.loadInstagramAccountList();
          this.setState({ show_account_connect_popup: false });
        } else {
          this.setState({ warning_dialog_show_state: true, warning_dialog_content: "계정 업데이트에 실패했습니다." });
        }
      })
      .catch((err) => {
        this.setState({ warning_dialog_show_state: true, warning_dialog_content: "서버 요청 중 오류가 발생했습니다." });
      });
  };

  // Instagram Direct OAuth 완료는 새 탭에서 현재 화면으로 postMessage로 전달한다.
  handleInstagramDirectOAuthMessage = (event) => {
    if (event.origin !== new URL(INSTAGRAM_DIRECT_LOGIN_URL).origin) return;
    if (!this.instagramDirectOAuthWindow || event.source !== this.instagramDirectOAuthWindow) return;
    const data = event.data;
    if (!data || data.type !== "robomdInstagramDirectAuthComplete") return;

    this.instagramDirectOAuthWindow = null;
    if (data.status === "success" && /^IGD:\d+$/.test(String(data.token_id || ""))) {
      const tokenId = String(data.token_id);
      this.setState(
        { token_id: tokenId, selected_account_list: [], show_account_connect_popup: true },
        () => this.loadInstagramAccountList(tokenId)
      );
    } else {
      this.openWarning("Instagram 로그인 또는 권한 승인이 완료되지 않았습니다.");
    }
  };

  handleConnectAccount = () => {
    const result = submitFacebookOAuthForm({ redirectUri: REDIRECT_URI });
    if (result?.provider === "INSTAGRAM") {
      this.instagramDirectOAuthWindow = result.popup;
      if (!result.popup) {
        this.openWarning("Instagram 로그인 새 탭을 열지 못했습니다. 브라우저의 팝업 차단을 확인해주세요.");
      }
    }
  };

  handleClickOutside = (event) => {
    // 피커 외부 클릭이면서, 동시에 버튼도 클릭하지 않았을 때만 닫기
    if (
      this.pickerRef.current && 
      !this.pickerRef.current.contains(event.target) &&
      this.triggerRef.current && 
      !this.triggerRef.current.contains(event.target) // 버튼 클릭은 무시
    ) {
      this.setState({ emojiPickerVisible: false });
    }
  }

  // // 태그 추가 공통 로직
  // addTag = (newTagValue) => {
  //     const newTag = newTagValue.trim();
  //     if (!newTag) return;

  //     // '#' 기호가 없으면 자동으로 붙여줌
  //     const formattedTag = newTag.startsWith('#') ? newTag : `#${newTag}`;

  //     // 최대 30개 제한 방어
  //     if (this.state.tags.length >= 30) {
  //         alert("해시태그는 최대 30개까지만 등록 가능합니다.");
  //         return;
  //     }

  //     // 중복 체크 후 추가
  //     if (!this.state.tags.includes(formattedTag)) {
  //         this.setState(prevState => ({
  //             tags: [...prevState.tags, formattedTag],
  //             tagInput: "" // 입력창 비우기
  //         }));
  //     } else {
  //         this.setState({ tagInput: "" }); // 이미 있으면 창만 비움
  //     }
  // }

  // // Input 키보드 이벤트
  // handleTagKeyDown = (e) => {
  //     if (e.key === 'Enter' || e.key === ' ' || e.code === 'Space') {
  //         e.preventDefault();
  //         this.addTag(this.state.tagInput);
  //     } 
  //     // 입력창이 비어있을 때 백스페이스 누르면 마지막 칩 삭제
  //     else if (e.key === 'Backspace' && !this.state.tagInput && this.state.tags.length > 0) {
  //         this.setState(prevState => ({
  //             tags: prevState.tags.slice(0, -1)
  //         }));
  //     }
  // };

  handleComposition = (e) => {
    if (e.type === 'compositionstart') this.isComposing = true;
    if (e.type === 'compositionend') this.isComposing = false;
  };

  handleTagKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === " ") {
      e.preventDefault();
      this.addTag(e.target.value);
    }
  };

  addTag = (valueRaw) => {
    if (this.isComposing) return; // 조합 중이면 무시
    
    // 1. # 기준으로 문자열을 나누고, 공백 제거 및 빈 값 필터링
    const rawParts = valueRaw.split('#').map(t => t.trim()).filter(t => t);
    
    if (rawParts.length === 0) return;

    // 2. 각 태그에 # 붙이기 및 Sanitization
    const newTags = rawParts.map(t => `#${this.sanitizeHashtag(t)}`);

    this.setState((prev) => {
      // 3. 기존 태그와 합치고 중복 제거 (Set 사용)
      const combinedTags = [...new Set([...prev.tags, ...newTags])];

      // 4. 30개 제한 체크
      if (combinedTags.length > 30) {
        alert("해시태그는 최대 30개까지만 등록 가능합니다.");
        // 30개까지만 잘라서 반영
        // return { tags: combinedTags.slice(0, 30), inputHashtagValue: "" };
        return { tags: combinedTags, inputHashtagValue: "" };
      }

      return { tags: combinedTags, inputHashtagValue: "" };
    });
  }

  openConfirmDialog(props) {
    return new Promise((resolve) => {
      const container = document.createElement("div");
      document.body.appendChild(container);

      const close = (result) => {
        resolve(result);
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
      };

      ReactDOM.render(
        <TitleContentDialogV2
          {...props}
          popup_close={() => close(false)}
          button_list={[
            {
              title: "확인",
              event_method: () => close(true),
            },
            {
              title: "취소",
              event_method: () => close(false),
            },
          ]}
        />,
        container
      );
    });
  }

  loadNewFixedTagList = () => {
    http.get("/rest/shop/favorite-hashtags")
    .then(res => {
        // res.data는 서버에서 보낸 응답 객체입니다.
        if (res.data.status === 'success' && res.data.list != null) {
            this.setState({ fixedTags: res.data.list });
        } else {
            console.error("데이터 조회 실패:", res.data.message);
        }
    })
    .catch(error => {
        console.error("통신 에러:", error);
    });
  }

  async addFavoriteHashtag(hashtagValue) {
    // 1. 임시 고유 ID 생성
    const tempId = 'temp_' + Date.now();

    // 2. [Optimistic Update] 일단 UI에 즉시 추가
    this.setState(prev => ({
      fixedTags: [...prev.fixedTags, { favorite_tag_seq: tempId, tag_name: hashtagValue }],
      newFixedTagInput: ""
    }));

    try {
      const res = await http.post("/rest/shop/favorite-hashtags", {
        tag_name: hashtagValue,
        sort_order: 1
      });

      if (res.data.status === 'success') {
        // 3. [성공 시] 서버에서 받은 진짜 ID로 교체
        const realId = res.data.favorite_tag_seq;
        this.setState(prev => ({
          fixedTags: prev.fixedTags.map(tag =>
            tag.favorite_tag_seq === tempId ? { ...tag, favorite_tag_seq: realId } : tag
          )
        }));
      } else {
        // 4. [논리적 실패 시] 에러 발생 (catch 블록으로 이동)
        throw new Error(res.data.message);
      }
    } catch (error) {
      console.error("통신 에러:", error);
      alert("등록 실패: " + (error.message || "서버 오류 발생"));

      // 5. [복구(Rollback)] 실패 시 추가했던 임시 태그 삭제
      this.setState(prev => ({
        fixedTags: prev.fixedTags.filter(tag => tag.favorite_tag_seq !== tempId)
      }));
    }
  }
  
  updateFavoriteHashtag() {
    // API 호출
    http.post("/rest/shop/favorite-hashtags/sort-order", {
        list: this.state.fixedTags
    })
    .then(res => {
        if (res.data.status === 'success') {
            console.log("순서 변경 완료!");
        }
    })
    .catch(error => {
        console.error("통신 실패:", error);
    });
  }

  // [데이터 로드]
  loadQuickPhrases = () => {
      http.get("/rest/shop/favorite-phrases")
      .then(res => {
          if (res.data.status === 'success') {
            const mappedPhrases = res.data.list.map(item => ({
              favorite_phrase_seq: item.favorite_phrase_seq,
              title: item.phrase_title,     // DB의 phrase_title을 title로
              content: item.phrase_content  // DB의 phrase_content를 content로
            }));

            this.setState({ quickPhrases: mappedPhrases });
          }
      });
  }

  // [추가 API]
  addNewPhraseByAPI = async () => {
      const { phraseTitleInput, phraseContentInput } = this.state;
      const tempId = 'temp_' + Date.now();

      // Optimistic Update
      this.setState(prev => ({
          quickPhrases: [...prev.quickPhrases, { favorite_phrase_seq: tempId, title: phraseTitleInput, content: phraseContentInput }],
          phraseTitleInput: "",
          phraseContentInput: "",
          modals: { ...this.state.modals, phrase: false }
      }));

      try {
          const res = await http.post("/rest/shop/favorite-phrases", {
              phrase_title: phraseTitleInput,
              phrase_content: phraseContentInput
          });

          if (res.data.status === 'success') {
              // 서버 ID로 교체
              this.setState(prev => ({
                  quickPhrases: prev.quickPhrases.map(p => 
                      p.favorite_phrase_seq === tempId ? { ...p, favorite_phrase_seq: res.data.favorite_phrase_seq } : p
                  )
              }));
          }
      } catch (e) {
          alert("저장 실패");
          this.setState(prev => ({ quickPhrases: prev.quickPhrases.filter(p => p.favorite_phrase_seq !== tempId) }));
      }
  }

  /* 피드문구, 해시태그 개수 설정 조회  */
  loadGenerationCount = () => {
    // this.setState({ 
    //   save_dialog_show_state: true,
    //   save_dialog_content: "로딩중 입니다.",
    //   save_dialog_button_list: [{ title: "확인", type: "1", display_yn:"N" }],
    // });

    return http.get('/rest/shop/instagram/generation-count')
    .then(response => {
      // if (response && response.data) {
        const data = response.data.result || {};

        return new Promise((resolve) => {
          this.setState({
            hashtag_setting_count: data.manual_hashtag_count || 5,
            caption_setting_count: data.manual_caption_count || 3,
            is_auto_hashtag_on: data.manual_is_auto_hashtag_on !== undefined ? data.manual_is_auto_hashtag_on : false,

            // save_dialog_show_state: false,
          }, resolve);
        });
      // }
    })
    .catch(error => {
      console.error("데이터 조회 에러:", error);
      // this.setState({ save_dialog_show_state: false });
      return null;
    });
  };

  isValidIgSeq = (value) => {
    if (value === null || value === undefined) return false;

    const v = String(value).trim();

    if (!v) return false;
    if (v === "none" || v === "add") return false;

    return true;
  };

  getPublishAccountSeq = () => {
    const { selected_ig_access_seq, default_ig_access_seq } = this.state;
    // 사용자가 명시적으로 미선택한 경우 기본 계정을 대입하지 않는다.
    if (selected_ig_access_seq === "none") return "";

    if (this.isValidIgSeq(selected_ig_access_seq)) {
      return String(selected_ig_access_seq).trim();
    }

    if (this.isValidIgSeq(default_ig_access_seq)) {
      return String(default_ig_access_seq).trim();
    }

    return "";
  };

  handleAiCopywriterCreateNew = () => {
    // alert('새 AI 카피라이터 생성 페이지로 이동합니다.');
    window.open('/shop/instagram/InstagramCopywriterSetting'); 
  };


  getAiCopywriterGenerationContext = () => {
    const imageSlots = Array.isArray(this.state.imageSlots) ? this.state.imageSlots : [];

    return {
      product_name_list: imageSlots
        .filter((slot) => slot && slot.type === "product" && slot.product_name)
        .map((slot) => String(slot.product_name).trim())
        .filter(Boolean),
      image_list: imageSlots
        .map((slot) => slot && slot.data)
        .filter(Boolean),
      instagram_media_seq: this.state.media_id || null,
    };
  };

  openAiCopywriterRunModal = () => {
    this.setState((prev) => ({
      modals: { ...prev.modals, copywriterRun: true },
    }));
  };

  closeAiCopywriterRunModal = () => {
    this.setState((prev) => ({
      modals: { ...prev.modals, copywriterRun: false },
    }));
  };


  handleAiCopywriterResultApply = async (
    mergedCaption,
    selectedRecommendations = [],
    copywriterContext = {}
  ) => {
    const nextCaption = String(mergedCaption || "").trim();

    if (!nextCaption) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content:
          "문구 작성 에디터에 적용할 문구를 하나 이상 선택해주세요."
      });
      return false;
    }

    const { totalLength } = this.getCaptionAndTagLengthInfo(
      nextCaption,
      this.state.tags
    );

    if (totalLength > 2200) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content:
          `선택한 문구와 해시태그를 합치면 2,200자를 초과합니다.<br/>` +
          `(현재 ${totalLength.toLocaleString()}자)`
      });
      return false;
    }

    const recommendationHistorySeq = (selectedRecommendations || [])
      .map((item) => item?.copywriter_history_seq)
      .find(Boolean);

    const normalizedPresetSeq = String(
      copywriterContext.copywriter_preset_seq || ""
    ).trim() || null;

    const normalizedHistorySeq =
      copywriterContext.copywriter_history_seq ||
      recommendationHistorySeq ||
      null;

    await new Promise((resolve) => {
      this.setState({
        copywriter_preset_seq: normalizedPresetSeq,
        copywriterHistorySeq: normalizedHistorySeq,
        selectedCopywriterHistorySeq: normalizedHistorySeq,
      }, () => {
        this.setCaption(nextCaption, () => {
          if (this.captionTextareaRef.current) {
            this.captionTextareaRef.current.focus();
          }

          resolve();
        });
      });
    });

    const autoHashtagValue = this.state.is_auto_hashtag_on;

    const shouldGenerateHashtag =
      autoHashtagValue === true ||
      autoHashtagValue === 1 ||
      autoHashtagValue === "1" ||
      autoHashtagValue === "Y";

    if (shouldGenerateHashtag) {
      await this.generateAIHashtags();

      return {
        applied: true,
        refreshGptUsage: true
      };
    }

    return {
      applied: true,
      refreshGptUsage: false
    };
  };

  preventDatePickerTyping = (e) => {
    if (!e) return;

    if (e.type === "keydown") {
      const allowedKeys = ["Tab", "Escape"];
      if (allowedKeys.includes(e.key)) {
        return;
      }
    }

    e.preventDefault();
  };

  // =========================================================
  //  [RENDER] 고도화된 UI 렌더링 시작
  // =========================================================

  buildReelsAudioPayload = (
    selectedFeedType = this.state.selectedFeedType,
    audioState = this.state.reelsAudio
  ) => {
    if (selectedFeedType !== "REELS") {
      return {};
    }

    const reelsAudio = audioState || createDefaultReelsAudioState();
    const hasInstagramAudio =
      (reelsAudio.mode === "MUSIC" || reelsAudio.mode === "ORIGINAL_SOUND")
      && reelsAudio.audioId;

    return {
      audio_mode_cd: hasInstagramAudio ? reelsAudio.mode : "NONE",
      instagram_audio_id: hasInstagramAudio ? String(reelsAudio.audioId) : null,
      instagram_audio_type: hasInstagramAudio
        ? (reelsAudio.audioType || reelsAudio.mode)
        : null,
      instagram_audio_title: hasInstagramAudio ? (reelsAudio.title || null) : null,
      instagram_audio_artist: hasInstagramAudio ? (reelsAudio.artist || null) : null,
      instagram_audio_duration_ms:
        hasInstagramAudio && reelsAudio.durationMs !== null && reelsAudio.durationMs !== undefined
          ? Math.round(Number(reelsAudio.durationMs))
          : null,
      audio_volume: hasInstagramAudio
        ? clampInstagramAudioVolume(reelsAudio.audioVolume, 100)
        : 100,
      // Meta의 video_volume은 Instagram audio_configuration을 사용할 때만 발행에 반영한다.
      video_volume: hasInstagramAudio
        ? clampInstagramAudioVolume(reelsAudio.videoVolume, 100)
        : 100,
      audio_name: String(reelsAudio.audioName || "").trim() || null,
      audio_meta_snapshot_json: hasInstagramAudio && reelsAudio.meta
        ? JSON.stringify(reelsAudio.meta)
        : null,
    };
  };

  openInstagramAudioModal = () => {
    const accountSeq = this.getPublishAccountSeq();
    if (!accountSeq) {
      alert("Instagram 계정을 먼저 선택해주세요.");
      return;
    }
    this.setState({ reelsAudioModalOpen: true });
  };

  handleApplyInstagramAudio = (item) => {
    const normalized = normalizeInstagramAudioAsset(
      item && item.raw ? item.raw : item,
      item && item.audioType === "ORIGINAL_SOUND" ? "original_sound" : "music"
    );

    this.setState((prev) => ({
      reelsAudioModalOpen: false,
      reelsAudio: {
        ...(prev.reelsAudio || createDefaultReelsAudioState()),
        mode: normalized.audioType,
        audioId: normalized.id,
        audioType: normalized.audioType,
        title: normalized.title,
        artist: normalized.artist,
        durationMs: normalized.durationMs,
        previewUrl: normalized.previewUrl,
        platformPreviewUrl: normalized.platformPreviewUrl,
        audioVolume: prev.reelsAudio ? clampInstagramAudioVolume(prev.reelsAudio.audioVolume, 100) : 100,
        videoVolume: prev.reelsAudio ? clampInstagramAudioVolume(prev.reelsAudio.videoVolume, 100) : 100,
        meta: normalized.raw,
        mediaAudioType: "",
      },
    }), () => {
      this.syncReelsPreviewVolumes();
      // 적용 직후에도 상세 메타데이터를 다시 확인해 미리듣기 가능 여부를 최신 상태로 맞춘다.
      this.refreshSelectedInstagramAudioMetadata(normalized.id, normalized.audioType);
    });
  };

  clearInstagramAudio = () => {
    if (this.reelsPreviewAudioRef.current) {
      try {
        this.reelsPreviewAudioRef.current.pause();
        this.reelsPreviewAudioRef.current.currentTime = 0;
      } catch (e) {}
    }

    this.setState((prev) => ({
      reelsAudio: {
        ...createDefaultReelsAudioState(),
        audioName: prev.reelsAudio ? prev.reelsAudio.audioName || "" : "",
      },
    }), this.syncReelsPreviewVolumes);
  };

  updateReelsAudioVolume = (field, value) => {
    const next = clampInstagramAudioVolume(value, 100);

    // 사용자가 직접 조절한 마지막 1~100 값을 기억해 음소거 해제 시 그대로 복원한다.
    if (next > 0) {
      if (field === "audioVolume") this.reelsAudioVolumeBeforeMute = next;
      if (field === "videoVolume") this.reelsVideoVolumeBeforeMute = next;
    }

    this.setState((prev) => ({
      reelsAudio: {
        ...(prev.reelsAudio || createDefaultReelsAudioState()),
        [field]: next,
      },
    }), this.syncReelsPreviewVolumes);
  };

  toggleReelsVolumeMute = (field) => {
    const memoryKey = field === "audioVolume"
      ? "reelsAudioVolumeBeforeMute"
      : "reelsVideoVolumeBeforeMute";

    this.setState((prev) => {
      const current = prev.reelsAudio || createDefaultReelsAudioState();
      const currentVolume = clampInstagramAudioVolume(current[field], 100);
      const isMuted = currentVolume === 0;

      if (!isMuted) {
        this[memoryKey] = currentVolume;
      }

      const rememberedVolume = clampInstagramAudioVolume(this[memoryKey], 100);
      const restoredVolume = rememberedVolume > 0 ? rememberedVolume : 100;

      return {
        reelsAudio: {
          ...current,
          [field]: isMuted ? restoredVolume : 0,
        },
      };
    }, this.syncReelsPreviewVolumes);
  };

  toggleReelsAudioMute = () => this.toggleReelsVolumeMute("audioVolume");

  toggleReelsVideoMute = () => this.toggleReelsVolumeMute("videoVolume");

  syncReelsPreviewVolumes = () => {
    const audioState = this.state.reelsAudio || createDefaultReelsAudioState();
    const hasInstagramAudio =
      (audioState.mode === "MUSIC" || audioState.mode === "ORIGINAL_SOUND")
      && audioState.audioId;

    const video = this.reelsPreviewVideoRef.current;
    const audio = this.reelsPreviewAudioRef.current;

    if (video) {
      if (hasInstagramAudio) {
        const videoVolume = clampInstagramAudioVolume(audioState.videoVolume, 100);
        video.muted = videoVolume === 0;
        video.volume = videoVolume / 100;
      } else {
        video.muted = false;
        video.volume = 1;
      }
    }

    if (audio) {
      audio.volume = hasInstagramAudio
        ? clampInstagramAudioVolume(audioState.audioVolume, 100) / 100
        : 0;
    }
  };

  syncReelsPreviewAudioTime = (video) => {
    const audioState = this.state.reelsAudio || createDefaultReelsAudioState();
    const audio = this.reelsPreviewAudioRef.current;
    if (!video || !audio || !audioState.previewUrl) return;

    try {
      const duration = Number(audio.duration);
      if (Number.isFinite(duration) && duration > 0) {
        const next = Number(video.currentTime || 0) % duration;
        if (Math.abs(Number(audio.currentTime || 0) - next) > 0.35) {
          audio.currentTime = next;
        }
      }
    } catch (e) {}
  };

  handleReelsPreviewPlay = async (event) => {
    const video = event.currentTarget;
    this.syncReelsPreviewVolumes();

    const audioState = this.state.reelsAudio || createDefaultReelsAudioState();
    const audio = this.reelsPreviewAudioRef.current;
    if (!audio || !audioState.previewUrl || !audioState.audioId) return;

    this.syncReelsPreviewAudioTime(video);
    try {
      await audio.play();
    } catch (e) {
      // 브라우저 자동재생 정책 또는 해당 오디오 미리듣기 URL 제한 시 영상 재생은 유지한다.
      console.warn("Instagram 음악 미리보기 동기 재생 실패:", e);
    }
  };

  handleReelsPreviewPause = () => {
    const audio = this.reelsPreviewAudioRef.current;
    if (audio) {
      try { audio.pause(); } catch (e) {}
    }
  };

  handleReelsPreviewSeeked = (event) => {
    this.syncReelsPreviewAudioTime(event.currentTarget);
  };

  handleReelsPreviewTimeUpdate = (event) => {
    const video = event.currentTarget;
    const audio = this.reelsPreviewAudioRef.current;
    if (!audio || audio.paused) return;
    this.syncReelsPreviewAudioTime(video);
  };

  handleReelsPreviewEnded = () => {
    const audio = this.reelsPreviewAudioRef.current;
    if (audio) {
      try {
        audio.pause();
        audio.currentTime = 0;
      } catch (e) {}
    }
  };

  refreshSelectedInstagramAudioMetadata = async (audioId, audioType) => {
    const accountSeq = this.getPublishAccountSeq();
    if (!accountSeq || !audioId) return;

    try {
      const { data } = await http.get(
        `/rest/shop/instagram/${accountSeq}/audio/${encodeURIComponent(audioId)}`
      );

      const raw =
        data && data.data && typeof data.data === "object"
          ? data.data
          : data;

      const normalized = normalizeInstagramAudioAsset(
        raw,
        String(audioType || "").toUpperCase() === "ORIGINAL_SOUND"
          ? "original_sound"
          : "music"
      );

      if (!normalized.id) return;

      this.setState((prev) => {
        const current = prev.reelsAudio || createDefaultReelsAudioState();
        if (String(current.audioId || "") !== String(audioId)) return null;

        return {
          reelsAudio: {
            ...current,
            title: normalized.title || current.title,
            artist: normalized.artist || current.artist,
            durationMs:
              normalized.durationMs !== null
                ? normalized.durationMs
                : current.durationMs,
            previewUrl: normalized.previewUrl || current.previewUrl,
            platformPreviewUrl: normalized.platformPreviewUrl || current.platformPreviewUrl,
            meta: normalized.raw || current.meta,
          },
        };
      });
    } catch (e) {
      // 저장된 audio_id가 나중에 만료/제한되더라도 상세 화면 자체는 열리게 둔다.
      console.warn("선택된 Instagram 오디오 메타데이터 재조회 실패:", e);
    }
  };

  openReelsAudioPlatformPreview = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const url = getInstagramPlatformPreviewUrl(this.state.reelsAudio);
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  formatReelsAudioDuration = (durationMs) => {
    const n = Number(durationMs);
    if (!Number.isFinite(n) || n < 0) return "-";
    const totalSeconds = Math.floor(n / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${String(seconds).padStart(2, "0")}`;
  };

  renderReelsAudioControls = () => {
    if (this.state.selectedFeedType !== "REELS") return null;

    const audio = this.state.reelsAudio || createDefaultReelsAudioState();
    const hasAudio =
      (audio.mode === "MUSIC" || audio.mode === "ORIGINAL_SOUND")
      && audio.audioId;
    const platformPreviewUrl = getInstagramPlatformPreviewUrl(audio);
    const audioMuted =
      hasAudio && clampInstagramAudioVolume(audio.audioVolume, 100) === 0;
    const videoMuted =
      hasAudio && clampInstagramAudioVolume(audio.videoVolume, 100) === 0;

    return (
      <div
        className="reels-audio-controls"
        data-instagram-tutorial="post-reels-audio"
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", marginBottom: "12px" }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "7px" }}>
              <div className="section-title" style={{ fontSize: 15 }}>릴스 음악</div>
              {this.state.threadsPublishEnabled && (
                <span style={{ padding: "2px 7px", borderRadius: "999px", background: "#f3f4f6", color: "#6b7280", fontSize: "10px", fontWeight: 800 }}>
                  Instagram 전용
                </span>
              )}
            </div>
            <div style={{ marginTop: "3px", fontSize: "11px", color: "#8792a0" }}>
              인스타그램에서 제공하는 음악 또는 원본 오디오를 추가하고 영상 소리를 조절합니다.
            </div>
          </div>
          <button
            type="button"
            className="btn btn-outline"
            data-instagram-tutorial="post-reels-audio-add"
            style={{ height: "36px", padding: "0 13px", fontSize: "12px" }}
            onClick={this.openInstagramAudioModal}
          >
            {hasAudio ? "음악 변경" : "+ 음악 추가"}
          </button>
        </div>

        {hasAudio ? (
          <div
            data-instagram-tutorial="post-reels-audio-selected"
            style={{ display: "flex", alignItems: "center", gap: "12px", padding: "12px", border: "1px solid #dfe5eb", borderRadius: "8px", background: "#f8fbfc" }}
          >
            <div style={{ width: "42px", height: "42px", borderRadius: "7px", display: "flex", alignItems: "center", justifyContent: "center", background: "#eafafb", color: "#0b6e72", fontSize: "20px", flex: "0 0 42px" }}>♫</div>
            <div style={{ minWidth: 0, flex: 1 }}>
              <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: "13px", fontWeight: 800, color: "#202733" }}>
                {audio.title || "선택한 음악"}
              </div>
              <div style={{ marginTop: "3px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: "11px", color: "#6f7b89" }}>
                {audio.artist || "-"} · {this.formatReelsAudioDuration(audio.durationMs)}
              </div>
              <div style={{ marginTop: "5px", display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                <span style={{ fontSize: "10px", fontWeight: 700, color: "#0b6e72" }}>
                  {audio.mode === "MUSIC" ? "MUSIC · Sound Collection" : "ORIGINAL_SOUND"}
                </span>
                {!audio.previewUrl && platformPreviewUrl ? (
                  <button
                    type="button"
                    onClick={this.openReelsAudioPlatformPreview}
                    title="인스타그램에서 듣기"
                    style={{
                      padding: "4px 2px",
                      border: 0,
                      background: "transparent",
                      color: "#0b6e72",
                      fontSize: "10px",
                      fontWeight: 700,
                      lineHeight: 1.3,
                      whiteSpace: "nowrap",
                      cursor: "pointer",
                    }}
                  >
                    인스타그램에서 듣기
                  </button>
                ) : !audio.previewUrl ? (
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minHeight: "22px",
                      padding: "4px 7px",
                      borderRadius: "4px",
                      background: "#f1f5f9",
                      color: "#64748b",
                      fontSize: "10px",
                      fontWeight: 700,
                      lineHeight: 1.1,
                      whiteSpace: "nowrap",
                    }}
                  >
                    미리듣기 불가
                  </span>
                ) : null}
              </div>
            </div>
            <button
              type="button"
              onClick={this.clearInstagramAudio}
              style={{ border: 0, background: "transparent", color: "#7b8797", cursor: "pointer", fontSize: "12px" }}
            >
              삭제
            </button>
          </div>
        ) : (
          <div style={{ padding: "12px", border: "1px dashed #cfd6de", borderRadius: "8px", background: "#fafbfc", color: "#7d8793", fontSize: "12px" }}>
            추가한 음악이 없습니다. 영상 자체의 원본 오디오가 사용됩니다.
          </div>
        )}

        {hasAudio && (
          <>
            <div
              data-instagram-tutorial="post-reels-audio-volume"
              style={{ marginTop: "14px", display: "flex", alignItems: "center", gap: "12px" }}
            >
              <span style={{ width: "84px", fontSize: "12px", fontWeight: 700, color: "#475569" }}>음악 음량</span>
              <input
                type="range"
                min="0"
                max="100"
                value={clampInstagramAudioVolume(audio.audioVolume, 100)}
                onChange={(e) => this.updateReelsAudioVolume("audioVolume", e.target.value)}
                className="instagram-volume-range"
                style={{
                  flex: 1,
                  minWidth: 0,
                  "--range-value": `${clampInstagramAudioVolume(audio.audioVolume, 100)}%`
                }}
              />
              <span style={{ width: "34px", textAlign: "right", fontSize: "11px", color: "#64748b" }}>
                {clampInstagramAudioVolume(audio.audioVolume, 100)}
              </span>
              <button
                type="button"
                onClick={this.toggleReelsAudioMute}
                style={{
                  height: "30px",
                  padding: "0 10px",
                  border: "1px solid #d1d5db",
                  borderRadius: "5px",
                  background: audioMuted ? "#eefafb" : "#fff",
                  color: audioMuted ? "#0b6e72" : "#4b5563",
                  fontSize: "11px",
                  fontWeight: 700,
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                {audioMuted ? "음소거 해제" : "음소거"}
              </button>
            </div>

            <div data-instagram-tutorial="post-reels-video-volume" style={{ marginTop: "12px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <span style={{ width: "84px", fontSize: "12px", fontWeight: 700, color: "#475569" }}>영상 소리</span>
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={clampInstagramAudioVolume(audio.videoVolume, 100)}
                  onChange={(e) => this.updateReelsAudioVolume("videoVolume", e.target.value)}
                  className="instagram-volume-range"
                  style={{
                    flex: 1,
                    minWidth: 0,
                    "--range-value": `${clampInstagramAudioVolume(audio.videoVolume, 100)}%`
                  }}
                />
                <span style={{ width: "34px", textAlign: "right", fontSize: "11px", color: "#64748b" }}>
                  {clampInstagramAudioVolume(audio.videoVolume, 100)}
                </span>
                <button
                  type="button"
                  onClick={this.toggleReelsVideoMute}
                  style={{
                    height: "30px",
                    padding: "0 10px",
                    border: "1px solid #d1d5db",
                    borderRadius: "5px",
                    background: videoMuted ? "#eefafb" : "#fff",
                    color: videoMuted ? "#0b6e72" : "#4b5563",
                    fontSize: "11px",
                    fontWeight: 700,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  {videoMuted ? "음소거 해제" : "음소거"}
                </button>
              </div>
              <div style={{ marginTop: "5px", paddingLeft: "96px", fontSize: "10px", color: "#94a3b8" }}>
                선택한 음악과 함께 게시할 때 영상 원본 소리의 크기를 조절합니다.
              </div>
            </div>
          </>
        )}

        <div data-instagram-tutorial="post-reels-audio-name" style={{ marginTop: "14px" }}>
          <label style={{ display: "block", marginBottom: "6px", fontSize: "12px", fontWeight: 700, color: "#475569" }}>
            원본 오디오 이름
          </label>
          <input
            type="text"
            className="form-control"
            maxLength={255}
            placeholder="인스타그램에 표시할 원본 오디오 이름 (선택)"
            value={audio.audioName || ""}
            onChange={(e) =>
              this.setState((prev) => ({
                reelsAudio: {
                  ...(prev.reelsAudio || createDefaultReelsAudioState()),
                  audioName: e.target.value,
                },
              }))
            }
          />
        </div>
      </div>
    );
  };

  render() {
    const { 
        publishOption, caption, selectedAccount, aiSuggestionsVisible, tags, topicInput,
        scheduledDate, scheduledTime, account_list_v2, default_ig_access_seq,
        selected_ig_access_seq, aiRecommendations, selectedLabel, activeSection,
        quickPhrases, manualTags, fixedTags, modals, accountConnected, hashtag_setting_count, caption_setting_count, is_auto_hashtag_on,
        instagramPublishEnabled, threadsPublishEnabled, threadsAccountConnected, threads_account_list_v2, selected_threads_access_seq
    } = this.state;
  
    // 계정이 연동되지 않은 상태와 연동은 되어 있지만 선택하지 않은 상태를 구분한다.
    // 미리보기는 실제 선택값을 기준으로 하며, 기본 계정을 임의로 대입하지 않는다.
    const hasInstagramAccounts = !!accountConnected && (account_list_v2 || []).length > 0;
    const selectedInstagramPreviewAccount = (account_list_v2 || []).find(
      (acc) => String(acc.value) === String(selected_ig_access_seq || "")
    );
    const hasThreadsAccounts = !!threadsAccountConnected && (threads_account_list_v2 || []).length > 0;
    const selectedThreadsPreviewAccount = (threads_account_list_v2 || []).find(
      (acc) => String(acc.value) === String(selected_threads_access_seq || "")
    );
    const previewAccount = instagramPublishEnabled
      ? (selectedInstagramPreviewAccount || {
          title: hasInstagramAccounts ? "계정 미선택" : "계정 미연동",
          profile_picture_url: null,
        })
      : (selectedThreadsPreviewAccount || {
          title: hasThreadsAccounts ? "Threads 계정 미선택" : "Threads 계정 미연동",
          profile_picture_url: null,
        });
    
    const previewSlots = this.getFilledSlots();
    const imgs = previewSlots.map((slot) => this.getSlotPreviewUrl(slot));
    const hasSlides = imgs.length > 1 && this.state.selectedFeedType !== "REELS";
    const currentIdx = imgs.length ? ((this.state.previewSlideIndex % imgs.length) + imgs.length) % imgs.length : 0;
    const currentSlot = previewSlots.length > 0 ? previewSlots[currentIdx] : null;
    const currentIsVideo = this.isVideoSlot(currentSlot);
    const currentVideoUrl = currentIsVideo ? this.getSlotVideoUrl(currentSlot) : "";
    const currentPosterUrl = currentIsVideo ? this.getSlotPosterUrl(currentSlot) : "";
    const currentImg = currentIsVideo ? (currentVideoUrl || currentPosterUrl) : (currentSlot ? this.getSlotPreviewUrl(currentSlot) : null);
    const currentSlotIndex = currentSlot
      ? (this.state.imageSlots || []).findIndex((slot) => slot === currentSlot)
      : -1;
    const previewAspectRatio = currentIsVideo
      ? this.getSlotDisplayRatio(currentSlot)
      : (this.state.currentRatio ? this.state.currentRatio : "1/1");

    // --- 계정 리스트 동적 생성 로직 ---
    let displayAccountList = [];
    let selectedAccountText = null;
    if (!accountConnected || !account_list_v2 || account_list_v2.length === 0) {
        // 계정 연동이 안 된 상태일 때
        displayAccountList = [
            { title: "+ 인스타그램 연동하기", value: "add" }
        ];

        selectedAccountText = "계정 연동하기";
    } else {
        // 계정 연동이 된 상태일 때 (계종명 앞에 @ 붙이기)
        displayAccountList = _.cloneDeep(account_list_v2 || []);
        displayAccountList = account_list_v2.map(acc => {
            return {
                ...acc, // 기존 속성(value, profile_picture_url 등)은 그대로 복사
                // 방어 로직: 혹시 이미 @가 붙어있다면 그대로 두고, 없다면 붙임
                title: acc.title.startsWith('@') ? acc.title : '@' + acc.title 
            };
        });
    }

    let displayThreadsAccountList = [];
    let selectedThreadsAccountText = null;
    if (!threadsAccountConnected || !threads_account_list_v2 || threads_account_list_v2.length === 0) {
      displayThreadsAccountList = [{ title: "+ Threads 연동하기", value: "add" }];
      selectedThreadsAccountText = "계정 연동하기";
    } else {
      displayThreadsAccountList = threads_account_list_v2.map((acc) => ({
        ...acc,
        title: acc.title && acc.title.startsWith("@") ? acc.title : `@${acc.title || "Threads 계정"}`,
      }));
      const selectedThreads = displayThreadsAccountList.find(
        (acc) => String(acc.value) === String(selected_threads_access_seq || "")
      );
      selectedThreadsAccountText = selectedThreads ? selectedThreads.title : null;
    }

    // 1. [개수 계산용] 배열의 길이가 곧 태그의 개수 (정규식 필요 없음!)
    const tagCount = tags.length;

    // 2. [글자 수 계산용] 배열을 띄어쓰기 한 칸으로 예쁘게 연결
    const hashtagText = tags.join(" "); 

    // 3. 해시태그 총 길이 (본문과 태그 사이 줄바꿈/띄어쓰기 1자 포함)
    const hashtagLength = hashtagText.length > 0 ? hashtagText.length + 1 : 0; 

    // 4. 본문 최대 입력 가능 길이 계산 (2,200자 - 해시태그 길이)
    const maxCaptionLength = Math.max(0, 2200 - hashtagLength);
  
    return (
      <>
      <div className="instagram_post_page">
        <div className="main-wrapper" id="page-wrapper" style={{ paddingTop: '72px', maxWidth: '100%', height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f3f4f6', fontFamily: "'Noto Sans KR', sans-serif" }}>
          {/* --- [STYLE] HTML에서 가져온 전체 CSS --- */}
          <style>
            {
              `
                .common_popup_frame_v2_content:has(.instagram-no-accounts) {
                  max-width: 720px !important;
                  width: min(720px, calc(100vw - 32px)) !important;
                  word-break: keep-all;
                }
              `
            }
          </style>
          <style>{`
              .instagram_post_page {
                  --primary-mint: #00e2e6;
                  --primary-mint-hover: #00bfc2;
                  --deep-navy: #0A1A2F;
                  --deep-navy-hover: #111C3A;
                  --bg-color: #f3f4f6; 
                  --border-color: #e5e7eb;
                  --text-main: #0A1A2F;
                  --text-sub: #6b7280;
                  --white: #ffffff;
                  --radius-md: 12px;
                  --radius-sm: 8px;
              }
              .instagram_post_page .w-100-percent { width: 100% !important; }
              .instagram_post_page .main-wrapper * { box-sizing: border-box; font-size: 14px; }
              .instagram_post_page .main-wrapper textarea { font-family: 'Noto Sans KR', sans-serif; font-size: 14px !important;}
              .instagram_post_page .main-wrapper input { font-family: 'Noto Sans KR', sans-serif; font-size: 14px;}
              .instagram_post_page .main-wrapper input::placeholder { font-family: 'Noto Sans KR', sans-serif; font-size: 14px;}
              .instagram_post_page .main-wrapper textarea::placeholder { font-family: 'Noto Sans KR', sans-serif; font-size: 14px;}
              .instagram_post_page .main-wrapper button { box-shadow: 0 0 0 0px transparent !important; }

              .instagram-volume-range,
              .instagram-volume-range:hover,
              .instagram-volume-range:focus,
              .instagram-volume-range:active {
                -webkit-appearance: none;
                appearance: none;

                width: 100%;
                height: 6px;
                border-radius: 999px;
                outline: none;
                border: none;

                background: linear-gradient(
                  to right,
                  #00C4B5 0%,
                  #00C4B5 var(--range-value),
                  #e5e7eb var(--range-value),
                  #e5e7eb 100%
                );

                cursor: pointer;
              }

              /* Chrome / Safari / Edge */
              .instagram-volume-range::-webkit-slider-runnable-track {
                height: 6px;
                border-radius: 999px;
                border: none;
                background: transparent;
              }

              .instagram-volume-range::-webkit-slider-thumb {
                -webkit-appearance: none;
                appearance: none;

                width: 16px;
                height: 16px;

                margin-top: -5px;

                border-radius: 50%;
                border: none;
                outline: none;

                background: #00C4B5;
                box-shadow: none;

                cursor: pointer;
              }

              /* Firefox */
              .instagram-volume-range::-moz-range-track {
                height: 6px;
                border-radius: 999px;
                border: none;
                background: transparent;
              }

              .instagram-volume-range::-moz-range-thumb {
                width: 16px;
                height: 16px;

                border-radius: 50%;
                border: none;

                background: #00C4B5;
                box-shadow: none;

                cursor: pointer;
              }

              .instagram-volume-range:focus {
                outline: none;
                box-shadow: none;
              }

              .instagram_post_page .main-wrapper .react-datepicker-wrapper { margin-bottom: 0; }

              .instagram_post_page #page-wrapper { max-width: 100% !important; padding-top: 72px !important; }
              @media (min-width: 801px) {
                  body:has(.instagram_post_page) { overflow: hidden !important; }
                  .instagram_post_page#page-wrapper { padding-top: 72px !important; }
                  .instagram_post_page .header-row { 
                    width: 100% !important; 
                    box-sizing: border-box !important; /* 100%가 패딩 안쪽 기준이 되도록 설정 */
                    position: relative !important;     /* 혹시 외부 CSS에서 fixed로 띄운 걸 강제로 주저앉힘 */
                    margin-top: 0 !important; 
                    margin-left: 0 !important; 
                    margin-right: 0 !important;
                    min-width: 1300px;
                  }
                  .instagram_post_page .main-container { 
                      flex: 1;
                      display: grid;
                      grid-template-columns: minmax(0, 1fr) 380px;
                      min-height: 0;
                      overflow: hidden;
                  }
                  .instagram_post_page .input-scroll-area {
                    min-height: 0;
                    height: 100%;
                    display: grid;
                    grid-template-columns: 1fr;
                    align-items: stretch;
                    overflow-y: auto;
                  }

                  .instagram_post_page .editor-form-stack,
                  .instagram_post_page .preview-fixed-area {
                    min-height: 100%;
                    background: #ffffff;
                  }
              }
              .instagram_post_page {
                /* Tooltips */
                .nav-tooltip { position: absolute; left: 100%; margin-left: 14px; background: var(--deep-navy); color: white; padding: 6px 12px; border-radius: 6px; font-size: 12px; font-weight: 600; white-space: nowrap; pointer-events: none; opacity: 0; transform: translateX(-10px); transition: all 0.2s; z-index: 200; box-shadow: 0 4px 12px rgba(10,26,47,0.15); }
                .nav-tooltip::before { content: ''; position: absolute; right: 100%; top: 50%; transform: translateY(-50%); border-width: 5px; border-style: solid; border-color: transparent var(--deep-navy) transparent transparent; }
                .nav-item:hover .nav-tooltip { opacity: 1; transform: translateX(0); }

                .has-tooltip { position: relative; display: inline-flex; align-items: center; justify-content: center; border: 1px solid transparent; border-radius: 6px; }
                .has-tooltip:not(:has(.chip-new)):hover { 
                  border: 1px solid var(--primary-mint) !important;
                }
                .has-tooltip:hover .segment-btn {
                  background: #f0fdfe !important; 
                  color: #00736D !important;
                }
                .tooltip-down { position: absolute; top: 100%; left: 50%; transform: translateX(-50%) translateY(10px); background: var(--deep-navy); color: white; padding: 6px 12px; margin-top: 6px; border-radius: 6px; font-size: 12px; font-weight: 600; white-space: nowrap; pointer-events: none; opacity: 0; visibility: hidden; transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1); z-index: 2000; box-shadow: 0 4px 12px rgba(10,26,47,0.15); }
                .tooltip-down::before { content: ''; position: absolute; bottom: 100%; left: 50%; transform: translateX(-50%); border-width: 5px; border-style: solid; border-color: transparent transparent var(--deep-navy) transparent; }
                .has-tooltip:hover .tooltip-down { opacity: 1; visibility: visible; transform: translateX(-50%) translateY(0); }

                .tooltip-up { position: absolute; bottom: 100%; left: 50%; transform: translateX(-50%) translateY(-10px); background: var(--deep-navy); color: white; padding: 6px 12px; margin-bottom: 6px; border-radius: 6px; font-size: 12px; font-weight: 600; white-space: nowrap; pointer-events: none; opacity: 0; visibility: hidden; transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1); z-index: 2000; box-shadow: 0 4px 12px rgba(10,26,47,0.15); }
                .tooltip-up::before { content: ''; position: absolute; top: 100%; left: 50%; transform: translateX(-50%); border-width: 5px; border-style: solid; border-color: var(--deep-navy) transparent transparent transparent; }
                .has-tooltip:hover .tooltip-up { opacity: 1; visibility: visible; transform: translateX(-50%) translateY(0); }
                
                .has-tooltip:hover svg path[stroke]:not([stroke="none"]) {
                  stroke: currentColor;
                }
                .has-tooltip:hover svg path[fill]:not([fill="none"]) {
                  fill: currentColor;
                }

                /* Header */
                .header-row {
                  flex-shrink: 0;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  background: #ffffff;
                  padding: 14px 24px;
                  border-bottom: 1px solid #e5e7eb;
                  z-index: 1000;
                  box-shadow: 0 4px 12px rgba(10, 26, 47, 0.04);
                  margin-top: 0 !important;
                  flex-wrap: wrap;
                  gap: 16px;
                }
                .page-title { font-size: 20px; font-weight: 800; display: flex; align-items: center; gap: 10px; color: var(--deep-navy); }
                .page-title::before { content: ''; width: 6px; height: 20px; background: var(--primary-mint); border-radius: 3px; display: block; }
                .page-title-group { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
                .post-type-control .segment-btn { border: 1px solid transparent; min-width: 54px; justify-content: center; padding: 7px 12px; }
                .post-type-control .segment-btn:hover { 
                  border: 1px solid var(--primary-mint) !important;
                  color: #00736D;
                  background: #f0fdfe !important;
                }
                .post-type-control .segment-btn:hover svg path[stroke]:not([stroke="none"]) {
                  stroke: currentColor;
                }
                .post-type-control .segment-btn:hover svg path[fill]:not([fill="none"]) {
                  fill: currentColor;
                }

                .header-actions { display: flex; align-items: center; gap: 12px; }

                /* v4: 발행 채널 서브바 */
                .publish-channel-bar {
                  flex-shrink: 0;
                  display: flex;
                  align-items: center;
                  gap: 16px;
                  min-height: 64px;
                  padding: 10px 24px;
                  background: #ffffff;
                  border-bottom: 1px solid var(--border-color);
                  z-index: 900;
                }
                .publish-channel-title {
                  font-size: 13px;
                  font-weight: 800;
                  color: var(--deep-navy);
                  white-space: nowrap;
                }
                .publish-platform-buttons {
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  padding-right: 16px;
                  border-right: 1px solid var(--border-color);
                }
                .publish-platform-button {
                  height: 40px;
                  display: inline-flex;
                  align-items: center;
                  gap: 8px;
                  padding: 0 14px;
                  border-radius: 9px;
                  border: 1px solid #d1d5db;
                  background: #ffffff;
                  color: #9ca3af;
                  font-size: 13px;
                  font-weight: 800;
                  cursor: pointer;
                  transition: all 0.18s ease;
                }
                .publish-platform-button svg { opacity: .45; }
                .publish-platform-button.active {
                  border-color: var(--primary-mint);
                  background: #f0fdfe;
                  color: var(--deep-navy);
                  box-shadow: 0 0 0 1px rgba(0,226,230,.08) !important;
                }
                .publish-platform-button.active svg { opacity: 1; }
                .publish-platform-button:hover {
                  border-color: var(--primary-mint);
                  background: #f8ffff;
                }
                .publish-channel-accounts {
                  display: flex;
                  align-items: center;
                  gap: 12px;
                  min-width: 0;
                }
                .publish-account-group {
                  display: flex;
                  align-items: center;
                  gap: 8px;
                }
                .publish-account-label {
                  font-size: 12px;
                  font-weight: 700;
                  color: #6b7280;
                  white-space: nowrap;
                }
                .publish-account-select { width: 200px; }

                .slot-add:hover {
                    border-color: var(--primary-mint) !important;
                    color: var(--primary-mint) !important;
                    background: #f0fdfe !important;
                }
                
                /* UI Components */
                .segmented-control { display: flex; background: var(--bg-color); padding: 4px; border-radius: var(--radius-sm); border: 1px solid var(--border-color); gap: 4px; }
                .segment-btn { display: flex; gap: 5px; align-items: center; padding: 8px 16px; border-radius: 6px; font-size: 13px; font-weight: 700; color: var(--text-sub); cursor: pointer; border: none; background: transparent; transition: all 0.2s; white-space: nowrap; flex: 1; text-align: center; }
                .segment-btn.active { background: var(--white); color: var(--deep-navy); box-shadow: 0 1px 3px rgba(32, 32, 32, 0.08), 0 3px 8px rgba(32, 32, 32, 0.05) !important; }
                
                .btn { height: 42px; padding: 0 20px; border-radius: var(--radius-sm); font-size: 14px; font-weight: 700; cursor: pointer; border: none; transition: 0.2s; display: inline-flex; align-items: center; justify-content: center; gap: 6px; white-space: nowrap; }
                .btn-primary { background: var(--primary-mint); color: var(--deep-navy); box-shadow: 0 2px 8px rgba(0, 226, 230, 0.2); }
                .btn-primary:hover { background: var(--primary-mint-hover); color: var(--deep-navy); transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0, 226, 230, 0.3); }
                .btn-primary:active { background: var(--primary-mint-hover) !important; color: var(--deep-navy) !important; transform: translateY(-1px) !important; box-shadow: 0 4px 12px rgba(0, 226, 230, 0.3) !important; }
                .btn-primary:focus { background: var(--primary-mint-hover) !important; color: var(--deep-navy) !important; transform: translateY(-1px) !important; box-shadow: 0 4px 12px rgba(0, 226, 230, 0.3) !important; }
                .btn-black { background: #111827; color: var(--primary-mint); }
                .btn-black:hover { background: var(--primary-mint); transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); color: #111827; }
                .btn-purple { background: #f5f3ff; border: 1px solid #ddd6fe; color: #6d28d9; }
                .btn-purple:hover { background: #ede9fe; border-color: #c4b5fd; color: #581c87; }
                .icon-btn-purple { background: #f5f3ff; border: 1px solid #ddd6fe; cursor: pointer; font-size: 14px; margin-left: 6px; padding: 4px 8px; border-radius: 6px; transition: 0.2s; color: #6d28d9; vertical-align: middle; }
                .icon-btn-purple:hover { background: #ede9fe; border-color: #c4b5fd; color: #581c87; }
                .btn-outline { background: var(--white); border: 1px solid #d1d5db; color: #4b5563; }
                .btn-outline:hover { 
                  border-color: var(--primary-mint) !important;
                  color: var(--deep-navy); 
                  background: #f0fdfe !important;
                }
                .btn-apply { height: 34px; padding: 0 16px; border-radius: 6px; font-size: 13px; font-weight: 700; background: var(--white); border: 1px solid #cbd5e1; color: #475569; transition: 0.2s; }
                .ai-card:hover .btn-apply { border-color: var(--primary-mint); color: #0d9488; background: #f0fdfe; }
                
                /* Main Layout */
                .main-container {
                  flex: 1;
                  display: grid;
                  // grid-template-columns: 72px minmax(0, 1fr) 380px;
                  grid-template-columns: minmax(0, 1fr) 380px;
                  height: 100%;
                  min-height: 0;
                  overflow: hidden;
                  margin-top: 0 !important;
                  width: 100%;
                  // background: #f6f8fb;
                  background: #ffffff;
                }

                .side-nav-area {
                  background: #ffffff;
                  border-right: 1px solid #e5e7eb;
                  padding: 24px 0;
                  display: flex;
                  flex-direction: column;
                  gap: 18px;
                  align-items: center;
                  z-index: 10;
                  box-shadow: 2px 0 8px rgba(10, 26, 47, 0.02);
                }
                
                .nav-item { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; width: 64px; height: 64px; border-radius: 12px; cursor: pointer; color: #9ca3af; transition: 0.2s; position: relative; }
                .nav-item:hover { background: var(--bg-color); color: var(--deep-navy); }
                .nav-item.active { background: #f0fdfe; color: #0d9488; font-weight: 700; box-shadow: 0 2px 6px rgba(0,226,230,0.15); }
                .nav-icon { font-size: 20px; }
                .nav-label { font-size: 11px; }

                .input-scroll-area {
                  padding: 0px;
                  margin: 20px 24px;
                  // overflow-y: auto;
                  display: grid;
                  grid-template-columns: 1fr;
                  align-items: stretch;
                  align-content: stretch;
                  min-height: 0;
                  // height: 100%;
                  height: calc(100% - 40px);
                  gap: 10px;
                  scroll-behavior: smooth;
                  // background: #f6f8fb;
                  background: #ffffff;
                }

                .editor-form-stack {
                  display: flex;
                  flex-direction: column;
                  min-width: 0;
                  min-height: 100%;
                  overflow: auto;
                }

                .input-scroll-area::-webkit-scrollbar { width: 10px; }
                .input-scroll-area::-webkit-scrollbar-track { background: transparent; }
                .input-scroll-area::-webkit-scrollbar-thumb { background-color: #cbd5e1; border-radius: 10px; border: 2px solid var(--bg-color); }
                .input-scroll-area::-webkit-scrollbar-thumb:hover { background-color: #9ca3af; }

                .reels-section-row {
                  min-width: 0;
                }

                .reels-section-row.is-reels {
                  display: grid;
                  grid-template-columns: 212px minmax(0, 1fr);
                  align-items: start;
                  gap: 24px;
                }

                .reels-section-row.is-reels > .card {
                  min-width: 0;
                  width: 100%;
                  box-sizing: border-box;
                }

                .card {
                  background: #ffffff;
                  border-radius: 10px;
                  // border: 1px solid #e5e7eb;
                  border: 0px solid #e5e7eb;
                  padding: 24px 28px;
                  // box-shadow: 0 2px 10px rgba(10, 26, 47, 0.03);
                }
                #sec-caption {
                  padding-top: 0 !important;
                }
                #sec-hashtag {
                  padding-top: 0 !important;
                }
                .section-header {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 18px;
                }

                .section-title {
                  font-size: 18px;
                  font-weight: 800;
                  color: #0A1A2F;
                  display: flex;
                  align-items: center;
                  gap: 6px;
                }

                /* 문구 작성 박스 */
                #sec-caption textarea {
                  min-height: 180px;
                  border: 1px solid #dbe2ea !important;
                  border-radius: 0 0 8px 8px !important;
                  resize: vertical;
                  color: #374151;
                  line-height: 1.6;
                }

                .status-badge { font-size: 12px; font-weight: 600; color: var(--text-sub); background: var(--bg-color); padding: 6px 12px; border-radius: 6px; display: inline-flex; align-items: center; gap: 6px; border: 1px dashed #cbd5e1; cursor: help; }
                
                .toolbar {
                  display: flex;
                  gap: 8px;
                  padding: 10px 14px;
                  background: #f8fafc;
                  border: 1px solid #dbe2ea;
                  border-bottom: none;
                  border-radius: 8px 8px 0 0;
                }

                
                .tool-btn { background: var(--white); border: 1px solid #d1d5db; border-radius: 4px; padding: 4px 10px; font-size: 13px; cursor: pointer; color: #475569; transition: 0.2s; }
                .tool-btn:hover { background: var(--bg-color); border-color: var(--primary-mint); color: var(--primary-mint-hover); }

                .chip-container { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 12px; align-items: center; }
                .phrase-chip { padding: 8px 16px; border-radius: 20px; font-size: 13px; font-weight: 500; cursor: pointer; background: var(--bg-color); border: 1px solid #EEEEEE; color: #374151; display: flex; align-items: center; gap: 6px; transition: 0.2s; }
                .phrase-chip:not(.chip-new):hover { 
                  border: 1px solid var(--primary-mint) !important;
                  color: #00736D;
                  background: #f0fdfe !important;
                }
                .chip-hashtag { color: #374151 !important; background:white !important; border: 1px solid #7c8390 !important; }
                .chip-new { border: 1px dashed #9ca3af; background: transparent; color: #374151; }
                .chip-new:hover { 
                  border-color: var(--primary-mint) !important;
                  background: #f0fdfe !important;
                }
                .chip-delete { font-size: 14px; color: #9ca3af; padding-left: 2px; transition: 0.2s; }
                .chip-delete:hover { color: #dc2626; transform: scale(1.2); }

                .ai-section { margin-top: 32px; padding: 24px; background: #edf7ff; border-radius: 12px; border: 1px solid #e2e8f0; }
                .ai-header-row {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 18px;
                  flex-wrap: wrap;
                  gap: 12px;
                }
                .ai-card {
                  background: #ffffff;
                  border: 1px solid #e5e7eb;
                  border-radius: 9px;
                  padding: 12px;
                  cursor: pointer;
                  transition: 0.2s;
                  position: relative;
                  box-shadow: 0 2px 6px rgba(10, 26, 47, 0.03);
                  margin-bottom: 0;
                  // min-height: 128px;
                }

                .ai-card:hover {
                  border-color: #00e2e6;
                  box-shadow: 0 6px 18px rgba(0, 226, 230, 0.12);
                  transform: translateY(-2px);
                }
                
                /* 일체형 프롬프트 입력창 (Search bar style) */
                .ai-prompt-container {
                  display: flex;
                  align-items: center;
                  background: #ffffff;
                  border: 2px solid #d1d5db;
                  border-radius: 8px;
                  padding: 6px;
                  box-shadow: 0 2px 8px rgba(10, 26, 47, 0.03);
                  transition: all 0.2s;
                  margin-bottom: 6px;
                }
                .ai-prompt-container:focus-within {
                  border-color: #00e2e6;
                  box-shadow: 0 0 0 4px rgba(0, 226, 230, 0.15);
                }
                .ai-prompt-input {
                  flex: 1;
                  border: none !important;
                  background: transparent;
                  padding: 14px 16px;
                  font-size: 15px;
                  color: #0A1A2F;
                  outline: none;
                  font-family: inherit;
                }

                .ai-result-grid {
                  display: flex;
                  flex-direction: column;
                  gap: 16px;
                }

                /* Preview Area */
                .preview-fixed-area {
                  padding: 24px 24px;
                  background: #ffffff;
                  border-left: 1px solid #e5e7eb;
                  overflow-y: auto;
                  box-shadow: -2px 0 8px rgba(10, 26, 47, 0.02);
                  z-index: 10;
                  min-height: 100%;
                }

                .insta-frame {
                  background: #ffffff;
                  border: 1px solid #dbdbdb;
                  border-radius: 8px;
                  width: 100%;
                  max-width: 330px;
                  margin: 0 auto;
                  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
                  word-break: break-word;
                  overflow: hidden;
                }

                /* Modals */
                .modal-overlay { display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(10,26,47,0.6); z-index: 9999; align-items: center; justify-content: center; 
                    /* -backdrop-filter: blur(2px); */
                }
                .modal-overlay.open { display: flex; animation: fadeIn 0.2s ease; }
                .modal-box { background: var(--white); width: 440px; max-width: 90%; border-radius: 16px; padding: 32px; box-shadow: 0 20px 50px rgba(10,26,47,0.2); animation: slideUp 0.3s ease; position: relative; }
                .modal-close-button { position: absolute; top: 16px; right: 16px; width: 24px; height: 24px; border: 0; border-radius: 50%; color: #0e1d32; font-size: 22px; line-height: 32px; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: 0.2s; z-index: 1; background: transparent; padding: 2px; }
                .modal-close-button:hover { background: #e2e8f0; color: #0A1A2F; }
                .modal-title { font-size: 20px; font-weight: 800; margin-bottom: 20px; color: var(--deep-navy); }
                
                #ig_account_select {
                  // background-color: var(--bg-color);
                  // font-weight: 700;
                  color: var(--deep-navy);
                }

                .date-wrapper { width: 130px; display: block; }
                .time-wrapper { width: 110px; display: block; }

                .custom-date-picker, .custom-time-picker {
                    height: 42px !important;
                    padding: 0 12px !important;
                    padding-right: 32px !important; /* 아이콘이 들어갈 우측 여백 */
                    width: 100% !important;
                    font-family: 'Noto Sans KR', sans-serif;
                    font-size: 14px;
                    color: var(--deep-navy);
                    background-repeat: no-repeat;
                    background-position: right 10px center;
                    cursor: pointer;
                    background-color: var(--white);
                    border: 1px solid var(--border-color) !important;
                    border-radius: var(--radius-sm);
                    transition: all 0.2s;
                    box-sizing: border-box;
                }

                /* 클릭(포커스) 되었을 때 테두리 색상 변경 */
                .custom-date-picker:focus, .custom-time-picker:focus {
                    border-color: var(--primary-mint) !important;
                    outline: none;
                    box-shadow: 0 0 0 3px rgba(0, 226, 230, 0.15) !important;
                }

                /* 날짜 입력창 우측 달력 SVG 아이콘 */
                .custom-date-picker {
                    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="%236b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>');
                }

                /* 시간 입력창 우측 시계 SVG 아이콘 */
                .custom-time-picker {
                    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="%236b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>');
                }

                #imageSelectModal h4 {
                  font-size: 1.1em !important;
                  font-weight: 700 !important;
                  margin-top: 0 !important;
                }

                .form-control:focus {
                    outline: none;
                    border-color: var(--primary-mint) !important;
                    box-shadow: 0 0 0 3px rgba(0, 226, 230, 0.15);
                }

                /* [Info Banner] */
                .info-banner { background: #f5f3ff; border: 1px solid #ddd6fe; border-radius: var(--radius-md); padding: 16px 24px; display: flex; justify-content: space-between; align-items: center; box-shadow: 0 2px 8px rgba(109, 40, 217, 0.05); gap: 16px; flex-wrap: wrap; }
                .info-banner-text { color: #581c87; font-weight: 600; font-size: 14px; display: flex; align-items: center; gap: 8px; }

                .has-tooltip:has(#select_option_area) .tooltip-down { display: none !important; }

                .modal-overlay open { z-index: 9999 !important; }

                .instagram_post_page .common_text_input input {
                    width: 100%;
                    padding: 12px 16px;
                    border: 2px solid #e5e7eb;
                    border-radius: 8px;
                    font-size: 14px;
                    transition: all 0.2s;
                    background: white;
                    color: #0A1A2F;
                }

                .instagram_post_page .common_text_input input:focus {
                    outline: none;
                    border-color: #00e2e6;
                    box-shadow: 0 0 0 3px rgba(0, 226, 230, 0.1);
                }
                
                .instagram_post_page .common_text_input input:hover {
                    outline: none;
                    border-color: #e5e7eb;
                }

                .order-controls {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                }

                /* Setting Link */
                .setting-link { display: inline-flex; align-items: center; gap: 4px; font-size: 13px; font-weight: 600; color: var(--text-sub); background: var(--bg-color); padding: 8px 16px; border-radius: 5px; border: 1px solid #cbd5e1; cursor: pointer; transition: 0.2s; text-decoration: none; line-height: 0;}
                .setting-link:hover { border-color: var(--deep-navy); color: var(--deep-navy); background: white; }

                button:focus {
                  box-shadow: none !important;
                }

                .gpt-usage-inline {
                  font-size: 12px;
                  font-weight: 400;
                  color: #8e8e8e;
                  margin-bottom: 6px;
                  text-align: right;
                  display: flex;
                  flex-wrap: wrap;
                  justify-content: flex-end;
                  align-items: center;
                  gap: 5px;
                }
                .gpt-usage-inline span {
                  font-weight: 400 !important;
                  font-size: 12px;
                  color: #8e8e8e !important;
                }  

                /* 민트 버튼 스타일 */
                /* 1. 두 버튼의 기본 레이아웃 스타일 */
                .btn-mint {
                  padding: 12px 24px;
                  font-size: 15px;
                  font-weight: 500;
                  color: #00A396;
                  background-color: #FFFFFF;
                  border: 1px solid #00C4B5;
                  border-radius: 6px;
                  cursor: pointer;
                  transition: all 0.2s ease-in-out;
                }

                /* 2. 이미 선택된(Active) 버튼의 고정 스타일 */
                .btn-mint.active {
                  background-color: #F0FBFB; /* 옅은 청록색 배경 고정 */
                  color: #00A396; /* 선택됨을 강조하는 진한 텍스트 */
                  font-weight: 700;
                }

                /* 3. 🎯 완벽하게 통일된 호버(Hover) 규칙 */
                /* 기본 버튼이든, 선택된(Active) 버튼이든 마우스를 올리면 동일한 효과 적용 */
                .btn-mint:hover, 
                .btn-mint.active:hover {
                  background-color: #E0F7F6; /* 기존보다 살짝만 더 짙어진 옅은 청록색 */
                  border-color: #00A396; /* 테두리 포인트 컬러 */
                  color: #00A396; /* 텍스트도 동일하게 포인트 컬러로 변경 */
                }

                /* AI 카피라이터 실행 버튼과 높이/기본 여백 통일 */
                #hashtag-ai-button {
                  height: 42px;
                  min-height: 42px;
                  padding: 0 20px;
                  margin: 0;
                }

                /* 이미지 슬롯 첫 번째 tooltip만 왼쪽 밖으로 안 나가게 보정 */
                .slot-container > .image-slot.primary.has-tooltip .tooltip-down {
                  left: 0;
                  transform: translateX(0) translateY(10px);
                }

                /* hover 시에도 기존 공통 hover transform을 덮어쓰기 */
                .slot-container > .image-slot.primary.has-tooltip:hover .tooltip-down {
                  transform: translateX(0) translateY(0);
                }

                /* 말풍선 삼각형 위치 보정 */
                .slot-container > .image-slot.primary.has-tooltip .tooltip-down::before {
                  left: 50px;
                  transform: translateX(-50%);
                }

                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

                /* 모바일 */
                @media (max-width: 1200px) {
                  .reels-section-row.is-reels {
                    grid-template-columns: 1fr;
                    gap: 0;
                  }

                  .main-container {
                    grid-template-columns: 1fr;
                  }

                  .input-scroll-area {
                    grid-template-columns: 1fr;
                  }


                  .preview-fixed-area {
                    display: none;
                  }
                }

                @media (max-width: 800px) {
                  #page-wrapper {
                    height: auto !important;
                    padding-top: 60px !important;
                    padding-bottom: 92px !important;
                    padding-left: 0 !important;
                    padding-right: 0 !important;
                  }

                  .main-container {
                    display: flex;
                    flex-direction: column;
                    height: auto;
                    overflow: visible;
                    margin-top: 0;
                  }

                  .input-scroll-area {
                    grid-template-columns: 1fr;
                  }


                  .side-nav-area {
                    display: none;
                  }

                  .input-scroll-area {
                    padding: 20px 16px;
                    height: auto;
                    overflow: visible;
                    gap: 20px;
                    margin: 5%;
                  }
                  .card {
                    padding: 3%;
                  }

                  #hashtag-ai-button {
                    width: 100%;
                    justify-content: center;
                    margin-top: 10px;
                  }

                  div:has(#hashtag-ai-button) {
                    flex-wrap: wrap;
                  }

                  .preview-fixed-area {
                    display: block;
                    border-left: none;
                    border-top: 1px solid #e5e7eb;
                    padding: 32px 16px;
                  }

                  .header-row {
                    position: sticky;
                    top: 60px;
                    flex-direction: column;
                    align-items: stretch;
                    gap: 12px;
                    margin-top: 0;
                    height: auto;
                  }

                  .page-title-group {
                    width: 100%;
                    justify-content: space-between;
                  }

                  .header-actions {
                    flex-direction: column;
                    align-items: stretch;
                    width: 100%;
                    gap: 10px;
                  }

                  .segmented-control {
                    width: 100%;
                    display: flex;
                  }

                  .segment-btn {
                    flex: 1;
                    text-align: center;
                  }

                  .hide-mobile {
                    display: none;
                  }

                  .tooltip-down,
                  .tooltip-up {
                    display: none !important;
                  }

                  #ig_account_select_wrapper {
                    width: 100% !important;
                  }

                  .publish-channel-bar {
                    flex-direction: column;
                    align-items: stretch;
                    gap: 10px;
                    padding: 12px 16px;
                  }
                  .publish-platform-buttons {
                    width: 100%;
                    border-right: 0;
                    padding-right: 0;
                  }
                  .publish-platform-button { flex: 1; justify-content: center; }
                  .publish-channel-accounts {
                    width: 100%;
                    flex-direction: column;
                    align-items: stretch;
                  }
                  .publish-account-group {
                    width: 100%;
                    flex-direction: column;
                    align-items: stretch;
                    gap: 5px;
                  }
                  .publish-account-select { width: 100%; }

                  .ai-prompt-container {
                    flex-direction: column;
                    align-items: stretch;
                    padding: 10px;
                    gap: 8px;
                  }

                  .ai-prompt-container .btn-black {
                    width: 100%;
                    justify-content: center;
                    margin: 0;
                  }

                  .ai-copywriter-btns-container {
                    flex-wrap: wrap;
                    gap: 10px !important;
                  }
                  .ai-copywriter-btns {
                    width: 100%;
                  }
                }
              }
              .instagram_post_page .copywriter-inline-launch-button {
                background: #0A1A2F;
                color: #ffffff;
                border: 1px solid #0A1A2F;
              }
              .instagram_post_page .copywriter-inline-launch-button:hover {
                background: #111C3A;
                border-color: #111C3A;
                color: #ffffff;
              }

              .instagram_post_page:not(:has(#templateModal)) em-emoji-picker {
                display: flex !important;
                top: 0px !important;
                left: 0px !important;
              }
              @media (max-width: 800px) {
                .instagram_post_page:not(:has(#templateModal)) em-emoji-picker {
                  left: 0px !important;
                }
              }

              .ai-video-studio-workflow .modal-box {
                padding: 0 !important;
              }
          `}</style>
    
          {/* --- [HEADER] --- */}
          <header className="header-row" data-instagram-tutorial="post-header">
            <div className="page-title-group">
              <div className="page-title">콘텐츠 등록</div>
              <div className="segmented-control post-type-control" data-instagram-tutorial="post-content-type">
                <button
                  data-instagram-tutorial="post-feed-tab"
                  className={`segment-btn ${this.state.selectedFeedType !== "REELS" ? "active" : ""}`}
                  onClick={() => this.selectPostContentType("FEED")}
                >
                  <div style={{width: "24px", height: "24px", display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_2803_100)">
                      <path d="M10.5254 18.9337C11.0404 18.9337 11.458 18.5135 11.458 17.9953C11.458 17.477 11.0404 17.0569 10.5254 17.0569C10.0103 17.0569 9.59277 17.477 9.59277 17.9953C9.59277 18.5135 10.0103 18.9337 10.5254 18.9337Z" fill="#333333"/>
                      <path d="M16.5674 18.9337C17.0824 18.9337 17.5 18.5135 17.5 17.9953C17.5 17.477 17.0824 17.0569 16.5674 17.0569C16.0523 17.0569 15.6348 17.477 15.6348 17.9953C15.6348 18.5135 16.0523 18.9337 16.5674 18.9337Z" fill="#333333"/>
                      <path d="M16.8785 23H10.2386C7.90312 23 5.99805 21.0831 5.99805 18.7331V17.9231C5.99805 15.5731 7.90312 13.6562 10.2386 13.6562H16.8785C19.214 13.6562 21.1191 15.5731 21.1191 17.9231V18.7331C21.1191 21.0831 19.214 23 16.8785 23ZM10.2386 15.172C8.73211 15.172 7.51254 16.4072 7.51254 17.915V18.7251C7.51254 20.241 8.73211 21.4681 10.2386 21.4681H16.8785C18.385 21.4681 19.6046 20.241 19.6046 18.7251V17.915C19.6046 16.3992 18.377 15.172 16.8785 15.172H10.2386Z" fill="#333333"/>
                      <path d="M14.1203 12.1243H13.0044V14.0813H14.1203V12.1243Z" fill="#333333"/>
                      <path d="M13.5625 20.658C12.9408 20.658 12.3589 20.4094 12.2951 20.3773C12.056 20.273 11.9444 19.9923 12.048 19.7437C12.1516 19.5031 12.4386 19.3908 12.6777 19.4951C12.6777 19.4951 13.14 19.6956 13.5705 19.6956C14.0009 19.6956 14.4553 19.5031 14.4632 19.4951C14.7024 19.3908 14.9893 19.4951 15.0929 19.7437C15.1966 19.9843 15.0929 20.273 14.8458 20.3773C14.7821 20.4094 14.1922 20.658 13.5785 20.658H13.5625Z" fill="#333333"/>
                      <path d="M13.5622 12.7178C14.3282 12.7178 14.9492 12.093 14.9492 11.3222C14.9492 10.5515 14.3282 9.9267 13.5622 9.9267C12.7963 9.9267 12.1753 10.5515 12.1753 11.3222C12.1753 12.093 12.7963 12.7178 13.5622 12.7178Z" fill="#333333"/>
                      <path d="M21.5494 20.7142C21.3502 20.7142 21.1589 20.6981 20.9835 20.6821L20.2422 20.634V15.934H20.8002C21.4618 15.934 23.0002 15.934 23.0002 17.2494V19.5673C23.0002 19.9763 22.8168 20.2249 22.6733 20.3613C22.3704 20.642 21.956 20.7062 21.5494 20.7062V20.7142ZM21.3581 19.5833C21.5813 19.5994 21.8364 19.5913 21.9241 19.5432L21.8922 17.2574C21.8284 17.1611 21.6052 17.113 21.3661 17.089V19.5913L21.3581 19.5833Z" fill="#333333"/>
                      <path d="M5.76664 20.7142C5.36012 20.7142 4.94563 20.65 4.64273 20.3693C4.49128 20.2329 4.31592 19.9763 4.31592 19.5753V17.2574C4.31592 15.942 5.85432 15.942 6.51592 15.942H7.07389V20.634L6.33258 20.6821C6.15722 20.6981 5.96592 20.7142 5.76664 20.7142ZM5.95795 17.0809C5.71882 17.097 5.49563 17.1371 5.43983 17.2092V19.5753C5.49563 19.6073 5.74273 19.5993 5.95795 19.5833V17.0809Z" fill="#333333"/>
                      <path d="M6.76285 5.87641C6.97806 6.09297 7.27299 6.21327 7.57589 6.21327C7.87879 6.21327 8.16575 6.09297 8.38096 5.87641C8.59618 5.65986 8.71575 5.37113 8.71575 5.06635C8.71575 4.76158 8.59618 4.47284 8.38096 4.25629C8.16575 4.03974 7.87879 3.91943 7.57589 3.91943C7.27299 3.91943 6.98603 4.03974 6.77082 4.25629C6.5556 4.47284 6.43604 4.76158 6.43604 5.06635C6.43604 5.21874 6.46792 5.37113 6.52372 5.50748C6.57951 5.64382 6.66719 5.77215 6.77082 5.88444L6.76285 5.87641Z" fill="#333333"/>
                      <path d="M2.52246 17.8589V11.4987L5.56739 8.43493L7.53623 10.416C7.82319 10.6967 8.2058 10.8571 8.61232 10.8571C9.01884 10.8571 9.40145 10.6967 9.68841 10.416L13.9449 6.13307L17.7551 9.96682V12.8542C17.7551 13.6081 19.2775 13.6482 19.2775 12.8782V2.5319C19.2775 2.12286 19.1181 1.73788 18.8312 1.44914C18.5442 1.16041 18.1616 1 17.7551 1H2.52246C2.11594 1 1.73333 1.16041 1.44638 1.44914C1.15942 1.73788 1 2.12286 1 2.5319V17.8589C1 18.268 1.15942 18.6529 1.44638 18.9417C1.73333 19.2304 2.11594 19.3908 2.52246 19.3908H2.92101C3.86159 19.3908 3.82971 17.8669 2.96884 17.8669C2.79348 17.8669 2.52246 17.8669 2.52246 17.8669V17.8589ZM2.52246 2.5319H17.7551V7.80131L15.021 5.05031C14.7341 4.7696 14.3514 4.60919 13.9449 4.60919C13.5384 4.60919 13.1558 4.7696 12.8688 5.05031L8.61232 9.33321L6.64348 7.35217C6.35652 7.07145 5.97391 6.91105 5.56739 6.91105C5.16087 6.91105 4.77826 7.07145 4.4913 7.35217L2.52246 9.33321V2.5319Z" fill="#333333"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_2803_100">
                      <rect width="22" height="22" fill="white" transform="translate(1 1)"/>
                      </clipPath>
                      </defs>
                    </svg>
                  </div>
                  피드
                </button>
                <button
                  data-instagram-tutorial="post-reels-tab"
                  className={`segment-btn ${this.state.selectedFeedType === "REELS" ? "active" : ""}`}
                  onClick={() => this.selectPostContentType("REELS")}
                >
                  <div style={{width: "24px", height: "24px", display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.6662 12.923L11.1662 9.92299C11.0533 9.84761 10.9219 9.80433 10.7863 9.79775C10.6506 9.79118 10.5157 9.82157 10.396 9.88567C10.2763 9.94977 10.1762 10.0452 10.1064 10.1617C10.0367 10.2783 9.99991 10.4115 10 10.5474V16.5474C9.99991 16.6832 10.0367 16.8165 10.1064 16.933C10.1762 17.0495 10.2763 17.145 10.396 17.2091C10.5157 17.2732 10.6506 17.3035 10.7863 17.297C10.9219 17.2904 11.0533 17.2471 11.1662 17.1717L15.6662 14.1717C15.7691 14.1033 15.8535 14.0105 15.9118 13.9015C15.9702 13.7926 16.0007 13.6709 16.0007 13.5474C16.0007 13.4238 15.9702 13.3021 15.9118 13.1932C15.8535 13.0843 15.7691 12.9915 15.6662 12.923ZM11.5 15.1458V11.9536L13.8981 13.5474L11.5 15.1458Z" fill="#333333"/>
                      <path d="M18.7632 3H17.5651H16.2499H15.151H13.9014H11.5287H10.4569H8.9657H7.81931H5.23677C4.64354 3 4.07461 3.23955 3.65514 3.66595C3.23566 4.09235 3 4.67067 3 5.27368V18.7263C3 19.3293 3.23566 19.9077 3.65514 20.3341C4.07461 20.7605 4.64354 21 5.23677 21H18.7632C19.3565 21 19.9254 20.7605 20.3449 20.3341C20.7643 19.9077 21 19.3293 21 18.7263V5.27368C21 4.67067 20.7643 4.09235 20.3449 3.66595C19.9254 3.23955 19.3565 3 18.7632 3ZM19.5088 18.7263C19.5088 18.9273 19.4303 19.1201 19.2904 19.2622C19.1506 19.4044 18.961 19.4842 18.7632 19.4842H5.23677C5.03903 19.4842 4.84939 19.4044 4.70956 19.2622C4.56974 19.1201 4.49118 18.9273 4.49118 18.7263V5.27368C4.49118 5.07268 4.56974 4.8799 4.70956 4.73777C4.84939 4.59564 5.03903 4.51579 5.23677 4.51579H8.21914C8.34192 4.51587 9.18311 4.51579 9.27556 4.51579C9.46196 4.51579 10.8075 4.51579 9.71032 4.51579H11.9471H14.246H16.0265H16.514H17.1662H18.7632C18.961 4.51579 19.1506 4.59564 19.2904 4.73777C19.4303 4.8799 19.5088 5.07268 19.5088 5.27368V18.7263Z" fill="#333333"/>
                      <path d="M4.5 7.5C4.5 7.5 13.9469 7.5 20 7.5" stroke="#333333" stroke-width="1.5"/>
                      <path d="M7 4L9 7.4641" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                      <path d="M11 4L13 7.4641" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                      <path d="M15 4L17 7.4641" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                  </div>
                  릴스
                </button>
              </div>
            </div>
            <div className="header-actions">
              
              <div className="segmented-control" data-instagram-tutorial="post-publish-option">
                <div className="has-tooltip" style={{flex: 1}}>
                    <button data-instagram-tutorial="post-now-option" className={`segment-btn ${publishOption === 'NOW' ? 'active' : ''}`} onClick={() => this.selectPublishOption('NOW')}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.2844 12.5344L9.34687 16.4719C9.20291 16.6095 9.01166 16.6867 8.8125 16.6875C8.66378 16.6873 8.51849 16.6428 8.3951 16.5598C8.27171 16.4768 8.17578 16.3589 8.11951 16.2213C8.06324 16.0836 8.04917 15.9323 8.07908 15.7867C8.10899 15.641 8.18154 15.5075 8.2875 15.4031L10.9406 12.75H2.25C2.05109 12.75 1.86032 12.671 1.71967 12.5303C1.57902 12.3897 1.5 12.1989 1.5 12C1.5 11.8011 1.57902 11.6103 1.71967 11.4697C1.86032 11.329 2.05109 11.25 2.25 11.25H10.9406L8.2875 8.59687C8.14577 8.45639 8.06566 8.26537 8.06478 8.06581C8.0639 7.86626 8.14233 7.67454 8.28281 7.53281C8.42329 7.39109 8.61432 7.31097 8.81387 7.31009C9.01342 7.30921 9.20515 7.38764 9.34687 7.52813L13.2844 11.4656C13.4252 11.6078 13.5042 11.7999 13.5042 12C13.5042 12.2001 13.4252 12.3922 13.2844 12.5344ZM18 3H12.75C12.5511 3 12.3603 3.07902 12.2197 3.21967C12.079 3.36032 12 3.55109 12 3.75C12 3.94891 12.079 4.13968 12.2197 4.28033C12.3603 4.42098 12.5511 4.5 12.75 4.5H18V19.5H12.75C12.5511 19.5 12.3603 19.579 12.2197 19.7197C12.079 19.8603 12 20.0511 12 20.25C12 20.4489 12.079 20.6397 12.2197 20.7803C12.3603 20.921 12.5511 21 12.75 21H18C18.3978 21 18.7794 20.842 19.0607 20.5607C19.342 20.2794 19.5 19.8978 19.5 19.5V4.5C19.5 4.10218 19.342 3.72064 19.0607 3.43934C18.7794 3.15804 18.3978 3 18 3Z" fill="#333333"/>
                      </svg>
                      즉시 발행
                    </button>
                    <div className="tooltip-down">즉시 인스타그램 업로드</div>
                </div>
                <div className="has-tooltip" style={{flex: 1}}>
                    <button data-instagram-tutorial="post-scheduled-option" className={`segment-btn ${publishOption === 'SCHEDULED' ? 'active' : ''}`} 
                      onClick={() => {
                         if (!accountConnected) {
                            this.needConnectAccount();
                            return;
                          }
                        this.selectPublishOption('SCHEDULED')
                      }
                    }>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.7">
                          <path d="M19.5 3H17.25V2.25C17.25 2.05109 17.171 1.86032 17.0303 1.71967C16.8897 1.57902 16.6989 1.5 16.5 1.5C16.3011 1.5 16.1103 1.57902 15.9697 1.71967C15.829 1.86032 15.75 2.05109 15.75 2.25V3H8.25V2.25C8.25 2.05109 8.17098 1.86032 8.03033 1.71967C7.88968 1.57902 7.69891 1.5 7.5 1.5C7.30109 1.5 7.11032 1.57902 6.96967 1.71967C6.82902 1.86032 6.75 2.05109 6.75 2.25V3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3ZM6.75 4.5V5.25C6.75 5.44891 6.82902 5.63968 6.96967 5.78033C7.11032 5.92098 7.30109 6 7.5 6C7.69891 6 7.88968 5.92098 8.03033 5.78033C8.17098 5.63968 8.25 5.44891 8.25 5.25V4.5H15.75V5.25C15.75 5.44891 15.829 5.63968 15.9697 5.78033C16.1103 5.92098 16.3011 6 16.5 6C16.6989 6 16.8897 5.92098 17.0303 5.78033C17.171 5.63968 17.25 5.44891 17.25 5.25V4.5H19.5V7.5H4.5V4.5H6.75ZM19.5 19.5H4.5V9H19.5V19.5Z" fill="#333333"/>
                          <rect x="7" y="11" width="2" height="2" rx="0.3" fill="#333333"/>
                          <rect x="7" y="15" width="2" height="2" rx="0.3" fill="#333333"/>
                          <rect x="11" y="11" width="2" height="2" rx="0.3" fill="#333333"/>
                          <rect x="11" y="15" width="2" height="2" rx="0.3" fill="#333333"/>
                          <rect x="15" y="11" width="2" height="2" rx="0.3" fill="#333333"/>
                          <rect x="15" y="15" width="2" height="2" rx="0.3" fill="#333333"/>
                        </g>
                      </svg>
                      예약 발행
                    </button>
                    <div className="tooltip-down">원하는 날짜와 시간 예약 업로드</div>
                </div>
              </div>
    
              {publishOption === 'SCHEDULED' && (
                <div data-instagram-tutorial="post-schedule-fields" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  {/* <DatePicker selected={this.getDateObjForDate()} onChange={this.onChangeDatePicker} dateFormat="yyyy-MM-dd" className="custom-date-picker" wrapperClassName="date-wrapper" style={{height:'42px', width:'130px', padding:'0 10px', border:'1px solid #ddd', borderRadius:'8px'}} />
                  <DatePicker selected={this.getDateObjForTime()} onChange={this.onChangeTimePicker} showTimeSelect showTimeSelectOnly dateFormat="HH:mm" className="custom-time-picker" wrapperClassName="time-wrapper" style={{height:'42px', width:'110px', padding:'0 10px', border:'1px solid #ddd', borderRadius:'8px'}} /> */}
                  <DatePicker 
                      selected={this.getDateObjForDate()} 
                      onChange={this.onChangeDatePicker} 
                      dateFormat="yyyy-MM-dd" 
                      className="custom-date-picker" 
                      wrapperClassName="date-wrapper" 
                      placeholderText="날짜 선택"
                  />
                  <DatePicker 
                      selected={this.getDateObjForTime()} 
                      onChange={this.onChangeTimePicker} 
                      showTimeSelect 
                      showTimeSelectOnly 
                      timeFormat="HH:mm" 
                      timeIntervals={30} 
                      timeCaption="시간" 
                      dateFormat="HH:mm" 
                      className="custom-time-picker" 
                      wrapperClassName="time-wrapper" 
                      placeholderText="시간 선택"
                      autoComplete="off"
                      inputMode="none"
                      onKeyDown={this.preventDatePickerTyping}
                      onPaste={this.preventDatePickerTyping}
                      onDrop={this.preventDatePickerTyping}
                      onChangeRaw={this.preventDatePickerTyping}
                  />
                </div>
              )}
    
              <div data-instagram-tutorial="post-save-actions" style={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <div className="has-tooltip" style={{flex: 1}}>
                      <button className="btn btn-outline" style={{width: '100%'}} onClick={this.draftPost}>임시 저장</button>
                      <div className="tooltip-down">작성 내용 임시 보관</div>
                  </div>
                  <div className="has-tooltip" style={{flex: 1}}>
                      <button className="btn btn-primary" style={{width: '100%'}} onClick={this.publishPost}>
                      {publishOption === 'NOW' ? '게시하기' : '예약 등록'}
                      </button>
                      <div className="tooltip-down">선택한 채널에 콘텐츠 최종 발행</div>
                  </div>
              </div>
            </div>
          </header>

          {/* --- [v4] 발행 채널 / 플랫폼별 계정 선택 --- */}
          <div className="publish-channel-bar" data-instagram-tutorial="post-publish-channel">
            <div className="publish-channel-title">발행 채널</div>

            <div className="publish-platform-buttons">
              <button
                type="button"
                className={`publish-platform-button ${instagramPublishEnabled ? "active" : ""}`}
                onClick={() => this.togglePublishPlatform("instagram")}
                aria-pressed={instagramPublishEnabled}
                title="Instagram 발행"
              >
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="17.4" cy="6.8" r="1.1" fill="currentColor"/>
                </svg>
                Instagram
              </button>

              <button
                type="button"
                className={`publish-platform-button ${threadsPublishEnabled ? "active" : ""}`}
                onClick={() => this.togglePublishPlatform("threads")}
                aria-pressed={threadsPublishEnabled}
                title="Threads 발행"
              >
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M17.8 10.1c-.3-4-2.6-6.2-6-6.2-3.9 0-6.4 3-6.4 7.8 0 5.2 2.5 8.2 6.7 8.2 3.6 0 6.1-2 6.1-4.8 0-2.3-1.7-3.8-4.4-3.8-3 0-4.8 1.3-4.8 3.4 0 1.6 1.2 2.7 3 2.7 2.8 0 4.9-2.4 4.9-5.9 0-3-1.5-4.8-4.3-4.8-2 0-3.5.9-4.4 2.4" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Threads
              </button>
            </div>

            <div className="publish-channel-accounts">
              {instagramPublishEnabled && (
                <div className="publish-account-group">
                  <span className="publish-account-label">Instagram 계정</span>
                  <div className="publish-account-select" id="ig_account_select_wrapper" data-instagram-tutorial="post-account">
                    <div
                      onClickCapture={(e) => {
                        if (!accountConnected) {
                          e.preventDefault();
                          e.stopPropagation();
                          this.needConnectAccount();
                        }
                      }}
                    >
                      <SelectBoxV2
                        id="ig_account_select"
                        width="100%"
                        height="40px"
                        list={displayAccountList || []}
                        optionTexttName="title"
                        optionValuetName="value"
                        selectedValue={selected_ig_access_seq || default_ig_access_seq || ""}
                        selectedText={selectedAccountText}
                        onClickOption={this.onChangeAccount}
                      />
                    </div>
                  </div>
                </div>
              )}

              {threadsPublishEnabled && (
                <div className="publish-account-group">
                  <span className="publish-account-label">Threads 계정</span>
                  <div className="publish-account-select">
                    <div
                      onClickCapture={(e) => {
                        if (!threadsAccountConnected) {
                          e.preventDefault();
                          e.stopPropagation();
                          this.handleThreadsConnect();
                        }
                      }}
                    >
                      <SelectBoxV2
                        id="threads_account_select"
                        width="100%"
                        height="40px"
                        list={displayThreadsAccountList || []}
                        optionTexttName="title"
                        optionValuetName="value"
                        selectedValue={selected_threads_access_seq || ""}
                        selectedText={selectedThreadsAccountText}
                        onClickOption={this.onChangeThreadsAccount}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
    
          {/* --- [MAIN] --- */}
          <div className="main-container">
            {/* <nav className="side-nav-area">
              <div className={`nav-item ${activeSection === 'sec-image' ? 'active' : ''}`} onClick={() => this.scrollToSec('sec-image')}>
                <div className="nav-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 15V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V15ZM19.5 4.5V13.1906L16.8094 10.5C16.527 10.2217 16.1464 10.0658 15.75 10.0658C15.3536 10.0658 14.973 10.2217 14.6906 10.5L10.5 14.6906L8.55938 12.75C8.27698 12.4717 7.89645 12.3158 7.5 12.3158C7.10355 12.3158 6.72302 12.4717 6.44062 12.75L4.5 14.6906V4.5H19.5ZM19.5 19.5H4.5V16.8094L7.5 13.8094L9.44062 15.75C9.72302 16.0283 10.1036 16.1842 10.5 16.1842C10.8964 16.1842 11.277 16.0283 11.5594 15.75L15.75 11.5594L19.5 15.3094V19.5ZM8.57812 9.42188C8.47332 9.31744 8.39034 9.19321 8.33401 9.0564C8.27768 8.91959 8.24912 8.77295 8.25 8.625C8.25 8.32663 8.36853 8.04048 8.5795 7.8295C8.79048 7.61853 9.07663 7.5 9.375 7.5C9.67337 7.5 9.95952 7.61853 10.1705 7.8295C10.3815 8.04048 10.5 8.32663 10.5 8.625C10.5 8.92337 10.3815 9.20952 10.1705 9.4205C9.95952 9.63147 9.67337 9.75 9.375 9.75C9.07695 9.74772 8.79136 9.63013 8.57812 9.42188Z" fill="#333333"/>
                </svg>
                </div><div className="nav-label">{this.state.selectedFeedType === "REELS" ? "동영상" : "이미지"}</div>
                <div className="nav-tooltip">{this.state.selectedFeedType === "REELS" ? "동영상 등록" : "이미지 및 디자인 제작"}</div>
              </div>
              <div className={`nav-item ${activeSection === 'sec-caption' ? 'active' : ''}`} onClick={() => this.scrollToSec('sec-caption')}>
                <div className="nav-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 15V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V15ZM19.5 4.5V13.1906L16.8094 10.5C16.527 10.2217 16.1464 10.0658 15.75 10.0658C15.3536 10.0658 14.973 10.2217 14.6906 10.5L10.5 14.6906L8.55938 12.75C8.27698 12.4717 7.89645 12.3158 7.5 12.3158C7.10355 12.3158 6.72302 12.4717 6.44062 12.75L4.5 14.6906V4.5H19.5ZM19.5 19.5H4.5V16.8094L7.5 13.8094L9.44062 15.75C9.72302 16.0283 10.1036 16.1842 10.5 16.1842C10.8964 16.1842 11.277 16.0283 11.5594 15.75L15.75 11.5594L19.5 15.3094V19.5ZM8.57812 9.42188C8.47332 9.31744 8.39034 9.19321 8.33401 9.0564C8.27768 8.91959 8.24912 8.77295 8.25 8.625C8.25 8.32663 8.36853 8.04048 8.5795 7.8295C8.79048 7.61853 9.07663 7.5 9.375 7.5C9.67337 7.5 9.95952 7.61853 10.1705 7.8295C10.3815 8.04048 10.5 8.32663 10.5 8.625C10.5 8.92337 10.3815 9.20952 10.1705 9.4205C9.95952 9.63147 9.67337 9.75 9.375 9.75C9.07695 9.74772 8.79136 9.63013 8.57812 9.42188Z" fill="#333333"/>
                  </svg>
                </div><div className="nav-label">문구작성</div>
                <div className="nav-tooltip">문구 에디터 및 AI 도구</div>
              </div>
              <div className={`nav-item ${activeSection === 'sec-hashtag' ? 'active' : ''}`} onClick={() => this.scrollToSec('sec-hashtag')}>
                <div className="nav-icon">
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 7H14" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M4 11H14" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M6.31836 14L7.22372 4.04107" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M10.8633 14L11.7686 4.04107" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                </div>
                <div className="nav-label">해시태그</div>
                <div className="nav-tooltip">해시태그 추천 및 관리</div>
              </div>
            </nav> */}
    
            <main className="input-scroll-area" ref={this.scrollAreaRef}>
              <div className="editor-form-stack">

                {/* --- [NEW] 계정 연동 안내 배너 --- */}
                {!this.state.accountConnected && !this.state.hideAccountBanner && (
                    <div className="info-banner" id="accountLinkBanner" style={{display: "none"}}>
                        <div className="info-banner-text">
                            <span style={{ fontSize: '18px' }}>💡</span>
                            아직 인스타그램 계정이 연동되지 않았습니다. 계정을 연동하고 자동 발행을 경험해 보세요!
                        </div>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <button className="btn btn-outline" style={{ height: '34px', padding: '0 12px', fontSize: '12px' }} onClick={() => this.setState({ hideAccountBanner: true })}>
                                기능 둘러보기
                            </button>
                            {/* 기존에 구현된 handleConnectAccount 함수를 연결합니다 */}
                            <button className="btn btn-purple" style={{ height: '34px', padding: '0 12px', fontSize: '12px' }} onClick={this.handleConnectAccount}>
                                계정 연동하기
                            </button>
                        </div>
                    </div>
                )}
                
                {/* SECTION 1: 미디어 / 릴스 음악 */}
                <div className={`reels-section-row ${this.state.selectedFeedType === "REELS" ? "is-reels" : ""}`}>
                <section className="card scroll-section" id="sec-image" data-instagram-tutorial="post-media-section" ref={el => { if(el) this.observer?.observe(el) }}>
                  <div className="section-header">
                      <div className="section-title">
                        {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M21 15V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V15ZM19.5 4.5V13.1906L16.8094 10.5C16.527 10.2217 16.1464 10.0658 15.75 10.0658C15.3536 10.0658 14.973 10.2217 14.6906 10.5L10.5 14.6906L8.55938 12.75C8.27698 12.4717 7.89645 12.3158 7.5 12.3158C7.10355 12.3158 6.72302 12.4717 6.44062 12.75L4.5 14.6906V4.5H19.5ZM19.5 19.5H4.5V16.8094L7.5 13.8094L9.44062 15.75C9.72302 16.0283 10.1036 16.1842 10.5 16.1842C10.8964 16.1842 11.277 16.0283 11.5594 15.75L15.75 11.5594L19.5 15.3094V19.5ZM8.57812 9.42188C8.47332 9.31744 8.39034 9.19321 8.33401 9.0564C8.27768 8.91959 8.24912 8.77295 8.25 8.625C8.25 8.32663 8.36853 8.04048 8.5795 7.8295C8.79048 7.61853 9.07663 7.5 9.375 7.5C9.67337 7.5 9.95952 7.61853 10.1705 7.8295C10.3815 8.04048 10.5 8.32663 10.5 8.625C10.5 8.92337 10.3815 9.20952 10.1705 9.4205C9.95952 9.63147 9.67337 9.75 9.375 9.75C9.07695 9.74772 8.79136 9.63013 8.57812 9.42188Z" fill="#333333"/>
                        </svg> */}
                        {this.state.selectedFeedType === "REELS" ? "동영상 등록" : "이미지 및 디자인 제작"}
                      </div>
                      {/* <div style={{display:'flex', gap: '10px'}}>
                        <div style={{ display: 'flex', gap: '5px' }}>
                            <button className={`btn btn-outline ${this.state.selectedFeedType === 'SINGLE' ? 'active' : ''}`} onClick={() => this.selectFeedType('SINGLE')} style={{height:'34px', padding: '0 12px', fontSize:'12px'}}>단일</button>
                            <button className={`btn btn-outline ${this.state.selectedFeedType === 'CAROUSEL' ? 'active' : ''}`} onClick={() => this.selectFeedType('CAROUSEL')} style={{height:'34px', padding: '0 12px', fontSize:'12px'}}>슬라이드</button>
                        </div>
                        {this.state.selectedFeedType === "CAROUSEL" && (
                          <button className="btn btn btn-outline" onClick={this.addNewImageSlot} style={{ height: '34px' }}>+ 슬롯 추가</button>
                        )}
                      </div> */}
                  </div>
                  {this.renderImageSlots()}
                </section>

                {this.state.selectedFeedType === "REELS" && this.state.instagramPublishEnabled && (
                  /* SECTION 1-1: 릴스 음악 - Instagram 전용 */
                  <section className="card" id="sec-reels-audio">
                    {this.renderReelsAudioControls()}
                  </section>
                )}
                </div>
      
                {/* SECTION 2: 문구 작성 */}
                <section className="card scroll-section" id="sec-caption" data-instagram-tutorial="post-caption-section" ref={el => { if(el) this.observer?.observe(el) }}>
                  <div id="captionSettings" className="section-header">
                    <div className="section-title">
                      {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.5306 5.46996L18.5306 2.46996C18.461 2.40023 18.3783 2.34491 18.2872 2.30717C18.1962 2.26943 18.0986 2.25 18 2.25C17.9014 2.25 17.8038 2.26943 17.7128 2.30717C17.6217 2.34491 17.539 2.40023 17.4694 2.46996L8.46937 11.47C8.39975 11.5397 8.34454 11.6224 8.3069 11.7135C8.26926 11.8045 8.24992 11.9021 8.25 12.0006V15.0006C8.25 15.1995 8.32902 15.3903 8.46967 15.5309C8.61032 15.6716 8.80109 15.7506 9 15.7506H12C12.0985 15.7507 12.1961 15.7313 12.2871 15.6937C12.3782 15.6561 12.4609 15.6008 12.5306 15.5312L21.5306 6.53122C21.6004 6.46156 21.6557 6.37884 21.6934 6.2878C21.7312 6.19675 21.7506 6.09915 21.7506 6.00059C21.7506 5.90203 21.7312 5.80443 21.6934 5.71338C21.6557 5.62234 21.6004 5.53962 21.5306 5.46996ZM11.6897 14.2506H9.75V12.3109L15.75 6.3109L17.6897 8.25059L11.6897 14.2506ZM18.75 7.19028L16.8103 5.25059L18 4.0609L19.9397 6.00059L18.75 7.19028ZM21 11.2506V19.5006C21 19.8984 20.842 20.2799 20.5607 20.5612C20.2794 20.8426 19.8978 21.0006 19.5 21.0006H4.5C4.10218 21.0006 3.72064 20.8426 3.43934 20.5612C3.15804 20.2799 3 19.8984 3 19.5006V4.50059C3 4.10277 3.15804 3.72123 3.43934 3.43993C3.72064 3.15863 4.10218 3.00059 4.5 3.00059H12.75C12.9489 3.00059 13.1397 3.07961 13.2803 3.22026C13.421 3.36091 13.5 3.55168 13.5 3.75059C13.5 3.9495 13.421 4.14027 13.2803 4.28092C13.1397 4.42157 12.9489 4.50059 12.75 4.50059H4.5V19.5006H19.5V11.2506C19.5 11.0517 19.579 10.8609 19.7197 10.7203C19.8603 10.5796 20.0511 10.5006 20.25 10.5006C20.4489 10.5006 20.6397 10.5796 20.7803 10.7203C20.921 10.8609 21 11.0517 21 11.2506Z" fill="#333333"/>
                      </svg> */}
                      내용 작성
                      {/* <button className="icon-btn-purple" onClick={(e) => { e.stopPropagation(); this.toggleModal('captionSettings', true); }} title="설정 변경 안내">
                        <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.5" d="M19.7724 7.39596C19.7502 7.29675 19.7069 7.20343 19.6453 7.12231C19.5837 7.04119 19.5053 6.97417 19.4154 6.92577L17.2914 5.75473C17.1775 5.52521 17.0493 5.30299 16.9076 5.08936L16.9522 2.6763C16.9531 2.57508 16.9329 2.47479 16.8929 2.38168C16.853 2.28857 16.7942 2.20464 16.7202 2.13513C15.6626 1.18194 14.4119 0.465009 13.0522 0.0325761C12.9546 0.00231062 12.8516 -0.00701284 12.75 0.00522155C12.6485 0.017456 12.5507 0.0509698 12.4632 0.103549L10.3838 1.34557C10.1249 1.33669 9.87506 1.33669 9.61624 1.34557L7.53682 0.103549C7.44928 0.0509698 7.35151 0.017456 7.24997 0.00522155C7.14843 -0.00701284 7.04544 0.00231062 6.9478 0.0325761C5.58632 0.465338 4.33507 1.1856 3.2798 2.144C3.20514 2.21112 3.1458 2.29335 3.10578 2.38517C3.06575 2.47698 3.04597 2.57625 3.04776 2.6763L3.09238 5.08936C2.94959 5.30228 2.82465 5.52407 2.6997 5.75473L0.575656 6.92577C0.487054 6.97467 0.410099 7.04199 0.350035 7.12313C0.289971 7.20427 0.24821 7.29733 0.227598 7.39596C-0.075866 8.78144 -0.075866 10.2156 0.227598 11.6011C0.249766 11.7003 0.29311 11.7936 0.354698 11.8747C0.416286 11.9558 0.494681 12.0229 0.584581 12.0713L2.70863 13.2423C2.82249 13.4718 2.95066 13.694 3.09238 13.9077L3.04776 16.3207C3.04695 16.422 3.06713 16.5222 3.10705 16.6154C3.14698 16.7085 3.20578 16.7924 3.2798 16.8619C4.3374 17.8151 5.58812 18.532 6.9478 18.9645C7.04544 18.9947 7.14843 19.0041 7.24997 18.9918C7.35151 18.9796 7.44928 18.9461 7.53682 18.8935L9.61624 17.6515H10.3838L12.4721 18.8935C12.5807 18.9645 12.7081 19.0015 12.838 19C12.9106 18.9968 12.9825 18.9849 13.0522 18.9645C14.4137 18.5317 15.6649 17.8114 16.7202 16.853C16.7949 16.7859 16.8542 16.7037 16.8942 16.6119C16.9342 16.5201 16.954 16.4208 16.9522 16.3207L16.9076 13.9077C17.0504 13.6948 17.1754 13.473 17.3003 13.2423L19.4243 12.0713C19.5129 12.0224 19.5899 11.9551 19.65 11.8739C19.71 11.7928 19.7518 11.6997 19.7724 11.6011C20.0759 10.2156 20.0759 8.78144 19.7724 7.39596ZM18.4337 10.9889L16.4078 12.1068C16.2793 12.181 16.1766 12.2924 16.1133 12.4261C15.9665 12.7285 15.7964 13.0192 15.6046 13.2955C15.5232 13.4195 15.4797 13.5644 15.4797 13.7125L15.5154 16.0102C14.747 16.6606 13.8674 17.1684 12.9183 17.5095L10.9282 16.3207C10.8171 16.2565 10.6908 16.2228 10.5622 16.2232H10.5087C10.1701 16.2498 9.82991 16.2498 9.4913 16.2232C9.34498 16.2152 9.19942 16.2491 9.07185 16.3207L7.08167 17.5095C6.13377 17.1701 5.25434 16.6654 4.48462 16.0191L4.52032 13.7125C4.52026 13.5644 4.47685 13.4195 4.39537 13.2955C4.20684 13.0171 4.03691 12.7267 3.88667 12.4261C3.82078 12.2942 3.71868 12.1835 3.59216 12.1068L1.56628 10.9889C1.38773 10.0033 1.38773 8.99379 1.56628 8.0081L3.59216 6.89028C3.72068 6.81603 3.82341 6.70463 3.88667 6.57091C4.0335 6.26853 4.20357 5.97787 4.39537 5.7015C4.47685 5.57751 4.52026 5.43263 4.52032 5.28453L4.48462 2.9868C5.25298 2.33645 6.13264 1.82862 7.08167 1.48751L9.07185 2.6763C9.19905 2.74892 9.34489 2.78285 9.4913 2.77389C9.82991 2.74727 10.1701 2.74727 10.5087 2.77389C10.655 2.78183 10.8006 2.74797 10.9282 2.6763L12.9183 1.48751C13.8662 1.82698 14.7457 2.33168 15.5154 2.97793L15.4797 5.28453C15.4797 5.43263 15.5232 5.57751 15.6046 5.7015C15.7932 5.97992 15.9631 6.27035 16.1133 6.57091C16.1792 6.70286 16.2813 6.81358 16.4078 6.89028L18.4337 8.0081C18.6123 8.99379 18.6123 10.0033 18.4337 10.9889ZM10 4.53045C9.01154 4.53045 8.04527 4.82182 7.22339 5.36772C6.40152 5.91362 5.76094 6.68953 5.38267 7.59732C5.00441 8.50512 4.90543 9.50403 5.09827 10.4677C5.29111 11.4315 5.7671 12.3167 6.46605 13.0115C7.165 13.7063 8.05552 14.1794 9.02499 14.3711C9.99446 14.5628 10.9993 14.4644 11.9126 14.0884C12.8258 13.7124 13.6063 13.0756 14.1555 12.2586C14.7046 11.4416 14.9978 10.4811 14.9978 9.49852C14.9978 8.18091 14.4712 6.91726 13.5339 5.98557C12.5967 5.05387 11.3255 4.53045 10 4.53045ZM10 13.0471C9.29395 13.0471 8.60377 12.839 8.01671 12.4491C7.42966 12.0592 6.9721 11.5049 6.70191 10.8565C6.43172 10.2081 6.36102 9.49458 6.49877 8.80622C6.63651 8.11785 6.9765 7.48555 7.47575 6.98927C7.975 6.49298 8.61108 6.15501 9.30356 6.01809C9.99604 5.88116 10.7138 5.95144 11.3661 6.22002C12.0184 6.48861 12.5759 6.94345 12.9682 7.52701C13.3605 8.11058 13.5698 8.79667 13.5698 9.49852C13.5698 10.4397 13.1937 11.3423 12.5243 12.0078C11.8548 12.6733 10.9468 13.0471 10 13.0471Z" fill="#6D28D9"/>
                        </svg>
                      </button> */}
                    </div>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-instagram-tutorial="post-copywriter-button"
                      onClick={this.openAiCopywriterRunModal}
                    >
                      AI문구만들기
                    </button>
                  </div>
      
                  {/* Toolbar & Textarea */}
                  <div>
                      <div className="toolbar" data-instagram-tutorial="post-caption-toolbar">
                          <button className="tool-btn" onClick={this.undoCaption}>↩</button>
                          <button className="tool-btn" onClick={this.redoCaption}>↪</button>
                          <button ref={this.triggerRef} className="tool-btn" onClick={this.showEmojiPicker}>🙂 이모지</button>
                      </div>
                      
                      {this.state.emojiPickerVisible && (
                        <div ref={this.pickerRef} style={{ position: 'absolute', zIndex: 999, transform: 'translateY(5px)' }}>
                          <Picker data={data} onEmojiSelect={emoji => this.handleEmojiSelect(emoji)} />
                        </div>
                      )}

                      <textarea
                          ref={this.captionTextareaRef}
                          data-instagram-tutorial="post-caption-input"
                          className="form-control"
                          style={{ borderRadius: "0 0 8px 8px", minHeight: "150px" }}
                          placeholder="내용을 입력하시거나 AI문구 만들기 버튼을 클릭해서 AI로 내용을 만들어주세요"
                          value={caption}
                          maxLength={maxCaptionLength}
                          onChange={this.onChangeCaption}
                      />
                      {/* 글자 수가 꽉 찼을 때 빨간색으로 경고 */}
                      <div style={{ 
                          textAlign: "right", 
                          fontSize: "12px", 
                          color: caption.length > maxCaptionLength ? "#dc2626" : "#8e8e8e", /* 2200자 도달 시 빨간색(#dc2626)으로 변경 */
                          marginTop: "5px" 
                      }}>
                          {caption.length.toLocaleString()}/{maxCaptionLength.toLocaleString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                      </div>
                  </div>

                  {/* Quick Phrase Chips */}
                  <div style={{ 
                    // marginBottom: '12px' 
                  }}>
                      <div className="chip-container" data-instagram-tutorial="post-caption-favorites">
                          <div className="has-tooltip">
                              <div className="phrase-chip chip-new" onClick={() => this.toggleModal('phrase', true)}>+ 즐겨찾는 문구 추가</div>
                              <div className="tooltip-down">자주 쓰는 문구 저장</div>
                          </div>
                          
                          {quickPhrases.map((phrase, idx) => (
                              <div key={idx} className="phrase-chip" onClick={() => this.appendPhraseText(phrase.content)}>
                                  {phrase.title} <span className="chip-delete" onClick={(e) => { e.stopPropagation(); this.removePhrase(idx); }}>×</span>
                              </div>
                          ))}
                      </div>
                  </div>
                </section>
      
                {/* SECTION 3: 해시태그 작성 */}
                <section
                  className="card scroll-section"
                  id="sec-hashtag"
                  data-instagram-tutorial="post-hashtag-section"
                  ref={el => { if (el) this.observer?.observe(el); }}
                  style={{ padding: "24px" }}
                >
                  <div className="section-header section-hashtag-header">
                    <div className="section-title">해시태그 작성</div>
                    <button
                      id="hashtag-ai-button"
                      data-instagram-tutorial="post-hashtag-ai"
                      type="button"
                      className="btn btn-mint"
                      onClick={this.generateAIHashtags}
                    >
                      AI 자동 추천
                    </button>
                  </div>

                  <div data-instagram-tutorial="post-hashtag-editor">
                    <InstagramHashtagEditor
                      tags={this.state.tags}
                      inputValue={this.state.inputHashtagValue}
                      onInputChange={(value) => this.setState({ inputHashtagValue: value })}
                      onAddInput={this.addTag}
                      onRemoveTag={this.removeTagAt}
                      onReorderTags={(nextTags) => this.setState({ tags: nextTags })}
                      favoriteTags={fixedTags}
                      onAddFavoriteTag={(tagName) => this.addTag(tagName)}
                      onDeleteFavoriteTag={this.removePhraseHashtag}
                      onOpenFavoriteTagModal={() => this.toggleModal('addTag', true)}
                    />
                  </div>
                </section>
              </div>
    
            </main>
    
            {/* --- [ASIDE] 우측 미리보기 영역 --- */}
            <aside className="preview-fixed-area" data-instagram-tutorial="post-preview">
              <div style={{ fontWeight: '800', color: 'var(--deep-navy)', marginTop: '16px', marginBottom: '23px', fontSize: '15px' }}>인스타그램 미리보기</div>
              
              <div className="insta-frame">
                <div style={{ padding: '14px', display: 'flex', alignItems: 'center', borderBottom: '1px solid #efefef' }}>
                  <div style={{ width: '32px', height: '32px', borderRadius: '50%', marginRight: '12px', background: 'var(--primary-mint)', overflow: 'hidden' }}>
                    {
                      previewAccount.profile_picture_url
                        ? <img src={previewAccount.profile_picture_url} alt="Profile" style={{ width: "100%", height: "100%" }} onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                        : null
                    }
                  </div>
                  {/* 연동 여부 및 계정 선택 상태에 맞는 이름 표시 */}
                  <div style={{ fontWeight: '600', fontSize: '13px' }}>{previewAccount.title}</div>
                </div>
                
                <div style={{ position: "relative", width: '100%', aspectRatio: previewAspectRatio, backgroundColor: currentIsVideo ? '#111827' : '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                  {currentImg ? (
                    currentIsVideo ? (
                      currentVideoUrl ? (
                        <video
                          ref={this.reelsPreviewVideoRef}
                          src={currentVideoUrl}
                          poster={currentPosterUrl || undefined}
                          controls
                          muted={
                            (((this.state.reelsAudio || {}).mode === "MUSIC"
                              || (this.state.reelsAudio || {}).mode === "ORIGINAL_SOUND")
                              && (this.state.reelsAudio || {}).audioId)
                            && clampInstagramAudioVolume((this.state.reelsAudio || {}).videoVolume, 100) === 0
                          }
                          playsInline
                          style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#111827' }}
                          onLoadedMetadata={(e) => {
                            this.handleVideoLoadedMetadata(currentSlotIndex, e);
                            this.syncReelsPreviewVolumes();
                          }}
                          onPlay={this.handleReelsPreviewPlay}
                          onPause={this.handleReelsPreviewPause}
                          onSeeked={this.handleReelsPreviewSeeked}
                          onTimeUpdate={this.handleReelsPreviewTimeUpdate}
                          onEnded={this.handleReelsPreviewEnded}
                        />
                      ) : (
                        <img src={currentPosterUrl || currentImg} style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#111827' }} alt="동영상 썸네일" />
                      )
                    ) : (
                      <img src={currentImg} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="미리보기" />
                    )
                  ) : (
                    <div style={{ color: '#9ca3af', fontSize: '13px' }}>{this.state.selectedFeedType === "REELS" ? "동영상 없음" : "이미지 없음"}</div>
                  )}



                  {this.state.selectedFeedType === "REELS" && currentIsVideo && (
                    <>
                      <audio
                        ref={this.reelsPreviewAudioRef}
                        src={(this.state.reelsAudio || {}).previewUrl || undefined}
                        preload="metadata"
                        loop
                      />

                      {(((this.state.reelsAudio || {}).mode === "MUSIC"
                        || (this.state.reelsAudio || {}).mode === "ORIGINAL_SOUND")
                        && (this.state.reelsAudio || {}).audioId) ? (
                        <div
                          style={{
                            position: "absolute",
                            left: 10,
                            right: 10,
                            bottom: 52,
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "8px 10px",
                            borderRadius: "8px",
                            background: "rgba(0,0,0,.62)",
                            color: "#fff",
                            pointerEvents: "none",
                          }}
                        >
                          <span style={{ fontSize: "16px" }}>♫</span>
                          <div style={{ minWidth: 0, flex: 1 }}>
                            <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: "11px", fontWeight: 800 }}>
                              {(this.state.reelsAudio || {}).title || "선택한 음악"}
                            </div>
                            <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: "9px", opacity: .78 }}>
                              {(this.state.reelsAudio || {}).artist || ""}
                            </div>
                          </div>
                          {!(this.state.reelsAudio || {}).previewUrl ? ( 
                            <span style={{ fontSize: "9px", fontWeight: 700, padding: "3px 5px", borderRadius: "4px", background: "rgba(255,255,255,.16)" }}>
                              미리듣기 불가
                            </span> 
                          ) : null}
                          {clampInstagramAudioVolume((this.state.reelsAudio || {}).videoVolume, 100) === 0 ? (
                            <span style={{ fontSize: "9px", fontWeight: 700, padding: "3px 5px", borderRadius: "4px", background: "rgba(255,255,255,.16)" }}>
                              원본 소리 꺼짐
                            </span>
                          ) : null}
                        </div>
                      ) : null}
                    </>
                  )}
                  {hasSlides && (
                    <div style={{ position: "absolute", bottom: 10, left: "50%", transform: "translateX(-50%)", display: "flex", gap: "6px" }}>
                      {imgs.map((_, i) => (
                        <div key={i} onClick={() => this.setSlide(i)} style={{ width: 6, height: 6, borderRadius: "50%", background: i === currentIdx ? "#fff" : "rgba(255,255,255,0.5)", cursor: "pointer" }} />
                      ))}
                    </div>
                  )}
                  {hasSlides && (
                      <>
                          <button onClick={this.previousSlide} style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", background: "rgba(0,0,0,0.5)", color: "white", border: "none", borderRadius: "50%", width: 32, height: 32, cursor: "pointer" }}>‹</button>
                          <button onClick={this.nextSlide} style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "rgba(0,0,0,0.5)", color: "white", border: "none", borderRadius: "50%", width: 32, height: 32, cursor: "pointer" }}>›</button>
                      </>
                  )}
                </div>
                
                <div style={{ padding: '16px', fontSize: '14px', color: '#262626', lineHeight: '1.5', maxHeight: '350px', overflowY: 'auto' }}>
                  <div style={{ marginBottom: '8px' }}>
                    {/* 본문 앞에도 미리보기 계정 상태를 동일하게 표시 */}
                    <span style={{ fontWeight: '600', marginRight: '6px' }}>{previewAccount.title}</span>
                    <span style={{ whiteSpace: 'pre-line' }}>{caption || '미리보기 문구가 여기에 표시됩니다.'}</span>
                  </div>
                  <div style={{ color: '#00376b', wordBreak: 'break-all', marginTop: '10px', whiteSpace: 'pre-wrap' }}>
                    {tags.length > 0 ? tags.join(' ') : ''}
                  </div>
                </div>
              </div>
            </aside>
    
          </div>
    
          <InstagramAudioSelectModal
            isOpen={!!this.state.reelsAudioModalOpen && !!this.state.instagramPublishEnabled}
            instagramAccessTokenSeq={this.getPublishAccountSeq()}
            selectedAudio={(this.state.reelsAudio && this.state.reelsAudio.audioId) ? {
              id: this.state.reelsAudio.audioId,
              audioType: this.state.reelsAudio.audioType,
              title: this.state.reelsAudio.title,
              artist: this.state.reelsAudio.artist,
              durationMs: this.state.reelsAudio.durationMs,
              previewUrl: this.state.reelsAudio.previewUrl,
              raw: this.state.reelsAudio.meta,
            } : null}
            onApply={this.handleApplyInstagramAudio}
            onClose={() => this.setState({ reelsAudioModalOpen: false })}
          />

          {/* --- [NEW MODALS] HTML에서 추가된 모달들 --- */}
          {/* {modals.styleConfig && (
              <div className="modal-overlay open" onClick={(e) => { if(e.target.className.includes('modal-overlay')) this.toggleModal('styleConfig', false); }}>
                  <div className="modal-box">
                      <div className="modal-title">🤖 카피라이터 설정</div>
                      <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '20px' }}>우리 브랜드에 맞는 톤앤매너와 타겟을 설정하세요.</p>
                      <div style={{ background: '#f8fafc', border: '1px dashed #cbd5e1', padding: '40px', textAlign: 'center', borderRadius: '8px', color: '#94a3b8' }}>
                          (상세 프롬프트 설정 UI 영역)
                      </div>
                      <div style={{ textAlign: 'right', marginTop: '24px' }}>
                          <button className="btn btn-outline" onClick={() => this.toggleModal('styleConfig', false)}>취소</button>
                          <button className="btn btn-primary" onClick={() => this.toggleModal('styleConfig', false)}>저장하기</button>
                      </div>
                  </div>
              </div>
          )} */}

          {modals.phrase && (
              <div className="modal-overlay open" onClick={(e) => { if(e.target.className.includes('modal-overlay')) this.toggleModal('phrase', false); }}>
                  <div className="modal-box">
                      <div className="modal-title">즐겨찾는 문구 추가</div>
                      <input type="text" className="form-control" placeholder="버튼 이름 (예: 문의안내)" style={{ marginBottom: '12px' }} value={this.state.phraseTitleInput} onChange={(e) => this.setState({ phraseTitleInput: e.target.value })} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); document.getElementById('phraseContentInputModal').focus(); } }} />
                      <textarea id="phraseContentInputModal" className="form-control" rows="3" placeholder="삽입될 문구 내용 (Shift+Enter로 줄바꿈, Enter로 저장)" value={this.state.phraseContentInput} onChange={(e) => this.setState({ phraseContentInput: e.target.value })} onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); this.addNewPhrase(); } }} />
                      <div className="flexBox" style={{ justifyContent: 'flex-end', textAlign: 'right', marginTop: '20px', gap: '12px' }}>
                          <button className="btn btn-outline" onClick={() => this.toggleModal('phrase', false)}>취소</button>
                          <button className="btn btn-primary" onClick={this.addNewPhrase}>추가</button>
                      </div>
                  </div>
              </div>
          )}

          {modals.addTag && (
              <div className="modal-overlay open" onClick={(e) => { if(e.target.className.includes('modal-overlay')) this.toggleModal('addTag', false); }}>
                  <div className="modal-box">
                      <div className="modal-title">즐겨찾는 태그 추가</div>
                      <p style={{ fontSize: '13px', color: '#64748b', marginBottom: '12px' }}># 기호를 쓰지 않아도 자동으로 붙습니다. (Enter를 눌러 저장하세요)</p>
                      <input type="text" className="form-control" placeholder="예: 트렌드" value={this.state.newFixedTagInput} onChange={(e) => this.setState({ newFixedTagInput: e.target.value })} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.addNewFixedTag(); } }} />
                      <div style={{ display: "flex", justifyContent: "right", marginTop: '20px', gap: "8px" }}>
                          <button className="btn btn-outline" onClick={() => this.toggleModal('addTag', false)}>취소</button>
                          <button className="btn btn-primary" onClick={this.addNewFixedTag}>추가</button>
                      </div>
                  </div>
              </div>
          )}
        </div>
          {/* 릴스 영상 제작방식 선택 */}
          {this.state.videoSourceModalOpen && (
            <div
              className="modal-overlay open"
              style={{ zIndex: 9999 }}
              onClick={(e) => {
                if (e.target.className && String(e.target.className).includes("modal-overlay")) {
                  this.closeVideoSourceModal();
                }
              }}
            >
              <div className="modal-box" data-instagram-tutorial="post-reels-source-modal" style={{ 
                maxWidth: 540, 
                // maxWidth: 280, 
                width: "100%", 
                padding: 30 
              }}>
                <button
                  type="button"
                  className="modal-close-button"
                  onClick={this.closeVideoSourceModal}
                  aria-label="닫기"
                >
                  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.0704 15.1788C16.1878 15.2973 16.2536 15.4573 16.2536 15.6241C16.2536 15.7909 16.1878 15.9509 16.0704 16.0694C15.9509 16.1849 15.7913 16.2495 15.6251 16.2495C15.4589 16.2495 15.2992 16.1849 15.1798 16.0694L10.0001 10.8819L4.82041 16.0694C4.70095 16.1849 4.54127 16.2495 4.3751 16.2495C4.20892 16.2495 4.04925 16.1849 3.92979 16.0694C3.81242 15.9509 3.74658 15.7909 3.74658 15.6241C3.74658 15.4573 3.81242 15.2973 3.92979 15.1788L9.11728 9.99912L3.92979 4.81943C3.83012 4.698 3.77919 4.54383 3.78689 4.38693C3.7946 4.23002 3.8604 4.08159 3.97148 3.9705C4.08256 3.85942 4.231 3.79362 4.3879 3.78592C4.54481 3.77821 4.69898 3.82914 4.82041 3.92881L10.0001 9.11631L15.1798 3.92881C15.3012 3.82914 15.4554 3.77821 15.6123 3.78592C15.7692 3.79362 15.9176 3.85942 16.0287 3.9705C16.1398 4.08159 16.2056 4.23002 16.2133 4.38693C16.221 4.54383 16.1701 4.698 16.0704 4.81943L10.8829 9.99912L16.0704 15.1788Z" fill="#333333" /></svg>
                </button>
                <h3 style={{ marginBottom: 20, fontSize: '20px', fontWeight: 800 }}>동영상 제작방식 선택</h3>
                <div style={{ 
                  display: "grid", 
                  // gridTemplateColumns: "repeat(2,1fr)", 
                  gap: 15, margin: "20px 0" 
                }}
                >
                  <div
                    data-instagram-tutorial="post-video-upload-option"
                    onClick={() => this.handleVideoSource("upload")}
                    style={{ padding: 22, border: "1px solid #dbdbdb", borderRadius: 8, cursor: "pointer", textAlign: "center" }}
                  >
                    <div style={{ width: 42, height: 42, margin: "0 auto 10px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2 20.5V4.5C2 3.67157 2.67157 3 3.5 3H8.25L10.5 6H19.5C20.3284 6 21 6.67157 21 7.5V11.25" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                          <path d="M2.25 20.5L5.4 12.9C5.74944 12.0576 6.57153 11.5 7.48352 11.5H21.0986C22.4542 11.5 23.3246 12.9384 22.7044 14.1439L19.3978 20.5714C19.1397 21.0732 18.6227 21.3889 18.0584 21.3889H3.1724C2.5197 21.3889 2.00008 20.8483 2.02591 20.1961C2.03008 20.0908 2.05297 19.9871 2.09342 19.8898L2.25 20.5Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </div>
                    <h4 style={{ fontSize: "1.1em", fontWeight: 600, margin: 0, color: 'var(--deep-navy)' }}>직접 올리기</h4>
                    <p style={{ fontSize: 12, color: "#8e8e8e", margin: "6px 0 0" }}>내 컴퓨터의 동영상 선택</p>
                  </div>
                  <div
                    data-instagram-tutorial="post-ai-video-studio-option"
                    onClick={() => this.handleVideoSource("ai")}
                    style={{ padding: 22, border: "1px solid #dbdbdb", borderRadius: 8, cursor: "pointer", textAlign: "center" }}
                  >
                    <div style={{ width: 42, height: 42, margin: "0 auto 10px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <svg
                        width="35"
                        height="35"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_4740_139)">
                          <mask
                            id="mask0_4740_139"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x="-1"
                            y="-2"
                            width="26"
                            height="24"
                          >
                            <path
                              d="M23.1001 -2H-0.899902V22H23.1001V-2Z"
                              fill="white"
                            />
                            <path
                              d="M24.3936 15H5.39355V22H24.3936V15Z"
                              fill="black"
                            />
                          </mask>

                          <g mask="url(#mask0_4740_139)">
                            <path
                              d="M16.8633 1H15.6652H14.35H13.2511H12.0015H9.6288H8.557H7.0658H5.91941H3.33687C2.74364 1 2.17471 1.23955 1.75524 1.66595C1.33576 2.09235 1.1001 2.67067 1.1001 3.27368V16.7263C1.1001 17.3293 1.33576 17.9077 1.75524 18.3341C2.17471 18.7605 2.74364 19 3.33687 19H16.8633C17.4566 19 18.0255 18.7605 18.445 18.3341C18.8644 17.9077 19.1001 17.3293 19.1001 16.7263V3.27368C19.1001 2.67067 18.8644 2.09235 18.445 1.66595C18.0255 1.23955 17.4566 1 16.8633 1ZM17.6089 16.7263C17.6089 16.9273 17.5304 17.1201 17.3905 17.2622C17.2507 17.4044 17.0611 17.4842 16.8633 17.4842H3.33687C3.13913 17.4842 2.94949 17.4044 2.80966 17.2622C2.66984 17.1201 2.59128 16.9273 2.59128 16.7263V3.27368C2.59128 3.07268 2.66984 2.8799 2.80966 2.73777C2.94949 2.59564 3.13913 2.51579 3.33687 2.51579H6.31924C6.44202 2.51587 7.28321 2.51579 7.37566 2.51579C7.56206 2.51579 8.9076 2.51579 7.81042 2.51579H10.0472H12.3461H14.1266H14.6141H15.2663H16.8633C17.0611 2.51579 17.2507 2.59564 17.3905 2.73777C17.5304 2.8799 17.6089 3.07268 17.6089 3.27368V16.7263Z"
                              fill="#333333"
                            />

                            <path
                              d="M2.6001 5.5C2.6001 5.5 12.047 5.5 18.1001 5.5"
                              stroke="#333333"
                              strokeWidth="1.5"
                            />

                            <path
                              d="M5.1001 2L7.1001 5.4641"
                              stroke="#333333"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                            />

                            <path
                              d="M9.1001 2L11.1001 5.4641"
                              stroke="#333333"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                            />

                            <path
                              d="M13.1001 2L15.1001 5.4641"
                              stroke="#333333"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                            />

                            <path
                              d="M11.6655 10.4173L7.16606 7.61769C7.05318 7.54735 6.92179 7.50696 6.78621 7.50082C6.65052 7.49469 6.51564 7.52305 6.39595 7.58287C6.27627 7.64269 6.17618 7.73174 6.10639 7.84046C6.0367 7.94927 5.99991 8.07358 6 8.2004V13.7997C5.99991 13.9264 6.0367 14.0508 6.10639 14.1595C6.17618 14.2682 6.27627 14.3573 6.39595 14.4172C6.51564 14.477 6.65052 14.5053 6.78621 14.4992C6.92179 14.493 7.05318 14.4526 7.16606 14.3823L11.6655 11.5826C11.7684 11.5188 11.8528 11.4322 11.9111 11.3305C11.9695 11.2289 12 11.1153 12 11C12 10.8847 11.9695 10.7711 11.9111 10.6695C11.8528 10.5679 11.7684 10.4813 11.6655 10.4173ZM7.49983 12.4917V9.51268L9.89765 11L7.49983 12.4917Z"
                              fill="#333333"
                            />
                          </g>

                          <path
                            d="M10.8079 19.0547C11.3229 19.0547 11.7403 18.6346 11.7403 18.1165C11.7403 17.5984 11.3229 17.1783 10.8079 17.1783C10.2929 17.1783 9.87549 17.5984 9.87549 18.1165C9.87549 18.6346 10.2929 19.0547 10.8079 19.0547Z"
                            fill="#333333"
                          />

                          <path
                            d="M16.849 19.0547C17.3639 19.0547 17.7814 18.6346 17.7814 18.1165C17.7814 17.5984 17.3639 17.1783 16.849 17.1783C16.334 17.1783 15.9165 17.5984 15.9165 18.1165C15.9165 18.6346 16.334 19.0547 16.849 19.0547Z"
                            fill="#333333"
                          />

                          <path
                            d="M17.1595 23.12H10.521C8.18593 23.12 6.28125 21.2036 6.28125 18.8542V18.0443C6.28125 15.6949 8.18593 13.7785 10.521 13.7785H17.1595C19.4945 13.7785 21.3991 15.6949 21.3991 18.0443V18.8542C21.3991 21.2036 19.4945 23.12 17.1595 23.12ZM10.521 15.294C9.01474 15.294 7.79543 16.5288 7.79543 18.0363V18.8461C7.79543 20.3617 9.01474 21.5885 10.521 21.5885H17.1595C18.6657 21.5885 19.885 20.3617 19.885 18.8461V18.0363C19.885 16.5208 18.6577 15.294 17.1595 15.294H10.521Z"
                            fill="#333333"
                          />

                          <path
                            d="M14.4023 12.2471H13.2866V14.2036H14.4023V12.2471Z"
                            fill="#333333"
                          />

                          <path
                            d="M13.8444 20.7785C13.2228 20.7785 12.641 20.53 12.5773 20.4979C12.3382 20.3936 12.2266 20.113 12.3302 19.8645C12.4338 19.6239 12.7207 19.5117 12.9598 19.6159C12.9598 19.6159 13.422 19.8164 13.8524 19.8164C14.2827 19.8164 14.7369 19.6239 14.7449 19.6159C14.984 19.5117 15.2709 19.6159 15.3745 19.8645C15.4782 20.105 15.3745 20.3936 15.1275 20.4979C15.0638 20.53 14.474 20.7785 13.8604 20.7785H13.8444Z"
                            fill="#333333"
                          />

                          <path
                            d="M13.8447 12.8404C14.6105 12.8404 15.2314 12.2157 15.2314 11.4452C15.2314 10.6746 14.6105 10.05 13.8447 10.05C13.0788 10.05 12.458 10.6746 12.458 11.4452C12.458 12.2157 13.0788 12.8404 13.8447 12.8404Z"
                            fill="#333333"
                          />

                          <path
                            d="M21.8299 20.8348C21.6306 20.8348 21.4394 20.8188 21.2641 20.8027L20.5229 20.7546V16.0558H21.0807C21.7422 16.0558 23.2803 16.0558 23.2803 17.3708V19.6881C23.2803 20.0971 23.097 20.3456 22.9535 20.482C22.6507 20.7626 22.2363 20.8268 21.8299 20.8268V20.8348ZM21.6386 19.7042C21.8618 19.7202 22.1168 19.7122 22.2045 19.6641L22.1726 17.3788C22.1088 17.2826 21.8857 17.2345 21.6466 17.2104V19.7122L21.6386 19.7042Z"
                            fill="#333333"
                          />

                          <path
                            d="M6.05052 20.8348C5.64408 20.8348 5.22968 20.7706 4.92684 20.49C4.77542 20.3536 4.6001 20.0971 4.6001 19.6962V17.3789C4.6001 16.0638 6.13819 16.0638 6.79964 16.0638H7.3575V20.7546L6.61635 20.8027C6.44102 20.8187 6.24976 20.8348 6.05052 20.8348ZM6.24179 17.2025C6.00271 17.2185 5.77956 17.2586 5.72378 17.3308V19.6962C5.77956 19.7283 6.02661 19.7202 6.24179 19.7042V17.2025Z"
                            fill="#333333"
                          />
                        </g>

                        <defs>
                          <clipPath id="clip0_4740_139">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <h4 style={{ fontSize: "1.1em", margin: 0, color: 'var(--deep-navy)' }}>AI 동영상 스튜디오</h4>
                    <p style={{ fontSize: 12, color: "#8e8e8e", margin: "6px 0 0" }}>AI로 동영상 만들기</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* --- [EXISTING MODALS] 기존 모달 유지 --- */}
          {this.state.imageModalOpen && (
            <div className="modal-overlay open" style={{ zIndex: 9999 }} onClick={(e) => { if (e.target.className.includes("modal-overlay")) this.closeImageModal(); }}>
              <div id="imageSelectModal" className="modal-box" data-instagram-tutorial="post-feed-source-modal" style={{ maxWidth: 540, width: "100%", padding: 30 }}>
                  <button
                    type="button"
                    className="modal-close-button"
                    onClick={this.closeImageModal}
                    aria-label="닫기"
                  >
                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.0704 15.1788C16.1878 15.2973 16.2536 15.4573 16.2536 15.6241C16.2536 15.7909 16.1878 15.9509 16.0704 16.0694C15.9509 16.1849 15.7913 16.2495 15.6251 16.2495C15.4589 16.2495 15.2992 16.1849 15.1798 16.0694L10.0001 10.8819L4.82041 16.0694C4.70095 16.1849 4.54127 16.2495 4.3751 16.2495C4.20892 16.2495 4.04925 16.1849 3.92979 16.0694C3.81242 15.9509 3.74658 15.7909 3.74658 15.6241C3.74658 15.4573 3.81242 15.2973 3.92979 15.1788L9.11728 9.99912L3.92979 4.81943C3.83012 4.698 3.77919 4.54383 3.78689 4.38693C3.7946 4.23002 3.8604 4.08159 3.97148 3.9705C4.08256 3.85942 4.231 3.79362 4.3879 3.78592C4.54481 3.77821 4.69898 3.82914 4.82041 3.92881L10.0001 9.11631L15.1798 3.92881C15.3012 3.82914 15.4554 3.77821 15.6123 3.78592C15.7692 3.79362 15.9176 3.85942 16.0287 3.9705C16.1398 4.08159 16.2056 4.23002 16.2133 4.38693C16.221 4.54383 16.1701 4.698 16.0704 4.81943L10.8829 9.99912L16.0704 15.1788Z" fill="#333333"></path></svg>
                  </button>
                  <h3 style={{ marginBottom: 20, fontSize: '20px', fontWeight: 800 }}>이미지 제작방식 선택</h3>
                  <div className="image-source-options" style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 15, margin: "20px 0" }}>
                    {[
                      { key: "upload", label: "직접 올리기", sub: "내 컴퓨터에서 선택", icon: `
                          <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M2 20.5V4.5C2 3.67157 2.67157 3 3.5 3H8.25L10.5 6H19.5C20.3284 6 21 6.67157 21 7.5V11.25"
                                stroke="#333333"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />

                            <path
                                d="M2.25 20.5L5.4 12.9C5.74944 12.0576 6.57153 11.5 7.48352 11.5H21.0986C22.4542 11.5 23.3246 12.9384 22.7044 14.1439L19.3978 20.5714C19.1397 21.0732 18.6227 21.3889 18.0584 21.3889H3.1724C2.5197 21.3889 2.00008 20.8483 2.02591 20.1961C2.03008 20.0908 2.05297 19.9871 2.09342 19.8898L2.25 20.5Z"
                                stroke="#333333"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        ` },
                      { key: "product", label: "상품 사용", sub: "쇼핑몰 상품 선택", icon: `
                          <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M20.25 6H16.5C16.5 4.80653 16.0259 3.66193 15.182 2.81802C14.3381 1.97411 13.1935 1.5 12 1.5C10.8065 1.5 9.66193 1.97411 8.81802 2.81802C7.97411 3.66193 7.5 4.80653 7.5 6H3.75C3.35218 6 2.97064 6.15804 2.68934 6.43934C2.40804 6.72064 2.25 7.10218 2.25 7.5V18.75C2.25 19.1478 2.40804 19.5294 2.68934 19.8107C2.97064 20.092 3.35218 20.25 3.75 20.25H20.25C20.6478 20.25 21.0294 20.092 21.3107 19.8107C21.592 19.5294 21.75 19.1478 21.75 18.75V7.5C21.75 7.10218 21.592 6.72064 21.3107 6.43934C21.0294 6.15804 20.6478 6 20.25 6ZM12 3C12.7956 3 13.5587 3.31607 14.1213 3.87868C14.6839 4.44129 15 5.20435 15 6H9C9 5.20435 9.31607 4.44129 9.87868 3.87868C10.4413 3.31607 11.2044 3 12 3ZM20.25 18.75H3.75V7.5H7.5V9C7.5 9.19891 7.57902 9.38968 7.71967 9.53033C7.86032 9.67098 8.05109 9.75 8.25 9.75C8.44891 9.75 8.63968 9.67098 8.78033 9.53033C8.92098 9.38968 9 9.19891 9 9V7.5H15V9C15 9.19891 15.079 9.38968 15.2197 9.53033C15.3603 9.67098 15.5511 9.75 15.75 9.75C15.9489 9.75 16.1397 9.67098 16.2803 9.53033C16.421 9.38968 16.5 9.19891 16.5 9V7.5H20.25V18.75Z" fill="#333333"/>
                          </svg>
                        ` },
                      { key: "ai", label: "AI 스튜디오", sub: "AI로 이미지 만들기", icon: `
                          <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_2803_100)">
                            <path d="M10.5254 18.9337C11.0404 18.9337 11.458 18.5135 11.458 17.9953C11.458 17.477 11.0404 17.0569 10.5254 17.0569C10.0103 17.0569 9.59277 17.477 9.59277 17.9953C9.59277 18.5135 10.0103 18.9337 10.5254 18.9337Z" fill="#333333"/>
                            <path d="M16.5674 18.9337C17.0824 18.9337 17.5 18.5135 17.5 17.9953C17.5 17.477 17.0824 17.0569 16.5674 17.0569C16.0523 17.0569 15.6348 17.477 15.6348 17.9953C15.6348 18.5135 16.0523 18.9337 16.5674 18.9337Z" fill="#333333"/>
                            <path d="M16.8785 23H10.2386C7.90312 23 5.99805 21.0831 5.99805 18.7331V17.9231C5.99805 15.5731 7.90312 13.6562 10.2386 13.6562H16.8785C19.214 13.6562 21.1191 15.5731 21.1191 17.9231V18.7331C21.1191 21.0831 19.214 23 16.8785 23ZM10.2386 15.172C8.73211 15.172 7.51254 16.4072 7.51254 17.915V18.7251C7.51254 20.241 8.73211 21.4681 10.2386 21.4681H16.8785C18.385 21.4681 19.6046 20.241 19.6046 18.7251V17.915C19.6046 16.3992 18.377 15.172 16.8785 15.172H10.2386Z" fill="#333333"/>
                            <path d="M14.1203 12.1243H13.0044V14.0813H14.1203V12.1243Z" fill="#333333"/>
                            <path d="M13.5625 20.658C12.9408 20.658 12.3589 20.4094 12.2951 20.3773C12.056 20.273 11.9444 19.9923 12.048 19.7437C12.1516 19.5031 12.4386 19.3908 12.6777 19.4951C12.6777 19.4951 13.14 19.6956 13.5705 19.6956C14.0009 19.6956 14.4553 19.5031 14.4632 19.4951C14.7024 19.3908 14.9893 19.4951 15.0929 19.7437C15.1966 19.9843 15.0929 20.273 14.8458 20.3773C14.7821 20.4094 14.1922 20.658 13.5785 20.658H13.5625Z" fill="#333333"/>
                            <path d="M13.5622 12.7178C14.3282 12.7178 14.9492 12.093 14.9492 11.3222C14.9492 10.5515 14.3282 9.9267 13.5622 9.9267C12.7963 9.9267 12.1753 10.5515 12.1753 11.3222C12.1753 12.093 12.7963 12.7178 13.5622 12.7178Z" fill="#333333"/>
                            <path d="M21.5494 20.7142C21.3502 20.7142 21.1589 20.6981 20.9835 20.6821L20.2422 20.634V15.934H20.8002C21.4618 15.934 23.0002 15.934 23.0002 17.2494V19.5673C23.0002 19.9763 22.8168 20.2249 22.6733 20.3613C22.3704 20.642 21.956 20.7062 21.5494 20.7062V20.7142ZM21.3581 19.5833C21.5813 19.5994 21.8364 19.5913 21.9241 19.5432L21.8922 17.2574C21.8284 17.1611 21.6052 17.113 21.3661 17.089V19.5913L21.3581 19.5833Z" fill="#333333"/>
                            <path d="M5.76664 20.7142C5.36012 20.7142 4.94563 20.65 4.64273 20.3693C4.49128 20.2329 4.31592 19.9763 4.31592 19.5753V17.2574C4.31592 15.942 5.85432 15.942 6.51592 15.942H7.07389V20.634L6.33258 20.6821C6.15722 20.6981 5.96592 20.7142 5.76664 20.7142ZM5.95795 17.0809C5.71882 17.097 5.49563 17.1371 5.43983 17.2092V19.5753C5.49563 19.6073 5.74273 19.5993 5.95795 19.5833V17.0809Z" fill="#333333"/>
                            <path d="M6.76285 5.87641C6.97806 6.09297 7.27299 6.21327 7.57589 6.21327C7.87879 6.21327 8.16575 6.09297 8.38096 5.87641C8.59618 5.65986 8.71575 5.37113 8.71575 5.06635C8.71575 4.76158 8.59618 4.47284 8.38096 4.25629C8.16575 4.03974 7.87879 3.91943 7.57589 3.91943C7.27299 3.91943 6.98603 4.03974 6.77082 4.25629C6.5556 4.47284 6.43604 4.76158 6.43604 5.06635C6.43604 5.21874 6.46792 5.37113 6.52372 5.50748C6.57951 5.64382 6.66719 5.77215 6.77082 5.88444L6.76285 5.87641Z" fill="#333333"/>
                            <path d="M2.52246 17.8589V11.4987L5.56739 8.43493L7.53623 10.416C7.82319 10.6967 8.2058 10.8571 8.61232 10.8571C9.01884 10.8571 9.40145 10.6967 9.68841 10.416L13.9449 6.13307L17.7551 9.96682V12.8542C17.7551 13.6081 19.2775 13.6482 19.2775 12.8782V2.5319C19.2775 2.12286 19.1181 1.73788 18.8312 1.44914C18.5442 1.16041 18.1616 1 17.7551 1H2.52246C2.11594 1 1.73333 1.16041 1.44638 1.44914C1.15942 1.73788 1 2.12286 1 2.5319V17.8589C1 18.268 1.15942 18.6529 1.44638 18.9417C1.73333 19.2304 2.11594 19.3908 2.52246 19.3908H2.92101C3.86159 19.3908 3.82971 17.8669 2.96884 17.8669C2.79348 17.8669 2.52246 17.8669 2.52246 17.8669V17.8589ZM2.52246 2.5319H17.7551V7.80131L15.021 5.05031C14.7341 4.7696 14.3514 4.60919 13.9449 4.60919C13.5384 4.60919 13.1558 4.7696 12.8688 5.05031L8.61232 9.33321L6.64348 7.35217C6.35652 7.07145 5.97391 6.91105 5.56739 6.91105C5.16087 6.91105 4.77826 7.07145 4.4913 7.35217L2.52246 9.33321V2.5319Z" fill="#333333"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_2803_100">
                            <rect width="22" height="22" fill="white" transform="translate(1 1)"/>
                            </clipPath>
                            </defs>
                        </svg>
                        ` },
                      { key: "template", label: "AI 디자인", sub: "디자인 템플릿 적용", icon: `
                          <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10" cy="13.5" r="1" fill="#333333"/>
                            <circle cx="15" cy="13.5" r="1" fill="#333333"/>
                            <rect x="4.75" y="7.35156" width="14.5" height="13.5" rx="2.75" stroke="#333333" stroke-width="1.5"/>
                            <path d="M18.5 11H19.1C20.1493 11 21 11.8507 21 12.9V15.1C21 16.1493 20.1493 17 19.1 17H18.5" stroke="#333333"/>
                            <path d="M5.5 17L4.9 17C3.85066 17 3 16.1493 3 15.1L3 12.9C3 11.8507 3.85066 11 4.9 11L5.5 11" stroke="#333333"/>
                            <path d="M11 16C12 16.5 12.5 16.5 13.5 16" stroke="#333333" stroke-linecap="round"/>
                            <rect x="9.09961" y="2.5" width="6" height="2" rx="1" stroke="#333333"/>
                            <rect x="6.5" y="9.5" width="11" height="9" rx="2" stroke="#333333"/>
                            <path d="M12 5V7" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                          </svg>
                        ` },
                    ].map((opt) => (
                      <div
                        key={opt.key}
                        data-instagram-tutorial={{
                          upload: "post-image-upload-option",
                          product: "post-product-image-option",
                          ai: "post-ai-studio-option",
                          template: "post-ai-design-option",
                        }[opt.key]}
                        onClick={() => this.handleImageSource(opt.key)}
                        style={{ padding: 20, border: "1px solid #dbdbdb", borderRadius: 8, cursor: "pointer", textAlign: "center" }}
                      >
                        <div style={{ fontSize: 32, marginBottom: 10 }} dangerouslySetInnerHTML={{ __html: opt.icon }}></div>
                        <h4 style={{ margin: 0, color: 'var(--deep-navy)' }}>{opt.label}</h4>
                        <p style={{ fontSize: 12, color: "#8e8e8e", margin: 0, marginTop: '6px' }}>{opt.sub}</p>
                      </div>
                    ))}
                  </div>
              </div>
            </div>
          )}
          
          {/* {this.state.imageModalOpen && (
            <div className="modal-overlay open" style={{ zIndex: 9999 }} onClick={(e) => { if (e.target.className.includes("modal-overlay")) this.closeImageModal(); }}>
              <div id="imageSelectModal" className="modal-box" style={{ maxWidth: 540, width: "100%", padding: 30 }}>
                  <h3 style={{ marginBottom: 20, fontSize: '20px', fontWeight: 800 }}>이미지 제작방식 선택</h3>
                  <div className="image-source-options" style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 15, margin: "20px 0" }}>
                    {[
                      // icon 값에 FontAwesome 클래스명 할당
                      { key: "upload", label: "직접 올리기", sub: "내 컴퓨터에서 선택", icon: "fas fa-cloud-upload-alt" },
                      { key: "product", label: "상품 사용", sub: "쇼핑몰 상품 선택", icon: "fas fa-shopping-bag" },
                      { key: "ai", label: "AI 생성", sub: "AI로 이미지 만들기", icon: "fas fa-robot" },
                      { key: "template", label: "템플릿 사용", sub: "디자인 템플릿 적용", icon: "fas fa-palette" },
                    ].map((opt) => (
                      <div key={opt.key} onClick={() => this.handleImageSource(opt.key)} style={{ padding: 20, border: "1px solid #dbdbdb", borderRadius: 8, cursor: "pointer", textAlign: "center" }}>
                        <div style={{ fontSize: 32, marginBottom: 10, color: 'var(--primary-mint)' }}>
                            <i className={opt.icon}></i>
                        </div>
                        <h4 style={{ margin: 0, color: 'var(--deep-navy)' }}>{opt.label}</h4>
                        <p style={{ fontSize: 12, color: "#8e8e8e", margin: 0, marginTop: '6px' }}>{opt.sub}</p>
                      </div>
                    ))}
                  </div>
              </div>
            </div>
          )} */}


          {/* 연결한 Threads 계정을 선택하는 팝업 */}
          {this.state.show_threads_account_connect_popup && (
            <PopupFrameV2
              className={"account-connect-popup"}
              maxWidth={"950px"}
              onClose={() => this.setState({
                show_threads_account_connect_popup: false,
                add_threads_account_list: [],
                selected_threads_account_list: [],
              })}
            >
              <div className="instagram_account_page">
                <h5 style={{ marginBottom: 20 }}>연결할 Threads 계정을 선택해주세요</h5>
                <div className="instagram-accounts">
                  {(this.state.add_threads_account_list || []).map((threads) => {
                    const seq = String(threads.threads_access_token_seq || "");
                    const selected = (this.state.selected_threads_account_list || []).map(String).includes(seq);
                    const username = threads.username || threads.threads_user_id || "Threads 계정";

                    return (
                      <div
                        className="account-card"
                        key={seq}
                        onClick={(e) => {
                          if (e.target.closest('input[type="checkbox"], label')) return;
                          this.toggleThreadsConnectSelection(seq);
                        }}
                        style={{
                          display: "flex",
                          gap: "18px",
                          cursor: "pointer",
                          userSelect: "none",
                          WebkitUserSelect: "none",
                          msUserSelect: "none",
                          marginBottom: "12px",
                        }}
                      >
                        <CheckBox
                          id={`threads-connect-${seq}`}
                          value={seq}
                          checked={selected}
                          onChangeCheck={() => this.toggleThreadsConnectSelection(seq)}
                        />

                        <div className="account-wrapper" style={{ display: "flex", alignItems: "center" }}>
                          <div className="account-left" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <div
                              className="account-avatar"
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "50%",
                                overflow: "hidden",
                                background: "#111827",
                                color: "#fff",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: 800,
                              }}
                            >
                              {threads.profile_picture_url ? (
                                <img
                                  src={threads.profile_picture_url}
                                  alt=""
                                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                              ) : (
                                <span>T</span>
                              )}
                            </div>
                            <div className="account-info">
                              <div className="account-username" style={{ fontWeight: "600", color: "var(--deep-navy)" }}>
                                {username.startsWith("@") ? username : `@${username}`}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "flex-end",
                    marginTop: "20px",
                    padding: "0 0 max(12px, env(safe-area-inset-bottom))",
                  }}
                  onPointerDown={(e) => e.stopPropagation()}
                  onTouchStart={(e) => e.stopPropagation()}
                >
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ minHeight: "44px", touchAction: "manipulation" }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.updateSelectedThreadsAccountsUseYn();
                    }}
                  >
                    연결하기
                  </button>
                </div>
              </div>
            </PopupFrameV2>
          )}

          {/* 연결한 계정을 선택하는 팝업 */}
          {this.state.show_account_connect_popup && (
            <PopupFrameV2
              className={"account-connect-popup"}
              maxWidth={"950px"}
              onClose={() => this.setState({ show_account_connect_popup: false })}
            >
              <div className="instagram_account_page">
                {(this.state.add_account_list || []).length === 0 ? (

                  <>
                    <div
                      className="instagram-no-accounts instagram-connect-guide-modal"
                      style={{
                        padding: "28px 36px 32px",
                        textAlign: "center",
                        color: "var(--deep-navy)",
                        lineHeight: "1.6",
                        wordBreak: "keep-all",
                      }}
                    >
                      <div
                        style={{
                          width: "70px",
                          height: "70px",
                          margin: "0 auto 18px",
                          borderRadius: "50%",
                          background: "rgba(0, 226, 230, 0.18)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "52px",
                            height: "52px",
                            borderRadius: "50%",
                            background: "var(--primary-mint)",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "32px",
                            fontWeight: 900,
                            boxShadow: "0 8px 18px rgba(0, 226, 230, 0.35)",
                          }}
                        >
                          !
                        </div>
                      </div>

                      <div
                        style={{
                          color: "var(--primary-mint-hover)",
                          fontSize: "17px",
                          fontWeight: 900,
                          marginBottom: "12px",
                        }}
                      >
                        인스타그램 필수가이드 확인
                      </div>

                      <div
                        style={{
                          color: "var(--deep-navy)",
                          fontSize: "26px",
                          fontWeight: 900,
                          lineHeight: "1.35",
                          letterSpacing: "-0.8px",
                        }}
                      >
                        인스타그램 규정상 <br/>
                        아래 필수 3가지 조건을 가이드를 따라 변경 후 <br/>
                        다시 계정 추가를 진행해주세요
                      </div>

                      <div
                        style={{
                          height: "1px",
                          background: "#d1d5db",
                          margin: "28px 0 22px",
                        }}
                      />

                      <div
                        style={{
                          textAlign: "left",
                          color: "var(--deep-navy)",
                          fontSize: "15px",
                          fontWeight: 700,
                          marginBottom: "16px",
                        }}
                      >
                        인스타그램 자동관리를 사용하려면 아래 3가지가 모두 필요합니다.
                      </div>

                      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        {[
                          "인스타그램 프로페셔널 계정 전환 (개인 계정 연동 불가)",
                          "페이스북 비즈니스 페이지 개설",
                          "인스타그램 계정과 페이스북 페이지 상호 연결",
                        ].map((item, index) => (
                          <div
                            key={item}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "14px",
                              minHeight: "54px",
                              padding: "0 16px",
                              border: "1px solid #dfe5ec",
                              borderRadius: "8px",
                              background: "#fff",
                              color: "var(--deep-navy)",
                              fontSize: "15px",
                              fontWeight: 700,
                            }}
                          >
                            <span
                              style={{
                                width: "22px",
                                height: "22px",
                                borderRadius: "50%",
                                border: "2px solid var(--primary-mint-hover)",
                                color: "var(--primary-mint-hover)",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "13px",
                                fontWeight: 900,
                                flexShrink: 0,
                              }}
                            >
                              ✓
                            </span>
                            <span>{index + 1}. {item}</span>
                          </div>
                        ))}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "12px",
                          alignItems: "flex-start",
                          marginTop: "22px",
                          padding: "16px 18px",
                          border: "1px solid #9ee7f0",
                          borderRadius: "8px",
                          background: "linear-gradient(180deg, #f0fdff 0%, #eafaff 100%)",
                          color: "var(--deep-navy)",
                          textAlign: "left",
                          fontSize: "14px",
                          fontWeight: 700,
                          lineHeight: "1.6",
                        }}
                      >
                        <span
                          style={{
                            width: "21px",
                            height: "21px",
                            borderRadius: "50%",
                            background: "#35a9c9",
                            color: "#fff",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "14px",
                            fontWeight: 900,
                            flexShrink: 0,
                            marginTop: "1px",
                          }}
                        >
                          i
                        </span>
                        <span>
                          위 3가지 중 하나라도 설정되지 않으면 계정 연동이 되지 않습니다.
                          <br />
                          설정 방법은 사용가이드에서 확인해주세요.
                        </span>
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "26px",
                          marginTop: "28px",
                        }}
                      >
                        <button
                          className="btn btn-primary"
                          style={{
                            height: "52px",
                            borderRadius: "10px",
                            fontSize: "15px",
                            fontWeight: 900,
                          }}
                          onClick={() => {
                            window.open(
                              "https://iclave.notion.site/Instagram-Facebook-2d363ab4c3ce800b9d58c0d0aaa0d9ce?source=copy_link",
                              "_blank"
                            );
                          }}
                        >
                          <span style={{ fontSize: "18px", lineHeight: 1 }}>↗</span>
                          가이드 바로 보기
                        </button>

                        <button
                          className="btn"
                          style={{
                            height: "52px",
                            borderRadius: "10px",
                            background: "#f1f5f9",
                            color: "#111827",
                            fontSize: "15px",
                            fontWeight: 900,
                            boxShadow: "none",
                          }}
                          onClick={() => this.setState({ show_account_connect_popup: false })}
                        >
                          닫기
                        </button>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <h5 style={{ marginBottom: 20 }}>
                      연결할 인스타그램 계정을 선택해주세요
                    </h5>

                    {(this.state.add_account_list || []).map((account) => (
                      <div className="instagram-accounts" key={account.token_id}>
                        {(Array.isArray(account.instagram_account_list)
                          ? account.instagram_account_list
                          : []
                        )
                          .filter((instagram) => instagram && instagram.instagram_access_token_seq)
                          .map((instagram) => {
                            const instagramAccessTokenSeq = String(
                              instagram.instagram_access_token_seq
                            );

                            return (
                              <div
                                className="account-card"
                                key={instagram.instagram_access_token_seq}
                                onClick={(e) => {
                                  // 체크박스나 라벨 자체를 클릭했을 때는 중복 실행 방지
                                  if (e.target.closest('input[type="checkbox"], label')) return;

                                  let selected_account_list = [
                                    ...this.state.selected_account_list,
                                  ];

                                  if (selected_account_list.includes(instagramAccessTokenSeq)) {
                                    selected_account_list = selected_account_list.filter(
                                      seq => seq !== instagramAccessTokenSeq
                                    );
                                  } else {
                                    selected_account_list.push(instagramAccessTokenSeq);
                                  }

                                  this.setState({ selected_account_list });
                                }}
                                style={{
                                  display: "flex",
                                  gap: "18px",
                                  cursor: "pointer",
                                  userSelect: "none",
                                  WebkitUserSelect: "none",
                                  msUserSelect: "none",
                                  marginBottom: "12px",
                                }}
                              >
                                <CheckBox
                                  id={instagramAccessTokenSeq}
                                  value={instagramAccessTokenSeq}
                                  checked={this.state.selected_account_list.includes(
                                    instagramAccessTokenSeq
                                  )}
                                  onChangeCheck={() => {
                                    let selected_account_list = [
                                      ...this.state.selected_account_list,
                                    ];

                                    if (selected_account_list.includes(instagramAccessTokenSeq)) {
                                      selected_account_list = selected_account_list.filter(
                                        seq => seq !== instagramAccessTokenSeq
                                      );
                                    } else {
                                      selected_account_list.push(instagramAccessTokenSeq);
                                    }

                                    this.setState({ selected_account_list });
                                  }}
                                />

                                <div
                                  className="account-wrapper"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    className="account-left"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    <div
                                      className="account-avatar"
                                      style={{
                                        width: "32px",
                                        height: "32px",
                                        borderRadius: "50%",
                                        overflow: "hidden",
                                        background: "#eee",
                                      }}
                                    >
                                      {!!instagram.profile_picture_url && (
                                        <img
                                          src={instagram.profile_picture_url}
                                          alt=""
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                          }}
                                        />
                                      )}
                                    </div>

                                    <div className="account-info">
                                      <div
                                        className="account-username"
                                        style={{
                                          fontWeight: "600",
                                          color: "var(--deep-navy)",
                                        }}
                                      >
                                        {instagram.username || "(username 없음)"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    ))}

                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "flex-end",
                      marginTop: "20px",
                      padding: "0 0 max(12px, env(safe-area-inset-bottom))",
                    }}
                    onPointerDown={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                  >
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{ minHeight: "44px", touchAction: "manipulation" }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.updateSelectedAccountsUseYn();
                      }}
                    >
                      연결하기
                    </button>
                  </div>
                  </>
                )}
              </div>
            </PopupFrameV2>
          )}
          {this.renderThreadsMobileOAuthGuide()}
          {this.state.confirm_dialog_show_state && <ConfirmDialogV2 content={this.state.confirm_dialog_content} button_list={this.state.confirm_dialog_button_list} popup_close={()=>{this.setState({confirm_dialog_show_state: false})}} />}
          {this.state.save_dialog_show_state && <SaveDialogV2 content={this.state.save_dialog_content} button_list={this.state.save_dialog_button_list} />}
          {this.state.basic_dialog_show_state && <BasicDialogV2 content={this.state.basic_dialog_content} button_list={this.state.basic_dialog_button_list} />}
          {this.state.warning_dialog_show_state && <WarningDialog content={this.state.warning_dialog_content} button_list={this.state.warning_dialog_button_list} />}
          {this.state.title_content_dialog_show_state &&
              <TitleContentDialogV2
                  title={this.state.title_content_dialog_title}
                  content={this.state.title_content_dialog_content}
                  button_list={this.state.title_content_dialog_button_list}
                  popup_close={()=>{this.setState({title_content_dialog_show_state: false})}}
              />
          }
          {/* {this.state.show_robo_img_popup && <RoboImageStudioTabs onClose={e => {this.setState({show_robo_img_popup:false})}} sendRoboImg={(img, seq) => {
              this.setState({
                save_dialog_show_state: true,
                save_dialog_content: "이미지를 적용 중입니다."
              });
              
              const config = { headers: { 'Content-Type': 'application/json' } };
              const body = { image_url: img, ratio: this.state.currentRatio ? this.state.currentRatio : "1/1" };
              http.post("/rest/shop/instagram/resizeUrlImg", body, config).then(res => {
                  this.applyAIImg(res.data.org_img_path, seq);
                  this.setState({show_robo_img_popup:false, save_dialog_show_state: false});
              });
          }} defaultTab="GENERATE" ratio={this.state.currentRatio || "1/1"} 
             service_type="01014"
          />} */}
          {this.state.show_robo_img_popup && (
              <AiImageStudioWorkflowClass
                view_mode="popup"
                ai_response_type="IMAGE"
                initial_prompt={this.state.ai_studio_initial_prompt || ""}
                initial_image_url={this.state.ai_studio_initial_image_url || ""}
                initial_history_seq={this.state.ai_studio_initial_history_seq || ""}
                initial_history_step_seq={this.state.ai_studio_initial_history_step_seq || ""}
                initial_result_seq={this.state.ai_studio_initial_result_seq || ""}
                initial_result_no={this.state.ai_studio_initial_result_no || ""}
                initial_result_image_url={this.state.ai_studio_initial_result_image_url || ""}
                onClose={() => {
                    this.setState({
                      show_robo_img_popup: false,
                      ai_studio_initial_prompt: "",
                      ai_studio_initial_image_url: "",
                      ai_studio_initial_history_seq: "",
                      ai_studio_initial_history_step_seq: "",
                      ai_studio_initial_result_seq: "",
                      ai_studio_initial_result_no: "",
                      ai_studio_initial_result_image_url: "",
                    });
                }}
                onApplyRule={(result) => {
                    const img = result.appliedImage || result.appliedValue || "";

                    if (!img) {
                        window.alert("적용할 이미지가 없습니다.");
                        return;
                    }

                    this.setState({
                        save_dialog_show_state: true,
                        save_dialog_content: "이미지를 적용 중입니다."
                    });

                    const config = {
                        headers: { 'Content-Type': 'application/json' }
                    };

                    const body = {
                        image_url: img,
                        ratio: this.state.currentRatio ? this.state.currentRatio : "1/1"
                    };

                    http.post("/rest/shop/instagram/resizeUrlImg", body, config)
                        .then((res) => {
                            this.applyAIImg(res.data.org_img_path, result);
                            this.setState({
                                show_robo_img_popup: false,
                                ai_studio_initial_prompt: "",
                                ai_studio_initial_image_url: "",
                                ai_studio_initial_history_seq: "",
                                ai_studio_initial_history_step_seq: "",
                                ai_studio_initial_result_seq: "",
                                ai_studio_initial_result_no: "",
                                ai_studio_initial_result_image_url: "",
                                save_dialog_show_state: false
                            });
                        })
                        .catch((e) => {
                            console.error(e);
                            this.setState({
                                save_dialog_show_state: false
                            });
                            window.alert("이미지를 적용할 수 없어요.");
                        });
                }}
                ratio={this.state.currentRatio || "1/1"}
                service_type="01014"
            />
          )}
          {this.state.show_ai_video_popup && (
            <AiVideoStudioWorkflowClass
              view_mode="popup"
              ai_response_type="VIDEO"
              opened_from="INSTAGRAM_CREATE_POST"
              initial_prompt={this.state.ai_video_studio_initial_prompt || ""}
              initial_image_url={this.state.ai_video_studio_initial_image_url || ""}
              initial_history_seq={this.state.ai_video_studio_initial_history_seq || ""}
              initial_result_seq={this.state.ai_video_studio_initial_result_seq || ""}
              initial_result_no={this.state.ai_video_studio_initial_result_no || ""}
              aspect_ratio={(this.state.currentRatio || "9/16").replace("/", ":")}
              onClose={() => {
                this.setState({
                  show_ai_video_popup: false,
                  ai_video_studio_initial_prompt: "",
                  ai_video_studio_initial_image_url: "",
                  ai_video_studio_initial_history_seq: "",
                  ai_video_studio_initial_result_seq: "",
                  ai_video_studio_initial_result_no: "",
                });
              }}
              onApplyRule={(result) => {
                const videoUrl = result.appliedVideo || result.appliedValue || "";
                if (!videoUrl || typeof videoUrl !== "string") {
                  this.setState({
                    warning_dialog_show_state: true,
                    warning_dialog_content: "적용할 동영상이 없습니다."
                  });
                  return;
                }

                const ratio = String(result.aspect_ratio || result.ratio || "9:16").replace(":", "/");
                this.setState({
                  imageSlots: [{
                    type: "video",
                    data: videoUrl,
                    source_url: videoUrl,
                    ai_video_studio_history_seq: result.ai_video_studio_history_seq || "",
                    ai_video_studio_result_seq: result.ai_video_studio_result_seq || "",
                    result_no: result.result_no || "",
                  }],
                  selectedFeedType: "REELS",
                  currentRatio: ratio || "9/16",
                  previewSlideIndex: 0,
                  show_ai_video_popup: false,
                  ai_video_studio_initial_prompt: "",
                  ai_video_studio_initial_image_url: "",
                  ai_video_studio_initial_history_seq: "",
                  ai_video_studio_initial_result_seq: "",
                  ai_video_studio_initial_result_no: "",
                });
              }}
            />
          )}
                    {this.state.show_add_product_popup && <SearchProductPopup title={"상품 추가"} select_type={"radio"} selected_product_list={this.state.selected_rp_product_list || []} onClose={() => {this.setState({show_add_product_popup:false})}} onSubmit={this.onClickAddProductbtn.bind(this)} submit_btn_name={"선택 상품 추가"} />}
          {this.state.show_design_template_popup && (
            <InstagramTemplateEditor
              onClose={() => {
                this.setState({
                  show_design_template_popup: false,
                  selected_template_event_type_cd: "",
                  selected_template_upper_code_cd: "",
                });
              }}
              onSubmit={this.applydDesign.bind(this)}
              event_seq={this.state.selected_event_seq}
              event_type_cd={this.state.selected_template_event_type_cd}
              upper_code_cd={this.state.selected_template_upper_code_cd}
              ratio={this.state.currentRatio ? this.state.currentRatio.replace("/", ":") : "1:1"}
            />
          )}
          {this.state.isSizeModalOpen && (
            <div data-instagram-tutorial="post-feed-size-modal">
              <ModalSizeSelect
                isOpen={this.state.isSizeModalOpen}
                onClose={() => {
                  this.setState({ isSizeModalOpen: false });
                }}
                onSelect={(ratio) => {
                  this.setState({
                    isSizeModalOpen: false,
                    currentRatio: ratio,
                    imageModalOpen: true
                  });
                }}
              />
            </div>
          )}
    
          <RoboMDAICopywriterModal
            isOpen={modals.copywriterRun}
            onClose={this.closeAiCopywriterRunModal}
            presetMode="DEFAULT"
            initialPresetSeq={this.state.copywriter_preset_seq || null}
            getGenerationContext={this.getAiCopywriterGenerationContext}
            onOpenCaptionSettings={() => this.toggleModal('captionSettings', true)}
            onApply={this.handleAiCopywriterResultApply}
          />

          {modals.captionSettings && (
              <div
                className="modal-overlay open"
                style={{ zIndex: 13010 }}
                onClick={(e) => {
                  if (e.target.className.includes('modal-overlay')) {
                    this.toggleModal('captionSettings', false);
                  }
                }}
              >
                  <div className="modal-box" style={{ width: '420px', textAlign: 'center' }}>
                      <div className="modal-title">설정 변경 안내</div>
                      <p style={{ color: '#64748b', lineHeight: 1.6, marginBottom: '24px' }}>
                          문구 자동 생성 여부와 한 번에 생성할 개수는<br/>
                          <b>[Ai 자동 환경설정]</b> 메뉴에서 언제든 변경할 수 있습니다.<br/><br/>
                          지금 설정 화면으로 이동하시겠습니까?
                      </p>
                      <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                          <button className="btn btn-outline" style={{ flex: 1 }} onClick={() => this.toggleModal('captionSettings', false)}>취소</button>
                          <button className="btn btn-primary" style={{ flex: 1 }} onClick={() => this.goToSettings('captionSettings')}>설정으로 이동</button>
                      </div>
                  </div>
              </div>
          )}

          {modals.hashtagSettings && (
              <div className="modal-overlay open"
                style={{ zIndex: 13010 }}
                onClick={(e) => { if(e.target.className.includes('modal-overlay')) this.toggleModal('hashtagSettings', false); }}>
                  <div className="modal-box" style={{ width: '420px', textAlign: 'center' }}>
                      <div className="modal-title">설정 변경 안내</div>
                      <p style={{ color: '#64748b', lineHeight: 1.6, marginBottom: '24px' }}>
                          해시태그 자동 생성 여부와 추천 개수는<br/>
                          <b>[Ai 자동 환경설정]</b> 메뉴에서 언제든 변경할 수 있습니다.<br/><br/>
                          지금 설정 화면으로 이동하시겠습니까?
                      </p>
                      <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                          <button className="btn btn-outline" style={{ flex: 1 }} onClick={() => this.toggleModal('hashtagSettings', false)}>취소</button>
                          <button className="btn btn-primary" style={{ flex: 1 }} onClick={() => this.goToSettings('hashtagSettings')}>설정으로 이동</button>
                      </div>
                  </div>
              </div>
          )}

          <input type="file" ref={this.fileInputRef} accept="image/*,video/*" style={{ display: "none" }} />
      </div>
      </>
    );
  }
}